import * as Types from '../../../model/Sitecore.graphql.d';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type PressReleaseDataQuery_item_Accordion_template_ItemTemplate_baseTemplates_ItemTemplate = (
  { __typename?: 'ItemTemplate' }
  & Pick<Types.ItemTemplate, 'id' | 'name'>
);

export type PressReleaseDataQuery_item_Accordion_template_ItemTemplate = (
  { __typename?: 'ItemTemplate' }
  & Pick<Types.ItemTemplate, 'id' | 'name'>
  & { baseTemplates: Types.Maybe<Array<Types.Maybe<PressReleaseDataQuery_item_Accordion_template_ItemTemplate_baseTemplates_ItemTemplate>>> }
);

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseTitle_TextField = (
  { __typename?: 'TextField' }
  & Pick<Types.TextField, 'value'>
);

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseDescription_TextField = (
  { __typename?: 'TextField' }
  & Pick<Types.TextField, 'value'>
);

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_PressReleasePlatform_name_TextField = (
  { __typename?: 'TextField' }
  & Pick<Types.TextField, 'value'>
);

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_DYs1ksGYYCrvxaXhjPM6OUwdCvGvprMvFTBqgM5oM = { __typename?: 'Accordion' | 'AccordionFolder' | 'AccordionFolder_03f88fb497884025b46f2cb249f4fcd6' | 'AccordionItem' | 'AccordionItem_8cf671721b2d489e809f4c23db5ab2da' | 'AccordionParametersTemplate' | 'AccordionPresentation' | 'AccordionPresentationFolder' | 'Accordion_02d060598cc14423a9ac9ff2365176b7' | 'Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1' | 'AddItem' | 'AddItem_1e1b739ec3784909941d171aca7362e5' | 'AddItem_3aea335cd06d45b1841acbc8d2d1ce40' | 'AddItem_de8c75222f3241288f20342f479894eb' | 'AddItem_ea8a3f269ccd443a95f571b868a94bd0' | 'AddThisParameters' | 'AggregatedFacetFilter' | 'AlertMessage' | 'AlertMessageFolder' | 'AlertMessageParametersTemplate' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_dxYboWowVqXyFEQIHTW4KbhL0lHEcueHzhBbeD0999E = { __typename?: 'AlertMessageType' | 'AllertMessageTypeFolder' | 'Archive' | 'ArticleAuthor' | 'ArticleAuthorsFolder' | 'ArticleCategoriesFolder' | 'ArticleCategory' | 'ArticleChapter' | 'ArticleChapters' | 'ArticleContentType' | 'ArticleContentTypesFolder' | 'ArticleFilter' | 'ArticleFilterOption' | 'ArticleFootnote' | 'ArticleFootnoteLink' | 'ArticleFootnoteText' | 'ArticleInfogramTile' | 'ArticleInfogramTileParametersTemplate' | 'ArticlePage' | 'ArticleRegion' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_UCMOSvPffh5Tlps5EZhWVbLbLYAlnbiakefGIxYg2c = { __typename?: 'ArticleRegionsFolder' | 'ArticleSearchPage' | 'ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c' | 'ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2' | 'ArticleSearchPage_be414ff574ac4203abb2694811443e25' | 'ArticleSearchPage_c7ad44ac3cab45158b619465a552a82c' | 'ArticleSearchPage_cf31bd740a4b4363b03d1f7a88e39907' | 'ArticleSeriesCollection' | 'ArticleSeriesFolder' | 'ArticleSettings' | 'ArticleSubscriptionBanner' | 'ArticleSubscriptionBannerFolder' | 'ArticleTag' | 'ArticleTagsFolder' | 'ArticleTeamAuthor' | 'ArticleTileParametersTemplate' | 'ArticleTilesParametersTemplate' | 'ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f' | 'ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8' | 'ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_xOJlvcBbMeSH2ZalUPaTM5ZeT2yOsFIN0h3Iv01is = { __typename?: 'ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c' | 'ArticleWildcardPage_405b20252077400383d3b47f09f88b47' | 'ArticleWildcardPage_b037a577f5cb4ad3b79f07720a96985b' | 'ArticlesGroupFolder' | 'AttachThemeExtension' | 'AutomaticDocumentListings' | 'AutomaticDocumentListingsFolder' | 'AvailableJSONRenderings' | 'AvailableMetaRenderings' | 'AvailableRenderings' | 'AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb' | 'AwardsBanner' | 'AwardsBannerFolder' | 'AwardsBannerImage' | 'AwardsBannerParametersTemplate' | 'BYOCWrapperRenderingParameters' | 'BackgroundColorOption' | 'BackgroundColorOptionFolder' | 'BannerFolder' | 'BannerType' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_TgBsOnUPPY6QvMRCjrAA0aJn3wFokEUMSDZlsVd9leA = { __typename?: 'BannerTypeFolder' | 'BaseHeading' | 'BaseHeadingFolder' | 'BoolFacet' | 'BranchesFolder' | 'Breadcrumb' | 'BrowserTitleDefinition' | 'CORSEntry' | 'CORSGrouping' | 'CTAPresentationType' | 'CTAPresentationTypeFolder' | 'C__AbrdnPage' | 'C__ActionBase' | 'C__AdvancedParameter' | 'C__App' | 'C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c' | 'C__ArticleWildcardPage' | 'C__AvailableRenderingsFolder' | 'C__BYOCRenderingParameters' | 'C__BackgroundParametersTemplate' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_1Fa5VAiUYUP8Bw87eryyMTnXaWA3g3Hakldosv8 = { __typename?: 'C__BaseCTA' | 'C__BasePage' | 'C__BasePage_037da552a5524fe4aeee331f57ac1378' | 'C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f' | 'C__BasePage_315fd21bebf04c9d9f00bae191442f1d' | 'C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd' | 'C__BasePage_728c97b5c56146d9807e21018a972bb5' | 'C__BasePage_6105875085f346729dfc8d133b481f26' | 'C__BasePage_b08130ebd3314a3b9c0f2b5e9b66387b' | 'C__BaseRenderingParameters' | 'C__BaseTheme' | 'C__BaseVariantField' | 'C__Class' | 'C__CompositeGroup' | 'C__CompositeSection' | 'C__EloquaForm' | 'C__ErrorPage_d40dd5cadbf1461191b8f9e1071e557d' | 'C__ExtendedOptions' | 'C__ExtendedOptions_2964fb4257a6440fb192218443904c90' | 'C__ExtendedOptions_f1850030f97848b4bdb5884b7e863160' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_ulsOVUMq3wDI6F3tyWyLZ3nyaAUzdauAXpbf8QIk = { __typename?: 'C__FEaaSRenderingParameters' | 'C__FacetSelectorConfigBase' | 'C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845' | 'C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b' | 'C__FundDetailsWildcardPage_fb127f7aeeba46458c5fbe9f7c589303' | 'C__FundSearchPage_d83da2a5ce9042b6bd557aa8820c62c5' | 'C__FundShareclassDetailsWildcardPage_e3590ad764a84980a419c4f1f926f9fc' | 'C__GlobalDatasourceBehavior' | 'C__GridDefinition' | 'C__GridItemBase' | 'C__GridParameters' | 'C__HeadlessSite' | 'C__HeadlessTenant' | 'C__HelpArticleSearchPage_d1c4d91365c8401389dcde7b5fb2f28b' | 'C__HelpArticleWildcardPage_c0a939305f6e47a38739f2a8f300e65d' | 'C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d' | 'C__IAllowEmpty' | 'C__IBaseVariantDefinition' | 'C__IBoosting' | 'C__ICacheable' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_xUQOkj0GMlc5wv60bmQQj73AHXxb38nIGTeN1leA = { __typename?: 'C__ICompatibleRenderings' | 'C__IComponentVariant' | 'C__IControlType' | 'C__IDynamicPlaceholder' | 'C__IFEaaSComponentsDataSourceTemplates' | 'C__IFEaaSComponentsEditorScriptURL' | 'C__IIcon' | 'C__ILocation' | 'C__IPaginable' | 'C__IPagination' | 'C__IPoi' | 'C__IRenderingId' | 'C__ISplitter' | 'C__IStyling' | 'C__IVariantDefinition' | 'C__InvestmentTrustPage' | 'C__JSONField' | 'C__JSONReference' | 'C__JSSData' | 'C__JSSSettings' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_t5cfgcaU3rr0AvX2OG5htlgnm2iWMKRTcTxzGBh8 = { __typename?: 'C__JSSSiteFolder' | 'C__JssRootFolder' | 'C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086' | 'C__Navigation_e6d98f24d01c419e871a4617125a49ed' | 'C__Page' | 'C__PageData' | 'C__PageDesignFolder' | 'C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd' | 'C__PageDesigns_daaf41fd96db4892be99f62f16d036c4' | 'C__PartialDesign' | 'C__PartialDesignFolder' | 'C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d' | 'C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d' | 'C__PlaceholderWrapper' | 'C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac' | 'C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b' | 'C__RedirectMapGrouping' | 'C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973' | 'C__Route' | 'C__SimpleVideo' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_4mXqXPHUZr4otYDSpYWX8Y4XMpULNT8i6kWuAJEVV8 = { __typename?: 'C__SiteSettingsFolder' | 'C__SitemapSettings' | 'C__StandardTemplate' | 'C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c' | 'C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65' | 'C__TrustFolder' | 'C__VariantDefinition' | 'C__VariantField' | 'C__VariantsGrouping' | 'C___AdvancedItem' | 'C___Arguments' | 'C___Arguments_33fab87cd52f44319a1f589ba7c1e287' | 'C___Article' | 'C___ArticlePageWorkflow' | 'C___ArticleSearchPage' | 'C___ArticleWildcard' | 'C___AssetServiceThemeMode' | 'C___BaseArticle' | 'C___BaseDataFolder' | 'C___BaseHelpArticle' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_eeK09Y7wkhG5t6ox2MHbp12nGtLVIravFt2ix25Urx8 = { __typename?: 'C___BaseInvestmentTrust' | 'C___BaseJSSTenant' | 'C___BasePage' | 'C___BasePageDesign' | 'C___BasePageDesignFolder' | 'C___BasePartialDesign' | 'C___BasePartialDesignFolder' | 'C___BasePlaceholder' | 'C___BasePlaceholderSettingsFolder' | 'C___BasePresentation' | 'C___BasePressRelease' | 'C___BaseRenderingParameters' | 'C___BaseSXAStandardValuesFolder' | 'C___BaseSettings' | 'C___BaseSharedSitesSettings' | 'C___BaseSiteDefinition' | 'C___BaseSiteFolder' | 'C___BaseSiteGrouping' | 'C___BaseSiteRoot' | 'C___BaseTenant' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_QxspLemKohwcfn6MLuzq31LoWJcDWhvc6FyIrdg3Y = { __typename?: 'C___BaseTenantFolder' | 'C___BucketRules' | 'C___CORS' | 'C___Content' | 'C___ContentType' | 'C___DataAttributes' | 'C___DatasourceWorkflow' | 'C___Dependencies' | 'C___Description' | 'C___DesignTemplateMapping' | 'C___Designable' | 'C___EditType' | 'C___EditType_8a9f84baaa124c5d9096935714809da4' | 'C___EditingTheme' | 'C___Enabled' | 'C___ErrorHandling' | 'C___ExternalArticle' | 'C___Fields' | 'C___FilteredArticlesParent' | 'C___FilteredArticlesWildcard' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_pLSvoSlIZBlpRr0oqseIDsMYsAtAKahN2CujcRmUG4 = { __typename?: 'C___Footnotes' | 'C___FundDetailsWildcard' | 'C___FundFormAvailability' | 'C___FundMetadataPage' | 'C___FundSearchPage' | 'C___FundsFolder' | 'C___FundsFormsFolder' | 'C___FundsLiteratureFolder' | 'C___FundsShareclassesDetailsWildcard' | 'C___GridMapping' | 'C___HelpArticle' | 'C___HelpArticleSearchPage' | 'C___HelpArticleWildcard' | 'C___HorizonDatasourceGrouping' | 'C___Icon' | 'C___IncludeByDefault' | 'C___IncludeIfInstalled' | 'C___InternalArticle' | 'C___InternetExplorerCompatibilityMode' | 'C___IsSystemModule' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_bAtMrDx88rUB43hbWgykdpxX2U1q1LBRCJ4YGeZd4 = { __typename?: 'C___JSONVariantPaging' | 'C___JSONVariantsBase' | 'C___LimitedDisplay' | 'C___LinkAttributes' | 'C___LinkSettings' | 'C___LiteratureHubSearchPage' | 'C___ManualKeyInformation' | 'C___MemberOf' | 'C___MetadataPage' | 'C___Modules' | 'C___Name' | 'C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d' | 'C___Name_299cdb154745448a807868d401248eaa' | 'C___Name_b88cf88159a54a19991e71038751cb60' | 'C___Navigable' | 'C___NavigablePage' | 'C___PageContent' | 'C___PageWorkflow' | 'C___PerSiteStandardValues' | 'C___Podcast' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_3TTCxtPd167YL33nF9XBmmHbkUnxZovqTZClaQHWlMw = { __typename?: 'C___PodcastPressRelease' | 'C___PremiumContentPage' | 'C___PressRelease' | 'C___PressReleaseContentType' | 'C___PressReleaseSearchPage' | 'C___PressReleaseWildcard' | 'C___ProtectedTheme' | 'C___PublishingGroupingTemplate' | 'C___RenderingRelatedParameters' | 'C___RenderingVariantsBase' | 'C___RenderingsList' | 'C___RobotsContent' | 'C___RoleDomain' | 'C___RoleName' | 'C___RoleType' | 'C___SalesforceCommonValidations' | 'C___SalesforceFieldId' | 'C___SalesforceFieldTitle' | 'C___SalesforceFieldValue' | 'C___Script' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_cjYnlIs8UAaiaQsoGXfmJs6J5mZumcliSqpOQJJTEs = { __typename?: 'C___SearchSignature' | 'C___Searchable' | 'C___SecurityItemPointer' | 'C___SharedArticles' | 'C___SharedContent' | 'C___SharedHelpArticles' | 'C___SharedPage' | 'C___SharedPressReleases' | 'C___SharedRoot' | 'C___SharedSettings' | 'C___SiteContent' | 'C___SiteFolder' | 'C___SiteMediaLibrary' | 'C___SiteSettings' | 'C___SiteTemplate' | 'C___SitecoreClientSiteManaging' | 'C___Sitemap' | 'C___SitemapMediaItems' | 'C___SlidersRangeSettings' | 'C___SolutionTemplateContent' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_06OIScbuurQrCIv2RnyRnUL8yzZFIOkwx4bqVVJ1U8 = { __typename?: 'C___SolutionTemplateDescription' | 'C___SolutionTemplateName' | 'C___SortOrder' | 'C___StackBreakpoint' | 'C___Statistics' | 'C___SupportedLanguages' | 'C___Taggable' | 'C___TeamMembersParentPage' | 'C___TeamMembersWildcard' | 'C___TechzoneArticle' | 'C___Template' | 'C___Title' | 'C___Type' | 'C___Validation' | 'C___VariantPaging' | 'C___VectorTile' | 'C___VectorTileLink' | 'C___Video' | 'C___VideoPressRelease' | 'C___Width' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_P8mpedaaoE314gdziPbBwa0OJmnSKCgK7OuMwTvh8 = { __typename?: 'C___WildcardPage' | 'CacheSetting' | 'Caching_26fce9bf0256458d8281a713a5bf5520' | 'CalendarEvent' | 'CallOutSection' | 'CallOutSectionDropdownOption' | 'CallOutSectionFolder' | 'CallOutSectionParametersTemplate' | 'CallToAction' | 'CallToActionFolder' | 'CapabilitiesFolder' | 'Capability' | 'CapabilityMap' | 'CapabilityMappings' | 'Carousel' | 'CarouselFolder' | 'CarouselSlide' | 'Carousel_2b65f0d87ec54834b4aa1753c0f7036b' | 'Checkbox' | 'ChecklistFilter' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_riDg0AYVm42AlYT43jww1Ay107z2R3VQxYQLo3qt4w = { __typename?: 'ChecklistFilterFolder' | 'ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee' | 'ColumnSplitter' | 'ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0' | 'CompatibilityMode' | 'ComponentConfiguration' | 'ComponentThemeConfiguration' | 'ComponentThemesConfiguration' | 'ComponentsConfigurations' | 'ConfigurationFolder' | 'Container' | 'ContainerOption' | 'ContainerOptionsFolder' | 'ContainerParametersTemplate' | 'Container_45130bdbbae34edcaea87b68b9d94c7f' | 'ContentBlock' | 'ContentBlockFolder' | 'ContentToken' | 'ContentTokenFolder' | 'ContentType' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_rOmfpST6oLo347EYJ7Raz1NFUvjdcKoBJzJr0H9BgZ0 = { __typename?: 'CorporateTheme' | 'CorporateThemesFolder' | 'Country' | 'CountryISOCode' | 'CountryISOCodesFolder' | 'CustomerReviewFolder' | 'CustomerReviewTile' | 'CustomerReviewTileParametersTemplate' | 'DataBridgeDocumentCategoryMap' | 'DataBridgeFund' | 'DataBridgeFundRangeName' | 'DataBridgeSettingsFolder' | 'DataBridgeShareClass' | 'DataFolder' | 'DatasourceConfiguration' | 'DatasourceConfigurations' | 'DatasourceWorkflowAction' | 'DateFacet' | 'DateFilter' | 'DateFilterFolder' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_OotNkMr3fBFvpnup0QnIBAKz5eVEb0STNbTDByrUc = { __typename?: 'DateFilter_ad89c1f1e99148ef865938ab13aa28f1' | 'DefaultColumnLayout' | 'DefaultShareclassMapping' | 'DefaultShareclassMappings' | 'DescriptiveHighlight' | 'DescriptiveHighlightFolder' | 'DescriptiveHighlightItem' | 'DescriptiveHighlightParametersTemplate' | 'Device' | 'Device_7c27ec70f42e40428a0fabaa2f8eda18' | 'Devices' | 'DictionaryFolder' | 'DisqusParameters' | 'DistanceFacet' | 'Divider' | 'DocumentItem' | 'DocumentListings' | 'DocumentListingsFolder' | 'DocumentTypeFolder' | 'DominantLanguageMapping' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_OVU4NcIdr6UAPevtvSSCtiep2KkZxR5zGCVShCeVdM = { __typename?: 'Dropdown' | 'DropdownFilter' | 'DropdownFilterFolder' | 'DropdownFilter_790c0f2c16214604a6c672b9f8ae830d' | 'EditEditingTheme' | 'EditFrame' | 'EditModePanel' | 'EditSiteItem' | 'EditSiteItem_f040db0387fe4e10ae4053c63175e31b' | 'EditSiteTheme' | 'EditTenantTemplate' | 'EditTenantTemplate_a7d9fcbcc8944274935f9b9659c000d3' | 'EditType' | 'EloquaFormFolder' | 'EloquaFundForm' | 'Enum' | 'Enums' | 'ErrorPage' | 'ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171' | 'ErrorPage_4dbccce416d1491f94198496e3f77c6d' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_PqG8IayP279sjtPG4vxuPRJW1hTc9wDd0Y6bxgfrj9M = { __typename?: 'ErrorPage_45d797cc048740ffb693214883ff35c2' | 'ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9' | 'ErrorPage_a7dfa49761224679bf9949fffacd5fa1' | 'EventCalendarParameters' | 'EventList' | 'EventListParameters' | 'EventTypes' | 'EventsFolder' | 'ExecuteScript' | 'ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f' | 'ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a' | 'ExecuteScript_b06460c28b7b47a59e2cf966f689b6ca' | 'ExecuteScript_bc9bb68436df4285888bd8b4d87b10de' | 'ExecuteScript_e14c08721a97459eafef0acaaaf1ffbb' | 'ExtendSiteTheme' | 'ExternalLiterature' | 'FEaaSWrapperRenderingParameters' | 'FacebookCommentsParametersTemplate' | 'FacetSlider' | 'FacetSliderFolder' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_jX8959OSsL1J6OXLEoQhYbwRZXji5sxbF5Emcsd7hk = { __typename?: 'FacetSlider_995ce2c7319f478b84fe22053ac85bb7' | 'FacetSummary' | 'FacetSummaryFolder' | 'FacetSummary_cd5c935c1f604d899a6b88ce28305cf2' | 'FacetsGrouping' | 'FakeNavigationItem' | 'FeatureBanner' | 'FeatureBannerParametersTemplate' | 'FeaturedArticles' | 'FeaturedArticlesFolder' | 'FeaturedTheme' | 'FeaturedThemesFolder' | 'Feed' | 'FeedFolder' | 'FeedParameters' | 'FieldEditor' | 'FieldRenderer' | 'FileList' | 'FileListFolder' | 'FileListParametersTemplate' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_nG2WofEr8CM8keV1x8PUfr4FiOA16RD19JEgZKAwYOw = { __typename?: 'File_04129321770849c1801baee196e1c0a8' | 'FilterCriteria' | 'FilterCriteriaFolder' | 'FilterTaxonomyOption' | 'FilterTaxonomyOptions' | 'FilteredArticlesParentPage' | 'FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d' | 'FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941' | 'FilteredArticlesParentPage_a34845039cf1441f8c967a5bbbdd7616' | 'FilteredArticlesParentPage_e4f65f074322485787460a4058d378f9' | 'FilteredArticlesParentPage_f099104e87204d52a6ab75aa44d159ce' | 'FilteredArticlesWildcardPage' | 'FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e' | 'FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835' | 'FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2' | 'FilteredArticlesWildcardPage_ceac9aa72d344797adf00f73f9a55f96' | 'FilteredArticlesWildcardPage_da761c9a4e8f4a91b99040d8f5baa260' | 'Flip' | 'FlipFolder' | 'Flip_5ef078504c044b839dafefd752cfaba8' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_phPzDO2Ka14Ao7Iqi5urCuijJRssi4yX4Ebgh3FcnbI = { __typename?: 'Flipside' | 'FloatFacet' | 'Footer' | 'FooterFolder' | 'FooterLink' | 'FormRenderingParameters' | 'FundAssetClass' | 'FundAssetClassesFolder' | 'FundDetailsWildcardPage' | 'FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734' | 'FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f' | 'FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b' | 'FundFormsFolder' | 'FundInFocus' | 'FundInFocusShareClass' | 'FundSearchPage' | 'FundSearchPage_5505b84dba1f47c7b8054749d802d926' | 'FundSearchPage_5806f83c03bc443380678ff955f4310f' | 'FundSearchPage_7432205c04214a419ca064c4cb37501c' | 'FundSearchPage_edc9df02132e4c0a8435dd60057cbb0a' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_Cng12S8NWxtlSTgmXuOQLEDPix0BbRxa4F0cvSsv1c = { __typename?: 'FundSettings' | 'FundShareclassDetailsWildcardPage' | 'FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c' | 'FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3' | 'FundShareclassDetailsWildcardPage_cf3f2635270b49779bb3822ab90f1dcc' | 'FundShareclassDetailsWildcardPage_d7e686d9c3bc4ef9974e201972b59eee' | 'FundSubAssetClass' | 'FundSubAssetClassesFolder' | 'FundsExternalLiteratureFolder' | 'FundsFolder' | 'FundsInFocusFolder' | 'FundsInFocusParametersTemplate' | 'FundsLiteratureFolder' | 'FundsLiteratureMappingsFolder' | 'Gallery' | 'GalleryFolder' | 'GalleryImage' | 'GalleryParametersTemplate' | 'GalleryVideo' | 'GatedAccordionContainer' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_Q1eQ5zKp1DmJrdMkqNxGrBxP1DirJ86dHnlUL7O6I = { __typename?: 'GlobalLanguageSelector' | 'GlobalNavigationBar' | 'GoogleAnalytics' | 'GoogleTagManager' | 'GoogleTagManagerFolder' | 'GridSetup' | 'GridTheme' | 'HTMLCode' | 'HTMLCodeFolder' | 'HTMLInclude' | 'HTMLIncludesFolder' | 'HTMLSnippet' | 'HTMLSnippetFolder' | 'HTMLTag' | 'Header' | 'HeaderFolder' | 'Heading' | 'HeadlessSiteSetupRoot' | 'HeadlessSite_00d050988bad49e5b65db1e08b03ca1b' | 'HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_UxmIFNNcD8BvR6JmFFbZx6akhkSuYq2XDQUlQUfc6gM = { __typename?: 'HeadlessSite_8ca001453c4b4715959d8a05292ecbc5' | 'HeadlessSite_68ffa40c5aab45548f774742b163f318' | 'HeadlessSite_89d464c8c03e4b0287e9a878d95d7149' | 'HeadlessSite_229484893ca144958b9937167dfb5064' | 'HeadlessSite_b28055626acc45a2913a9617398c9730' | 'HeadlessSite_f1cab1661abb450d84d55d938e7699cb' | 'HeadlessSite_f3884baa0e1548f59a6d7154a4559604' | 'HeadlessSolutionTemplateFolder' | 'HeadlessTenantSetupRoot' | 'HeadlessTenant_07248c4700af499eb2a9cb7789f72372' | 'HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8' | 'HeadlessTenant_5d72df6049c74324969205b55767ad7b' | 'HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3' | 'HeadlessTenant_77a403a2094e48afafa60943d349d23d' | 'HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2' | 'HeadlessTenant_94824ac390d748499e5af0275d10811f' | 'HeadlessTenant_4797571864fd40929cf2412c39757ec3' | 'HeadlessTenant_c102fb48f40f49fb9c21f8e3e1b0c107' | 'HeadlessTrustSite' | 'HeadlessVariants' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_K03JPtJ3NPqclv8mEFeFiFxrLZNgqW5QncC2uGSA77Y = { __typename?: 'HeadlessVariantsGrouping' | 'HelpArticlePage' | 'HelpArticlePlatform' | 'HelpArticlePlatformMap' | 'HelpArticlePlatformMappings' | 'HelpArticlePlatformsFolder' | 'HelpArticleSearchPage' | 'HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77' | 'HelpArticleTag' | 'HelpArticleTagsFolder' | 'HelpArticleWildcardPage' | 'HelpArticleWildcardPage_e4e2d58c853341deaa6b2a2a136421c4' | 'HelpArticlesGroupFolder' | 'HelpTagMap' | 'HelpTagMappings' | 'HeroBanner' | 'Highlight' | 'HighlightBlock' | 'HighlightBlockFolder' | 'HighlightBlockParametersTemplate' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_aenpgKLNXFjIwUuTFQwphJOVytmWnXoasHV2tDtjXA = { __typename?: 'HighlightFolder' | 'HighlightItem' | 'HighlightParametersTemplate' | 'Home' | 'HomePage' | 'HomePage_0d3963a8171d4080b5f808618578b631' | 'HomePage_6d95c7d946c74a70be07304cc73a2010' | 'HomePage_b407f259b4e34c7db9a06e8907a56b17' | 'HomePage_cde13c51062d426b95569e8202edc963' | 'HomePage_de9353283a3e41c495ba386aed0540c6' | 'IFrame' | 'IFrameFolder' | 'IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2' | 'IFrameParametersTemplate' | 'IFrame_0da12d476de24dfeb4d0f513489bfea1' | 'IFrame_88a6f65f2b78491bb3770b06e48883e1' | 'Icon' | 'IconFolder' | 'Image' | 'ImageFolder' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_CDmoRsf7y8h5Ar2oUgFnNgiYg5Wm5MFB5sWqwpfoA = { __typename?: 'ImageFolder_edc00e86cef24d0cbfa264460becc323' | 'ImageFolder_f7a4527687f14ea5bf25e3c7cb7aa993' | 'ImageParametersTemplate' | 'Image_83bc563c6320490092f8204bff81586a' | 'Image_15185b0e641844499f934ff03b7ee032' | 'Image_d885df8cb2d64007b34b2bbafb527304' | 'Infographics' | 'InfographicsFolder' | 'InputValidationStep' | 'InputValidationStep_088928cf558e40ec87f3342aa9e66757' | 'InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593' | 'InputValidationStep_d028fef2babf4ad1bbe74d62a977992f' | 'IntegerFacet' | 'IntroCopy' | 'IntroCopyFolder' | 'InvestmentTrustAssetClass' | 'InvestmentTrustAssetClassFolder' | 'InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73' | 'InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb' | 'InvestmentTrustRegion' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_N8t11RA4WT7eLeNtmUJb5cX9kSKK4wm7N236sTWE8 = { __typename?: 'InvestmentTrustRegionFolder' | 'InvestmentTrustStyle' | 'InvestmentTrustStyleFolder' | 'InvestorType' | 'InvestorTypesFolder' | 'ItemQueriesFolder' | 'ItemRights' | 'JSBeaconSettings' | 'JSONCheckbox' | 'JSONContent' | 'JSONDate' | 'JSONFile' | 'JSONImage' | 'JSONLayout' | 'JSONList' | 'JSONMultilistReference' | 'JSONPlaceholder' | 'JSONQuery' | 'JSONResults' | 'JSONRichText' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_BkDcm8o8XZ5WuUML3da3j72CB5P5RT7JbmLbgWLMlA = { __typename?: 'JSONScriban' | 'JSONSection' | 'JSONTemplate' | 'JSONText' | 'JSONToken' | 'JSONVariantDefinition' | 'JSONVariants' | 'JSSLayout' | 'JSSSettings_1a6fb678eca242c09ae77a9e7f72a6d0' | 'JSSSettings_6b328292f8314ab79885d89a054ca10a' | 'JSSSettings_457c9d0b61b84adfaf7f82561ed275ff' | 'JSSSettings_5045bf85d2ea430b9f41c2e348436e5d' | 'JSSSettings_a767f80d5ad44bfbb8b750a8da144cb5' | 'JSSSettings_b001fd725bb1476496825a8cb9e995cd' | 'JSSSettings_c643bc8630d14d61a173c7870f5dbbad' | 'JSSSettings_ce3dfd340df34b2d8715e54f85dfcce2' | 'JSSSettings_ef855d0ba8b04a8e87851d1298266d90' | 'JSSSiteGrouping' | 'JSSTenantFolder' | 'JavaScriptRendering' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_0vTag3ZdCtOjrU2vcDVBYggkRMS3OwqfjCaXIaj2FQ = { __typename?: 'JsonRendering' | 'JurisdictionStatus' | 'JurisdictionsFolder' | 'KeyHighlightItem' | 'KeyHighlights' | 'KeyHighlightsFolder' | 'KeyHighlightsParametersTemplate' | 'Language' | 'LanguageSelector' | 'LanguagesFolder' | 'LatestPressReleasesParametersTemplate' | 'LayoutServiceVariants' | 'LimitedDisplayFolder' | 'LimitedDisplayOption' | 'Link' | 'LinkList' | 'LinkListFolder' | 'LinkListFolder_c237d144647a4afeaa7b1570f3e3f139' | 'LinkList_33c9207e3b0446068ef54ca99a97c776' | 'LinkList_97a593ad273141dc80bfceb5ef6a33b7' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_sqVG0VpIjRzdFZ6SEQYGP8HSam7MB22VZyCoZhw = { __typename?: 'LinkList_f7561ffcc0d8477fb53d2703a4060be1' | 'Link_68bd1cb5a7624a969ac6cb16ab5882a3' | 'Link_930f134d56784b35bfd1b77f9d0115f1' | 'Link_e24e0789a05848bfabb6c69c0e60b6b7' | 'LinksFolder' | 'List' | 'ListFacet' | 'ListFolder' | 'ListItem' | 'ListParametersTemplate' | 'ListStyle' | 'ListStyleItem' | 'ListingHeroBanner' | 'ListingHeroParametersTemplate' | 'LiteratureAuthorization' | 'LiteratureAuthorizationsFolder' | 'LiteratureHubSearchPage' | 'LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d' | 'LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e' | 'LiteratureHubSearchPage_d2b2958263564ba8bba5922add46a0ea' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_8Kz6eX5wjZpt4Y3STeWvIdi5bV8U9Oq7PVI9cCpRs = { __typename?: 'LoadMore' | 'LoadMoreFolder' | 'LoadMore_7a3a53e06a0144ff8ba52be46e201fe6' | 'LocationFilter' | 'LocationFilterFolder' | 'LocationFilter_aaad4aad290744dc90b69e4e83a661ec' | 'Log' | 'Login' | 'Login_abed54dc4f7840ddac562289c9c849d8' | 'LogoTextBlockItem' | 'LogoTextBlocks' | 'LogoTextBlocksFolder' | 'Logout' | 'Logout_c2294d8235a6452a94b15eb5e543b602' | 'ManagedRangeFilter' | 'ManagedRangeFilterFolder' | 'ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91' | 'ManagedRangeItem' | 'Map' | 'MapParameters' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_1ZQOYG41E8YTlHUXoc3tPuY0q3xDporuJAVVUivtA = { __typename?: 'MapsFolder' | 'MapsProvider' | 'MediaBlock' | 'MediaBlockFolder' | 'MediaBlockParametersTemplate' | 'MediaFolder_81150e5837f5443fa3c075e14a9321e7' | 'MediaLinkParameters' | 'MediaVirtualFolder' | 'MegaNavigation' | 'MegaNavigationFolder' | 'MetaBranding' | 'MetaRenderingParameters' | 'MetadataPartialDesign' | 'Model' | 'ModelIterator' | 'MyLocationPOI' | 'Navigation' | 'NavigationCategory' | 'NavigationFilter' | 'NavigationFilterFolder' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_FtZZZXkh9e0hJWGo1Kh3UZ4YtGkERO9Cmf4oB7Bk = { __typename?: 'NavigationLink' | 'NavigationSubcategory' | 'Navigation_9ce34bf95c934dff841d8f649c2bd6c8' | 'OneTrustSettings' | 'OptimiserConfiguration' | 'OptimiserConfigurationSection' | 'OptimizedFile' | 'OracleCDPSettings' | 'OverlayContent' | 'OverlayFolderTemplate' | 'Ownership' | 'OwnershipFolder' | 'POI' | 'POIFolder' | 'POIType' | 'POIs' | 'PageBranchesFolder' | 'PageContent' | 'PageContentFolder' | 'PageContent_ef87e73bc7ff49a2ac599b0be83755c3' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_ItxT1uWpfHDU2NZek5ep0dLUbYpkhe2N9hrUVUJc = { __typename?: 'PageDesign' | 'PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0' | 'PageDesignFolder_27d4f8be63b045769a4ef3163c935b47' | 'PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8' | 'PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b' | 'PageDesignFolder_720d01f11e5046fa9c4a697f9321f662' | 'PageDesignFolder_771a0de7e83f44338c5d78727ead93bc' | 'PageDesignFolder_14161ec204984aa7a2a46decadf669f5' | 'PageDesignFolder_c691c2c4e0dd4fedb84a3c29de7002cb' | 'PageDesignFolder_d84605f786ea482da6ff683f6572821c' | 'PageDesign_1105b8f81e00426bbf1fc840742d827b' | 'PageDesigns' | 'PageDesigns_3af52e70e982424b9c85e355542500c9' | 'PageDesigns_9b34083e890b467d8e76b8c3dbbb712d' | 'PageDesigns_48d2d50a150c4f6283603a4fed5646e0' | 'PageDesigns_99a71bba507746729c3fb29b04abee23' | 'PageDesigns_a0f265b42d6241968b65d3ede7cb59c3' | 'PageDesigns_abe5ce6a82ff4433b4973bc50f192e11' | 'PageDesigns_b8d9b352c1694b31bd506848b47ca884' | 'PageDesigns_d3b2e1466f744df0900bec314f699ef3' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_dVvDcTzMNBPRc8A3EbBzjb3wldi0RCtaqrXmOhWdeA0 = { __typename?: 'PageDesigns_fd4b9b54f7474f01abdeba569d4b5bbe' | 'PageLevelTabs' | 'PageLevelTabsFolder' | 'PageList' | 'PageSelector' | 'PageSelectorConfiguration' | 'PageSelectorFolder' | 'PageSelector_59a7bb775f8c435ab810291abde80e63' | 'PageSize' | 'PageSizeFolder' | 'PageSize_b682562e0af64b3e9e3b45273bbe152d' | 'PageTheme' | 'PageThemesFolder' | 'Page_4f49a81db3664f198b89cab92f377d7a' | 'Page_5e66d86353544fe6a27d3b894984d50f' | 'Page_84f342ad2d0646b9aa9a818201145ca2' | 'Page_718df200be51463d93edf4d77ab7a49e' | 'Page_b61d5babe46f4ef39f27b57c4ccefdf7' | 'Page_cfd6e04697e24f3cb9eb41b79afc35dc' | 'Page_dae7821153e14dbabb0ddf0b53a90aaf' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_h2byPJl6xGVOvRywobMkOPhR2654wnDamnfTPKQ5SPs = { __typename?: 'Page_fa608b3e6aeb426388a059d89caabada' | 'Pagging' | 'Pagination' | 'PaginationFolder' | 'Paragraph' | 'PartialDesignFolder_8cf20a4412b746ee801218122c955b2d' | 'PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b' | 'PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8' | 'PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b' | 'PartialDesignFolder_828b5ff144cd4150bcdfe54084165112' | 'PartialDesignFolder_89098e3089aa4062a77346d608caac90' | 'PartialDesignFolder_1695576fb93647d7842ed17730278c32' | 'PartialDesignFolder_f16ae56fb78845639407c88edaffcbcc' | 'PartialDesignFolder_fb58558a3ec946d18524cd30805ab21a' | 'PartialDesign_fd2059fd60434dfe8c04e2437ce87634' | 'PartialDesigns' | 'PartialDesigns_043d3ad0ac4445dba03afc3550d088ec' | 'PartialDesigns_0310a4bf20d1441c886a0418c53e30f4' | 'PartialDesigns_36c869ded22040929ce829f6ed643c66' | 'PartialDesigns_1943dc73710a430895515a342c84b037' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_6JmPkgRXHMuxbwLKLbkgJcjRKmsIlXa0gtgQEjCdNo = { __typename?: 'PartialDesigns_b1e2a6790a1442d8bafa66317b8be117' | 'PartialDesigns_cc6d8635f3e2440ab8ebb93dc1030e9e' | 'PartialDesigns_d52704ed3b704a53abb4292105f687ad' | 'PartialDesigns_d216303f58d8425688da8cd30d00afab' | 'PartialDesigns_facda26791204fa9a0363344348f2c42' | 'PerformanceChartSettings' | 'PerformanceChartTimePeriod' | 'PerformanceChartTimePeriodFolder' | 'PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80' | 'PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d' | 'PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba' | 'Placeholder_1ca0304be5b64810821154426f1752c2' | 'Placeholder_d2a6884c04d54089a64ed27ca9d68d4c' | 'PlainHtmlParametersTemplate' | 'Playlist' | 'PlaylistFolder' | 'PlaylistParametersTemplate' | 'Podcast' | 'PodcastFolder' | 'PodcastPage' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_yHkYyZBv5NKWpeR5pkYUt3mI3oX5bJSUPoCthBFFyGc = { __typename?: 'PodcastPressReleasePage' | 'PoiTypes' | 'PostDeleteStep' | 'PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574' | 'PostDeleteStep_78d6ec9b66e34763987003cf314ee37a' | 'PostDeleteStep_b20857895385413883f096f3767cb156' | 'PostSetupStep' | 'PostSetupStep_6fac654e22154a419a1d59197bebc0fe' | 'PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f' | 'PostSetupStep_341738aa44fe490e90ff7010a3c2463b' | 'PreDeleteStep' | 'PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49' | 'PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b' | 'PreDeleteStep_f0daf401190f45468bda8568d08e161d' | 'PreDeleteValidationStep' | 'PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f' | 'PreDeleteValidationStep_edf1fa4206c44703ab1af23495bc6d8f' | 'PreDeleteValidationStep_f8c52120d0ea4d009de3b49fe12a3f1e' | 'Presentation' | 'Presentation_0a70fa7389234a6eabf34134f25f3221' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_Gns6CPvMEUg6ysN3qj6xpCJx38nqK83H91bwx61wLE = { __typename?: 'PressReleaseContentType' | 'PressReleaseContentTypesFolder' | 'PressReleaseFilter' | 'PressReleasePage' | 'PressReleasePlatformsFolder' | 'PressReleaseSearchPage' | 'PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f' | 'PressReleaseSearchPage_a6c344ca7c6946009de2ca92e27d7b72' | 'PressReleaseSearchPage_b9cd16f585ea4405a1ceda10cb20f64d' | 'PressReleaseSearchPage_c97027442df647cf9c36eedfc6787f58' | 'PressReleaseWildcardPage' | 'PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e' | 'PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79' | 'PressReleaseWildcardPage_b337d30403c642d2b9757e23d08223a1' | 'PressReleaseWildcardPage_e55e9d5bf9614e30b0a2a90327428258' | 'PressReleasesGroupFolder' | 'PrivacyWarning' | 'ProjectFolder' | 'Promo' | 'PromoFolder' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_ENQdzvbQNrNiryOm2NPQhFnmc18Yh4Fp0f0gQFYmFlU = { __typename?: 'PromoFolder_f07cbe8973ae4de692172570260cac6e' | 'Promo_7f21f14d096b4f27bbccf115c6e6f6f1' | 'Promo_881869ca7f5845ea8b34ad1bfd3551a8' | 'Promo_dfed4457d760457abec1c0dccdc44381' | 'PromotedContent' | 'PromotedContentFolder' | 'PropertyListingCard' | 'PropertyListingCards' | 'PropertyListingCategory' | 'PropertyListingFolder' | 'Query_98b413525a4b4067b92418a4b50f0a53' | 'QuickLinks' | 'QuickLinksFolder' | 'QuickLinksParametersTemplate' | 'QuotationBlockItem' | 'QuotationBlocks' | 'QuotationBlocksFolder' | 'QuotationBlocksParametersTemplate' | 'Quote' | 'QuoteFolder' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_QZDJyPms3T6lDHYCbvQFF0sD1nHC1HRs1Ix54YZ6i8 = { __typename?: 'QuoteParametersTemplate' | 'RadiusFilter' | 'RadiusFilterFolder' | 'RadiusFilter_de3fa58eef9d45449f77dcd1dbb05b64' | 'RadiusScheme' | 'RadiusSchemeValue' | 'RangeSliderFilter' | 'RangeSliderFilterFolder' | 'RangeSliderFilter_0a1787c296b54d40828522564a5d8e03' | 'RecentArticles' | 'Redirect' | 'RedirectMap' | 'RedirectMaps' | 'Region' | 'RegionLanguages' | 'RegionLanguagesFolder' | 'RelatedArticles' | 'RelatedArticlesParametersTemplate' | 'RenderEngineType' | 'RenderingFolder_840d4a46550349ecbf9dbd090946c63d' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_mWrj2tqhhIY9lLuI74Ks4zGGWP7srZO3klxwJMlgsg = { __typename?: 'RenderingHost' | 'ResizableIFramePage' | 'ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067' | 'ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68' | 'ResizableIFramePage_b58eacfb27f5417bb536141f94b92521' | 'ResizableIFramePage_d8d76a2407084147bf3900cd5e12e401' | 'ResizableIFramePage_f460ab055585441892023750e7cef6b7' | 'ResponsiveImage' | 'ResultsCount' | 'ResultsCountFolder' | 'ResultsCount_f3c0661ef9a9444ca26d44bf2a68a186' | 'ResultsVariantSelector' | 'RichText' | 'RichTextFolder' | 'RichText_0f3b73366112418c8bbab0526f3887ce' | 'RichText_efcfd8f6596745f48f85b5421928205d' | 'RiskImageMapping' | 'RiskImageMappings' | 'RiskLevelOption' | 'RiskLevelOptionFolder' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_ymNqvHCuEcVRQEfysJpY2kBJE9KwGVyjeu958mFrrlc = { __typename?: 'RiskWarning' | 'RiskWarningFolder' | 'RiskWarningParametersTemplate' | 'RolePlaceholder' | 'RowSplitter' | 'RowSplitter_340c887da1d1415b9678c763af74ea97' | 'Rule' | 'SDRLogoMapping' | 'SDRLogoMappings' | 'SDRTypeOption' | 'SDRTypeOptionFolder' | 'SXAJSSLayout' | 'SXARole' | 'SXAStandardValuesFolder' | 'SalesforceAlertMessage' | 'SalesforceCheckBox' | 'SalesforceCheckBoxType' | 'SalesforceConditionalRadioButton' | 'SalesforceConditionalRadioButtons' | 'SalesforceDateInput' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_4gcPHSCwc2XVOWBJzhReq136cuwdsEF53c96SP5CiZM = { __typename?: 'SalesforceDropdown' | 'SalesforceDropdownOption' | 'SalesforceHiddenField' | 'SalesforceInput' | 'SalesforceInputType' | 'SalesforceIntegratedForm' | 'SalesforceIntegratedFormTypesFolder' | 'SalesforceRepeatableSubSection' | 'SalesforceRichTextArea' | 'SalesforceSection' | 'SalesforceSortCodeInput' | 'SalesforceSubmissionType' | 'Scope' | 'ScopesFolder' | 'Scriban' | 'Scripts' | 'SearchBox' | 'SearchBoxFolder' | 'SearchBox_1c04fd611d874590acfe9cc186865ab3' | 'SearchFolder' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_RcDqArSfGfaeZn2uKE95hARLsahajiVremCkGWPo = { __typename?: 'SearchResults' | 'SearchResultsFolder' | 'SearchResults_a06f7130041d46bb8c2995a2dc00c26a' | 'SecondaryHeroBannerParametersTemplate' | 'SectionHeading' | 'SectionHeadingFolder' | 'SectionHeadingParametersTemplate' | 'SectionHeadingType' | 'SectionHeadingTypeFolder' | 'SectionSelector' | 'SectionSelectorFolder' | 'SectionSelectorTab' | 'Security_33077d51ebad4d1cb4a83b79f51dba13' | 'Series' | 'SeriesFolder' | 'Settings' | 'SettingsFolder' | 'Settings_6c82caca67dc464195698faad083230e' | 'SharePriceSettings' | 'SharedArticlesFolder' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_VFjXTBzpd79LHDBOD35cNMZmSFq180m1mHusZcXs = { __typename?: 'SharedContentFolder' | 'SharedFolder' | 'SharedHelpArticlesFolder' | 'SharedPressReleasesFolder' | 'SharedSettingsFolder' | 'SharedSitesSettings' | 'SharedSitesSettings_c14bf746030f4e598594395f6d299e61' | 'Showcase' | 'ShowcaseFolder' | 'ShowcaseItem' | 'ShowcaseParametersTemplate' | 'Site' | 'SiteContentFolder' | 'SiteDefinition' | 'SiteEntryDisclaimer' | 'SiteFolder' | 'SiteGrouping' | 'SiteManagement' | 'SiteSecurityItemPointer' | 'SiteSelector' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_MkuFXTU9755HLQp8UalGqsyAeKcQHfKk57YtkZFDXo = { __typename?: 'SiteSelector_a44632f56dcd4d10b4892f4e35e193c3' | 'SiteSetupRoot' | 'SiteTheme' | 'Site_e46f3af239fa4866a1577017c4b2a40c' | 'SitecoreFormWrapperParametersTemplate' | 'SitecoreRole' | 'SitemapSettings_c71d856635c849b7a84d9d176e9cbd05' | 'SkipLink' | 'SkipLinkParameters' | 'SkipLinksFolder' | 'Snippet' | 'SnippetItem' | 'SnippetsFolder' | 'SocialLoginWrapper' | 'SocialMediaButtons' | 'SocialMediaFolder' | 'SocialMediaShare' | 'SocialMediaTemplate' | 'SocialNetwork' | 'SocialNetworkFolder' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_ikuxXHO2arpTpiusmpYBomyF1zAxK7cnXIVR5AyNU = { __typename?: 'SocialNetworkLink' | 'SolutionTemplate' | 'SortResults' | 'SortResultsFolder' | 'Sorting' | 'SortingGroups' | 'SpotifyPodcast' | 'SpotifyPodcastFolder' | 'StickyCTA' | 'StickyCTAFolder' | 'StickyCTAParametersTemplate' | 'StrategiesInFocusFolder' | 'StrategyInFocus' | 'Style' | 'Styles' | 'Styles_9c0dac2808aa4b44bc2153363206f6a5' | 'SubscriptionBannerParametersTemplate' | 'Tab' | 'TabItem' | 'TableOfContents' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_NMn3JVcthxkgiQKXEWsmBod9iH6Hnr1ycy3Ortftdx0 = { __typename?: 'TableOfContentsFolder' | 'TableOfContentsSection' | 'TableOfContentsSubsection' | 'Tabs' | 'TabsFolder' | 'Tabs_f26a9560ccf148c59542800e837caf7a' | 'Tag' | 'TagCloud' | 'TagFolder' | 'TagList' | 'TeamBiographySettings' | 'TeamListingCards' | 'TeamListingCardsFolder' | 'TeamMember' | 'TeamMemberCard' | 'TeamMembers' | 'TeamMembersParentPage' | 'TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e' | 'TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e' | 'TeamMembersParentPage_47f304d629a84648a0e2b942513133ff' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_kYbw3Mn6uGrgzxBEykA9MbbLXnIvoKhO2ctQ2PcwVk = { __typename?: 'TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089' | 'TeamMembersParentPage_b4311697c06c4d58b88dca047c0a72b0' | 'TeamMembersWildcardPage' | 'TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e' | 'TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450' | 'TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a' | 'TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29' | 'TeamMembersWildcardPage_ea27a3d835fd49a3a4c797d2a6d52745' | 'TeamProfileCards' | 'TeamProfileCardsFolder' | 'TechzoneArticlePage' | 'Tenant' | 'TenantFolder' | 'TenantSecurityItemPointer' | 'TenantSetupRoot' | 'TertieryHeroBanner' | 'TertieryHeroBannerParametersTemplate' | 'Text' | 'TextBlock' | 'TextBlockHeadingParametersTemplate' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_eW0uqh0FJREFmMD7whlQHSyAhOj6irJCqObW4aiI4 = { __typename?: 'TextBlockHeadingType' | 'TextBlockHeadingTypeFolder' | 'TextBlockLinkType' | 'TextBlockLinkTypeFolder' | 'TextBlocks' | 'TextBlocksFolder' | 'TextBlocksParametersTemplate' | 'TextFolder' | 'TextFolder_b762d56787f5493cbb480c455d834457' | 'Text_b8f5894cb4934016bf784090b0a2fd16' | 'Theme' | 'ThemeTag' | 'ThemeTagsFolder' | 'ThemingMode' | 'ThemingModes' | 'Tile' | 'TileLink' | 'TileParametersTemplate' | 'TileSizeOption' | 'TileSizeOptionFolder' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_sMoHaQ0vl3goS076Rk1HRy3vPbwvd1ZUPxUpMfGI060 = { __typename?: 'TilesFolder' | 'TilesParametersTemplate' | 'Title' | 'Title_a82e893105754175917de904ef7e6dbe' | 'Toggle' | 'ToggleFolder' | 'Toggle_8e4c968e9fa543a89ac4c0baf273ccde' | 'Transformation' | 'TrustArticleHeroParametersTemplate' | 'TrustFinder' | 'TrustFinderFilterOption' | 'TrustRegion' | 'TrustType' | 'TrustTypesFolder' | 'Twitter' | 'TwitterApp' | 'TwitterApps' | 'TwitterFolder' | 'TwitterParametersTemplate' | 'TwitterSettings' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_jHUccxnc96VFbPApwlbfl6lTh5VJX08wTcEabw81G1w = { __typename?: 'UnknownItem' | 'UnminifiedFile' | 'UpgradeScript' | 'UpgradeScriptLibrary' | 'VariantComponentField' | 'VariantDateField' | 'VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55' | 'VariantPlaceholder' | 'VariantReference' | 'VariantSection' | 'VariantTemplate' | 'VariantText' | 'VariantToken' | 'Variants' | 'VectorFolder' | 'VectorTile' | 'VectorTileLink' | 'VectorTilesFolder' | 'VectorTilesParametersTemplate' | 'Version_95ebc23204774dc38ad3465d5fe8da2f' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_9IBNDu4RucbrcxK05T6CyGrZY6xBu9u2f1A7W17QDU = { __typename?: 'Video' | 'VideoCountOption' | 'VideoCountOptions' | 'VideoFolder' | 'VideoFolder_bba49474673e468186ba8b1a20e067a9' | 'VideoPage' | 'VideoParameters' | 'VideoParametersTemplate' | 'VideoPressReleasePage' | 'Video_4bc649610a894242be2dc5026090cf49' | '_AssetsOptimization' | '_BackgroundImage' | '_CompatibleThemes' | '_CompositeTheme' | '_CustomMetadata' | '_CustomRenderingViewPath' | '_DatasourceBehaviour' | '_Favicon' | '_FormsFolderLocation' | '_FundSettings' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_BPtRTuHp8rlvvWHijPSgBpGrAuzCnDphRfUgAxwLC8 = { __typename?: '_HasValidUrlName' | '_LocalDataLink' | '_Login' | '_OpenGraphMetadata' | '_PageDesignTheme' | '_PageSearchScope' | '_SearchCriteria' | '_SearchableWithoutRelatedItems' | '_SeoMetadata' | '_SiteTheme' | '_SitemapSettings' | '_StickyNote' | '_Styleable' | '_TwitterMetadata' | '_Webinar' | '_WildcardSource' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_PressReleasePlatform = (
  { __typename?: 'PressReleasePlatform' }
  & { name: Types.Maybe<PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_PressReleasePlatform_name_TextField> }
);

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem = PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_DYs1ksGYYCrvxaXhjPM6OUwdCvGvprMvFTBqgM5oM | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_dxYboWowVqXyFEQIHTW4KbhL0lHEcueHzhBbeD0999E | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_UCMOSvPffh5Tlps5EZhWVbLbLYAlnbiakefGIxYg2c | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_xOJlvcBbMeSH2ZalUPaTM5ZeT2yOsFIN0h3Iv01is | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_TgBsOnUPPY6QvMRCjrAA0aJn3wFokEUMSDZlsVd9leA | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_1Fa5VAiUYUP8Bw87eryyMTnXaWA3g3Hakldosv8 | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_ulsOVUMq3wDI6F3tyWyLZ3nyaAUzdauAXpbf8QIk | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_xUQOkj0GMlc5wv60bmQQj73AHXxb38nIGTeN1leA | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_t5cfgcaU3rr0AvX2OG5htlgnm2iWMKRTcTxzGBh8 | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_4mXqXPHUZr4otYDSpYWX8Y4XMpULNT8i6kWuAJEVV8 | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_eeK09Y7wkhG5t6ox2MHbp12nGtLVIravFt2ix25Urx8 | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_QxspLemKohwcfn6MLuzq31LoWJcDWhvc6FyIrdg3Y | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_pLSvoSlIZBlpRr0oqseIDsMYsAtAKahN2CujcRmUG4 | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_bAtMrDx88rUB43hbWgykdpxX2U1q1LBRCJ4YGeZd4 | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_3TTCxtPd167YL33nF9XBmmHbkUnxZovqTZClaQHWlMw | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_cjYnlIs8UAaiaQsoGXfmJs6J5mZumcliSqpOQJJTEs | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_06OIScbuurQrCIv2RnyRnUL8yzZFIOkwx4bqVVJ1U8 | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_P8mpedaaoE314gdziPbBwa0OJmnSKCgK7OuMwTvh8 | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_riDg0AYVm42AlYT43jww1Ay107z2R3VQxYQLo3qt4w | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_rOmfpST6oLo347EYJ7Raz1NFUvjdcKoBJzJr0H9BgZ0 | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_OotNkMr3fBFvpnup0QnIBAKz5eVEb0STNbTDByrUc | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_OVU4NcIdr6UAPevtvSSCtiep2KkZxR5zGCVShCeVdM | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_PqG8IayP279sjtPG4vxuPRJW1hTc9wDd0Y6bxgfrj9M | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_jX8959OSsL1J6OXLEoQhYbwRZXji5sxbF5Emcsd7hk | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_nG2WofEr8CM8keV1x8PUfr4FiOA16RD19JEgZKAwYOw | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_phPzDO2Ka14Ao7Iqi5urCuijJRssi4yX4Ebgh3FcnbI | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_Cng12S8NWxtlSTgmXuOQLEDPix0BbRxa4F0cvSsv1c | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_Q1eQ5zKp1DmJrdMkqNxGrBxP1DirJ86dHnlUL7O6I | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_UxmIFNNcD8BvR6JmFFbZx6akhkSuYq2XDQUlQUfc6gM | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_K03JPtJ3NPqclv8mEFeFiFxrLZNgqW5QncC2uGSA77Y | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_aenpgKLNXFjIwUuTFQwphJOVytmWnXoasHV2tDtjXA | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_CDmoRsf7y8h5Ar2oUgFnNgiYg5Wm5MFB5sWqwpfoA | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_N8t11RA4WT7eLeNtmUJb5cX9kSKK4wm7N236sTWE8 | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_BkDcm8o8XZ5WuUML3da3j72CB5P5RT7JbmLbgWLMlA | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_0vTag3ZdCtOjrU2vcDVBYggkRMS3OwqfjCaXIaj2FQ | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_sqVG0VpIjRzdFZ6SEQYGP8HSam7MB22VZyCoZhw | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_8Kz6eX5wjZpt4Y3STeWvIdi5bV8U9Oq7PVI9cCpRs | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_1ZQOYG41E8YTlHUXoc3tPuY0q3xDporuJAVVUivtA | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_FtZZZXkh9e0hJWGo1Kh3UZ4YtGkERO9Cmf4oB7Bk | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_ItxT1uWpfHDU2NZek5ep0dLUbYpkhe2N9hrUVUJc | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_dVvDcTzMNBPRc8A3EbBzjb3wldi0RCtaqrXmOhWdeA0 | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_h2byPJl6xGVOvRywobMkOPhR2654wnDamnfTPKQ5SPs | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_6JmPkgRXHMuxbwLKLbkgJcjRKmsIlXa0gtgQEjCdNo | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_yHkYyZBv5NKWpeR5pkYUt3mI3oX5bJSUPoCthBFFyGc | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_Gns6CPvMEUg6ysN3qj6xpCJx38nqK83H91bwx61wLE | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_ENQdzvbQNrNiryOm2NPQhFnmc18Yh4Fp0f0gQFYmFlU | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_QZDJyPms3T6lDHYCbvQFF0sD1nHC1HRs1Ix54YZ6i8 | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_mWrj2tqhhIY9lLuI74Ks4zGGWP7srZO3klxwJMlgsg | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_ymNqvHCuEcVRQEfysJpY2kBJE9KwGVyjeu958mFrrlc | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_4gcPHSCwc2XVOWBJzhReq136cuwdsEF53c96SP5CiZM | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_RcDqArSfGfaeZn2uKE95hARLsahajiVremCkGWPo | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_VFjXTBzpd79LHDBOD35cNMZmSFq180m1mHusZcXs | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_MkuFXTU9755HLQp8UalGqsyAeKcQHfKk57YtkZFDXo | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_ikuxXHO2arpTpiusmpYBomyF1zAxK7cnXIVR5AyNU | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_NMn3JVcthxkgiQKXEWsmBod9iH6Hnr1ycy3Ortftdx0 | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_kYbw3Mn6uGrgzxBEykA9MbbLXnIvoKhO2ctQ2PcwVk | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_eW0uqh0FJREFmMD7whlQHSyAhOj6irJCqObW4aiI4 | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_sMoHaQ0vl3goS076Rk1HRy3vPbwvd1ZUPxUpMfGI060 | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_jHUccxnc96VFbPApwlbfl6lTh5VJX08wTcEabw81G1w | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_9IBNDu4RucbrcxK05T6CyGrZY6xBu9u2f1A7W17QDU | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_BPtRTuHp8rlvvWHijPSgBpGrAuzCnDphRfUgAxwLC8 | PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem_PressReleasePlatform;

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField = (
  { __typename?: 'LookupField' }
  & { targetItem: Types.Maybe<PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField_targetItem> }
);

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_PressReleaseContentType_name_TextField = (
  { __typename?: 'TextField' }
  & Pick<Types.TextField, 'value'>
);

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_DYs1ksGYYCrvxaXhjPM6OUwdCvGvprMvFTBqgM5oM = { __typename?: 'Accordion' | 'AccordionFolder' | 'AccordionFolder_03f88fb497884025b46f2cb249f4fcd6' | 'AccordionItem' | 'AccordionItem_8cf671721b2d489e809f4c23db5ab2da' | 'AccordionParametersTemplate' | 'AccordionPresentation' | 'AccordionPresentationFolder' | 'Accordion_02d060598cc14423a9ac9ff2365176b7' | 'Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1' | 'AddItem' | 'AddItem_1e1b739ec3784909941d171aca7362e5' | 'AddItem_3aea335cd06d45b1841acbc8d2d1ce40' | 'AddItem_de8c75222f3241288f20342f479894eb' | 'AddItem_ea8a3f269ccd443a95f571b868a94bd0' | 'AddThisParameters' | 'AggregatedFacetFilter' | 'AlertMessage' | 'AlertMessageFolder' | 'AlertMessageParametersTemplate' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_dxYboWowVqXyFEQIHTW4KbhL0lHEcueHzhBbeD0999E = { __typename?: 'AlertMessageType' | 'AllertMessageTypeFolder' | 'Archive' | 'ArticleAuthor' | 'ArticleAuthorsFolder' | 'ArticleCategoriesFolder' | 'ArticleCategory' | 'ArticleChapter' | 'ArticleChapters' | 'ArticleContentType' | 'ArticleContentTypesFolder' | 'ArticleFilter' | 'ArticleFilterOption' | 'ArticleFootnote' | 'ArticleFootnoteLink' | 'ArticleFootnoteText' | 'ArticleInfogramTile' | 'ArticleInfogramTileParametersTemplate' | 'ArticlePage' | 'ArticleRegion' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_UCMOSvPffh5Tlps5EZhWVbLbLYAlnbiakefGIxYg2c = { __typename?: 'ArticleRegionsFolder' | 'ArticleSearchPage' | 'ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c' | 'ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2' | 'ArticleSearchPage_be414ff574ac4203abb2694811443e25' | 'ArticleSearchPage_c7ad44ac3cab45158b619465a552a82c' | 'ArticleSearchPage_cf31bd740a4b4363b03d1f7a88e39907' | 'ArticleSeriesCollection' | 'ArticleSeriesFolder' | 'ArticleSettings' | 'ArticleSubscriptionBanner' | 'ArticleSubscriptionBannerFolder' | 'ArticleTag' | 'ArticleTagsFolder' | 'ArticleTeamAuthor' | 'ArticleTileParametersTemplate' | 'ArticleTilesParametersTemplate' | 'ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f' | 'ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8' | 'ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_xOJlvcBbMeSH2ZalUPaTM5ZeT2yOsFIN0h3Iv01is = { __typename?: 'ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c' | 'ArticleWildcardPage_405b20252077400383d3b47f09f88b47' | 'ArticleWildcardPage_b037a577f5cb4ad3b79f07720a96985b' | 'ArticlesGroupFolder' | 'AttachThemeExtension' | 'AutomaticDocumentListings' | 'AutomaticDocumentListingsFolder' | 'AvailableJSONRenderings' | 'AvailableMetaRenderings' | 'AvailableRenderings' | 'AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb' | 'AwardsBanner' | 'AwardsBannerFolder' | 'AwardsBannerImage' | 'AwardsBannerParametersTemplate' | 'BYOCWrapperRenderingParameters' | 'BackgroundColorOption' | 'BackgroundColorOptionFolder' | 'BannerFolder' | 'BannerType' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_TgBsOnUPPY6QvMRCjrAA0aJn3wFokEUMSDZlsVd9leA = { __typename?: 'BannerTypeFolder' | 'BaseHeading' | 'BaseHeadingFolder' | 'BoolFacet' | 'BranchesFolder' | 'Breadcrumb' | 'BrowserTitleDefinition' | 'CORSEntry' | 'CORSGrouping' | 'CTAPresentationType' | 'CTAPresentationTypeFolder' | 'C__AbrdnPage' | 'C__ActionBase' | 'C__AdvancedParameter' | 'C__App' | 'C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c' | 'C__ArticleWildcardPage' | 'C__AvailableRenderingsFolder' | 'C__BYOCRenderingParameters' | 'C__BackgroundParametersTemplate' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_1Fa5VAiUYUP8Bw87eryyMTnXaWA3g3Hakldosv8 = { __typename?: 'C__BaseCTA' | 'C__BasePage' | 'C__BasePage_037da552a5524fe4aeee331f57ac1378' | 'C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f' | 'C__BasePage_315fd21bebf04c9d9f00bae191442f1d' | 'C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd' | 'C__BasePage_728c97b5c56146d9807e21018a972bb5' | 'C__BasePage_6105875085f346729dfc8d133b481f26' | 'C__BasePage_b08130ebd3314a3b9c0f2b5e9b66387b' | 'C__BaseRenderingParameters' | 'C__BaseTheme' | 'C__BaseVariantField' | 'C__Class' | 'C__CompositeGroup' | 'C__CompositeSection' | 'C__EloquaForm' | 'C__ErrorPage_d40dd5cadbf1461191b8f9e1071e557d' | 'C__ExtendedOptions' | 'C__ExtendedOptions_2964fb4257a6440fb192218443904c90' | 'C__ExtendedOptions_f1850030f97848b4bdb5884b7e863160' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_ulsOVUMq3wDI6F3tyWyLZ3nyaAUzdauAXpbf8QIk = { __typename?: 'C__FEaaSRenderingParameters' | 'C__FacetSelectorConfigBase' | 'C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845' | 'C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b' | 'C__FundDetailsWildcardPage_fb127f7aeeba46458c5fbe9f7c589303' | 'C__FundSearchPage_d83da2a5ce9042b6bd557aa8820c62c5' | 'C__FundShareclassDetailsWildcardPage_e3590ad764a84980a419c4f1f926f9fc' | 'C__GlobalDatasourceBehavior' | 'C__GridDefinition' | 'C__GridItemBase' | 'C__GridParameters' | 'C__HeadlessSite' | 'C__HeadlessTenant' | 'C__HelpArticleSearchPage_d1c4d91365c8401389dcde7b5fb2f28b' | 'C__HelpArticleWildcardPage_c0a939305f6e47a38739f2a8f300e65d' | 'C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d' | 'C__IAllowEmpty' | 'C__IBaseVariantDefinition' | 'C__IBoosting' | 'C__ICacheable' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_xUQOkj0GMlc5wv60bmQQj73AHXxb38nIGTeN1leA = { __typename?: 'C__ICompatibleRenderings' | 'C__IComponentVariant' | 'C__IControlType' | 'C__IDynamicPlaceholder' | 'C__IFEaaSComponentsDataSourceTemplates' | 'C__IFEaaSComponentsEditorScriptURL' | 'C__IIcon' | 'C__ILocation' | 'C__IPaginable' | 'C__IPagination' | 'C__IPoi' | 'C__IRenderingId' | 'C__ISplitter' | 'C__IStyling' | 'C__IVariantDefinition' | 'C__InvestmentTrustPage' | 'C__JSONField' | 'C__JSONReference' | 'C__JSSData' | 'C__JSSSettings' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_t5cfgcaU3rr0AvX2OG5htlgnm2iWMKRTcTxzGBh8 = { __typename?: 'C__JSSSiteFolder' | 'C__JssRootFolder' | 'C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086' | 'C__Navigation_e6d98f24d01c419e871a4617125a49ed' | 'C__Page' | 'C__PageData' | 'C__PageDesignFolder' | 'C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd' | 'C__PageDesigns_daaf41fd96db4892be99f62f16d036c4' | 'C__PartialDesign' | 'C__PartialDesignFolder' | 'C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d' | 'C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d' | 'C__PlaceholderWrapper' | 'C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac' | 'C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b' | 'C__RedirectMapGrouping' | 'C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973' | 'C__Route' | 'C__SimpleVideo' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_4mXqXPHUZr4otYDSpYWX8Y4XMpULNT8i6kWuAJEVV8 = { __typename?: 'C__SiteSettingsFolder' | 'C__SitemapSettings' | 'C__StandardTemplate' | 'C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c' | 'C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65' | 'C__TrustFolder' | 'C__VariantDefinition' | 'C__VariantField' | 'C__VariantsGrouping' | 'C___AdvancedItem' | 'C___Arguments' | 'C___Arguments_33fab87cd52f44319a1f589ba7c1e287' | 'C___Article' | 'C___ArticlePageWorkflow' | 'C___ArticleSearchPage' | 'C___ArticleWildcard' | 'C___AssetServiceThemeMode' | 'C___BaseArticle' | 'C___BaseDataFolder' | 'C___BaseHelpArticle' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_eeK09Y7wkhG5t6ox2MHbp12nGtLVIravFt2ix25Urx8 = { __typename?: 'C___BaseInvestmentTrust' | 'C___BaseJSSTenant' | 'C___BasePage' | 'C___BasePageDesign' | 'C___BasePageDesignFolder' | 'C___BasePartialDesign' | 'C___BasePartialDesignFolder' | 'C___BasePlaceholder' | 'C___BasePlaceholderSettingsFolder' | 'C___BasePresentation' | 'C___BasePressRelease' | 'C___BaseRenderingParameters' | 'C___BaseSXAStandardValuesFolder' | 'C___BaseSettings' | 'C___BaseSharedSitesSettings' | 'C___BaseSiteDefinition' | 'C___BaseSiteFolder' | 'C___BaseSiteGrouping' | 'C___BaseSiteRoot' | 'C___BaseTenant' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_QxspLemKohwcfn6MLuzq31LoWJcDWhvc6FyIrdg3Y = { __typename?: 'C___BaseTenantFolder' | 'C___BucketRules' | 'C___CORS' | 'C___Content' | 'C___ContentType' | 'C___DataAttributes' | 'C___DatasourceWorkflow' | 'C___Dependencies' | 'C___Description' | 'C___DesignTemplateMapping' | 'C___Designable' | 'C___EditType' | 'C___EditType_8a9f84baaa124c5d9096935714809da4' | 'C___EditingTheme' | 'C___Enabled' | 'C___ErrorHandling' | 'C___ExternalArticle' | 'C___Fields' | 'C___FilteredArticlesParent' | 'C___FilteredArticlesWildcard' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_pLSvoSlIZBlpRr0oqseIDsMYsAtAKahN2CujcRmUG4 = { __typename?: 'C___Footnotes' | 'C___FundDetailsWildcard' | 'C___FundFormAvailability' | 'C___FundMetadataPage' | 'C___FundSearchPage' | 'C___FundsFolder' | 'C___FundsFormsFolder' | 'C___FundsLiteratureFolder' | 'C___FundsShareclassesDetailsWildcard' | 'C___GridMapping' | 'C___HelpArticle' | 'C___HelpArticleSearchPage' | 'C___HelpArticleWildcard' | 'C___HorizonDatasourceGrouping' | 'C___Icon' | 'C___IncludeByDefault' | 'C___IncludeIfInstalled' | 'C___InternalArticle' | 'C___InternetExplorerCompatibilityMode' | 'C___IsSystemModule' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_bAtMrDx88rUB43hbWgykdpxX2U1q1LBRCJ4YGeZd4 = { __typename?: 'C___JSONVariantPaging' | 'C___JSONVariantsBase' | 'C___LimitedDisplay' | 'C___LinkAttributes' | 'C___LinkSettings' | 'C___LiteratureHubSearchPage' | 'C___ManualKeyInformation' | 'C___MemberOf' | 'C___MetadataPage' | 'C___Modules' | 'C___Name' | 'C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d' | 'C___Name_299cdb154745448a807868d401248eaa' | 'C___Name_b88cf88159a54a19991e71038751cb60' | 'C___Navigable' | 'C___NavigablePage' | 'C___PageContent' | 'C___PageWorkflow' | 'C___PerSiteStandardValues' | 'C___Podcast' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_3TTCxtPd167YL33nF9XBmmHbkUnxZovqTZClaQHWlMw = { __typename?: 'C___PodcastPressRelease' | 'C___PremiumContentPage' | 'C___PressRelease' | 'C___PressReleaseContentType' | 'C___PressReleaseSearchPage' | 'C___PressReleaseWildcard' | 'C___ProtectedTheme' | 'C___PublishingGroupingTemplate' | 'C___RenderingRelatedParameters' | 'C___RenderingVariantsBase' | 'C___RenderingsList' | 'C___RobotsContent' | 'C___RoleDomain' | 'C___RoleName' | 'C___RoleType' | 'C___SalesforceCommonValidations' | 'C___SalesforceFieldId' | 'C___SalesforceFieldTitle' | 'C___SalesforceFieldValue' | 'C___Script' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_cjYnlIs8UAaiaQsoGXfmJs6J5mZumcliSqpOQJJTEs = { __typename?: 'C___SearchSignature' | 'C___Searchable' | 'C___SecurityItemPointer' | 'C___SharedArticles' | 'C___SharedContent' | 'C___SharedHelpArticles' | 'C___SharedPage' | 'C___SharedPressReleases' | 'C___SharedRoot' | 'C___SharedSettings' | 'C___SiteContent' | 'C___SiteFolder' | 'C___SiteMediaLibrary' | 'C___SiteSettings' | 'C___SiteTemplate' | 'C___SitecoreClientSiteManaging' | 'C___Sitemap' | 'C___SitemapMediaItems' | 'C___SlidersRangeSettings' | 'C___SolutionTemplateContent' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_06OIScbuurQrCIv2RnyRnUL8yzZFIOkwx4bqVVJ1U8 = { __typename?: 'C___SolutionTemplateDescription' | 'C___SolutionTemplateName' | 'C___SortOrder' | 'C___StackBreakpoint' | 'C___Statistics' | 'C___SupportedLanguages' | 'C___Taggable' | 'C___TeamMembersParentPage' | 'C___TeamMembersWildcard' | 'C___TechzoneArticle' | 'C___Template' | 'C___Title' | 'C___Type' | 'C___Validation' | 'C___VariantPaging' | 'C___VectorTile' | 'C___VectorTileLink' | 'C___Video' | 'C___VideoPressRelease' | 'C___Width' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_P8mpedaaoE314gdziPbBwa0OJmnSKCgK7OuMwTvh8 = { __typename?: 'C___WildcardPage' | 'CacheSetting' | 'Caching_26fce9bf0256458d8281a713a5bf5520' | 'CalendarEvent' | 'CallOutSection' | 'CallOutSectionDropdownOption' | 'CallOutSectionFolder' | 'CallOutSectionParametersTemplate' | 'CallToAction' | 'CallToActionFolder' | 'CapabilitiesFolder' | 'Capability' | 'CapabilityMap' | 'CapabilityMappings' | 'Carousel' | 'CarouselFolder' | 'CarouselSlide' | 'Carousel_2b65f0d87ec54834b4aa1753c0f7036b' | 'Checkbox' | 'ChecklistFilter' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_riDg0AYVm42AlYT43jww1Ay107z2R3VQxYQLo3qt4w = { __typename?: 'ChecklistFilterFolder' | 'ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee' | 'ColumnSplitter' | 'ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0' | 'CompatibilityMode' | 'ComponentConfiguration' | 'ComponentThemeConfiguration' | 'ComponentThemesConfiguration' | 'ComponentsConfigurations' | 'ConfigurationFolder' | 'Container' | 'ContainerOption' | 'ContainerOptionsFolder' | 'ContainerParametersTemplate' | 'Container_45130bdbbae34edcaea87b68b9d94c7f' | 'ContentBlock' | 'ContentBlockFolder' | 'ContentToken' | 'ContentTokenFolder' | 'ContentType' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_rOmfpST6oLo347EYJ7Raz1NFUvjdcKoBJzJr0H9BgZ0 = { __typename?: 'CorporateTheme' | 'CorporateThemesFolder' | 'Country' | 'CountryISOCode' | 'CountryISOCodesFolder' | 'CustomerReviewFolder' | 'CustomerReviewTile' | 'CustomerReviewTileParametersTemplate' | 'DataBridgeDocumentCategoryMap' | 'DataBridgeFund' | 'DataBridgeFundRangeName' | 'DataBridgeSettingsFolder' | 'DataBridgeShareClass' | 'DataFolder' | 'DatasourceConfiguration' | 'DatasourceConfigurations' | 'DatasourceWorkflowAction' | 'DateFacet' | 'DateFilter' | 'DateFilterFolder' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_OotNkMr3fBFvpnup0QnIBAKz5eVEb0STNbTDByrUc = { __typename?: 'DateFilter_ad89c1f1e99148ef865938ab13aa28f1' | 'DefaultColumnLayout' | 'DefaultShareclassMapping' | 'DefaultShareclassMappings' | 'DescriptiveHighlight' | 'DescriptiveHighlightFolder' | 'DescriptiveHighlightItem' | 'DescriptiveHighlightParametersTemplate' | 'Device' | 'Device_7c27ec70f42e40428a0fabaa2f8eda18' | 'Devices' | 'DictionaryFolder' | 'DisqusParameters' | 'DistanceFacet' | 'Divider' | 'DocumentItem' | 'DocumentListings' | 'DocumentListingsFolder' | 'DocumentTypeFolder' | 'DominantLanguageMapping' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_OVU4NcIdr6UAPevtvSSCtiep2KkZxR5zGCVShCeVdM = { __typename?: 'Dropdown' | 'DropdownFilter' | 'DropdownFilterFolder' | 'DropdownFilter_790c0f2c16214604a6c672b9f8ae830d' | 'EditEditingTheme' | 'EditFrame' | 'EditModePanel' | 'EditSiteItem' | 'EditSiteItem_f040db0387fe4e10ae4053c63175e31b' | 'EditSiteTheme' | 'EditTenantTemplate' | 'EditTenantTemplate_a7d9fcbcc8944274935f9b9659c000d3' | 'EditType' | 'EloquaFormFolder' | 'EloquaFundForm' | 'Enum' | 'Enums' | 'ErrorPage' | 'ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171' | 'ErrorPage_4dbccce416d1491f94198496e3f77c6d' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_PqG8IayP279sjtPG4vxuPRJW1hTc9wDd0Y6bxgfrj9M = { __typename?: 'ErrorPage_45d797cc048740ffb693214883ff35c2' | 'ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9' | 'ErrorPage_a7dfa49761224679bf9949fffacd5fa1' | 'EventCalendarParameters' | 'EventList' | 'EventListParameters' | 'EventTypes' | 'EventsFolder' | 'ExecuteScript' | 'ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f' | 'ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a' | 'ExecuteScript_b06460c28b7b47a59e2cf966f689b6ca' | 'ExecuteScript_bc9bb68436df4285888bd8b4d87b10de' | 'ExecuteScript_e14c08721a97459eafef0acaaaf1ffbb' | 'ExtendSiteTheme' | 'ExternalLiterature' | 'FEaaSWrapperRenderingParameters' | 'FacebookCommentsParametersTemplate' | 'FacetSlider' | 'FacetSliderFolder' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_jX8959OSsL1J6OXLEoQhYbwRZXji5sxbF5Emcsd7hk = { __typename?: 'FacetSlider_995ce2c7319f478b84fe22053ac85bb7' | 'FacetSummary' | 'FacetSummaryFolder' | 'FacetSummary_cd5c935c1f604d899a6b88ce28305cf2' | 'FacetsGrouping' | 'FakeNavigationItem' | 'FeatureBanner' | 'FeatureBannerParametersTemplate' | 'FeaturedArticles' | 'FeaturedArticlesFolder' | 'FeaturedTheme' | 'FeaturedThemesFolder' | 'Feed' | 'FeedFolder' | 'FeedParameters' | 'FieldEditor' | 'FieldRenderer' | 'FileList' | 'FileListFolder' | 'FileListParametersTemplate' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_nG2WofEr8CM8keV1x8PUfr4FiOA16RD19JEgZKAwYOw = { __typename?: 'File_04129321770849c1801baee196e1c0a8' | 'FilterCriteria' | 'FilterCriteriaFolder' | 'FilterTaxonomyOption' | 'FilterTaxonomyOptions' | 'FilteredArticlesParentPage' | 'FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d' | 'FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941' | 'FilteredArticlesParentPage_a34845039cf1441f8c967a5bbbdd7616' | 'FilteredArticlesParentPage_e4f65f074322485787460a4058d378f9' | 'FilteredArticlesParentPage_f099104e87204d52a6ab75aa44d159ce' | 'FilteredArticlesWildcardPage' | 'FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e' | 'FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835' | 'FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2' | 'FilteredArticlesWildcardPage_ceac9aa72d344797adf00f73f9a55f96' | 'FilteredArticlesWildcardPage_da761c9a4e8f4a91b99040d8f5baa260' | 'Flip' | 'FlipFolder' | 'Flip_5ef078504c044b839dafefd752cfaba8' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_phPzDO2Ka14Ao7Iqi5urCuijJRssi4yX4Ebgh3FcnbI = { __typename?: 'Flipside' | 'FloatFacet' | 'Footer' | 'FooterFolder' | 'FooterLink' | 'FormRenderingParameters' | 'FundAssetClass' | 'FundAssetClassesFolder' | 'FundDetailsWildcardPage' | 'FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734' | 'FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f' | 'FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b' | 'FundFormsFolder' | 'FundInFocus' | 'FundInFocusShareClass' | 'FundSearchPage' | 'FundSearchPage_5505b84dba1f47c7b8054749d802d926' | 'FundSearchPage_5806f83c03bc443380678ff955f4310f' | 'FundSearchPage_7432205c04214a419ca064c4cb37501c' | 'FundSearchPage_edc9df02132e4c0a8435dd60057cbb0a' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_Cng12S8NWxtlSTgmXuOQLEDPix0BbRxa4F0cvSsv1c = { __typename?: 'FundSettings' | 'FundShareclassDetailsWildcardPage' | 'FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c' | 'FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3' | 'FundShareclassDetailsWildcardPage_cf3f2635270b49779bb3822ab90f1dcc' | 'FundShareclassDetailsWildcardPage_d7e686d9c3bc4ef9974e201972b59eee' | 'FundSubAssetClass' | 'FundSubAssetClassesFolder' | 'FundsExternalLiteratureFolder' | 'FundsFolder' | 'FundsInFocusFolder' | 'FundsInFocusParametersTemplate' | 'FundsLiteratureFolder' | 'FundsLiteratureMappingsFolder' | 'Gallery' | 'GalleryFolder' | 'GalleryImage' | 'GalleryParametersTemplate' | 'GalleryVideo' | 'GatedAccordionContainer' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_Q1eQ5zKp1DmJrdMkqNxGrBxP1DirJ86dHnlUL7O6I = { __typename?: 'GlobalLanguageSelector' | 'GlobalNavigationBar' | 'GoogleAnalytics' | 'GoogleTagManager' | 'GoogleTagManagerFolder' | 'GridSetup' | 'GridTheme' | 'HTMLCode' | 'HTMLCodeFolder' | 'HTMLInclude' | 'HTMLIncludesFolder' | 'HTMLSnippet' | 'HTMLSnippetFolder' | 'HTMLTag' | 'Header' | 'HeaderFolder' | 'Heading' | 'HeadlessSiteSetupRoot' | 'HeadlessSite_00d050988bad49e5b65db1e08b03ca1b' | 'HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_UxmIFNNcD8BvR6JmFFbZx6akhkSuYq2XDQUlQUfc6gM = { __typename?: 'HeadlessSite_8ca001453c4b4715959d8a05292ecbc5' | 'HeadlessSite_68ffa40c5aab45548f774742b163f318' | 'HeadlessSite_89d464c8c03e4b0287e9a878d95d7149' | 'HeadlessSite_229484893ca144958b9937167dfb5064' | 'HeadlessSite_b28055626acc45a2913a9617398c9730' | 'HeadlessSite_f1cab1661abb450d84d55d938e7699cb' | 'HeadlessSite_f3884baa0e1548f59a6d7154a4559604' | 'HeadlessSolutionTemplateFolder' | 'HeadlessTenantSetupRoot' | 'HeadlessTenant_07248c4700af499eb2a9cb7789f72372' | 'HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8' | 'HeadlessTenant_5d72df6049c74324969205b55767ad7b' | 'HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3' | 'HeadlessTenant_77a403a2094e48afafa60943d349d23d' | 'HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2' | 'HeadlessTenant_94824ac390d748499e5af0275d10811f' | 'HeadlessTenant_4797571864fd40929cf2412c39757ec3' | 'HeadlessTenant_c102fb48f40f49fb9c21f8e3e1b0c107' | 'HeadlessTrustSite' | 'HeadlessVariants' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_K03JPtJ3NPqclv8mEFeFiFxrLZNgqW5QncC2uGSA77Y = { __typename?: 'HeadlessVariantsGrouping' | 'HelpArticlePage' | 'HelpArticlePlatform' | 'HelpArticlePlatformMap' | 'HelpArticlePlatformMappings' | 'HelpArticlePlatformsFolder' | 'HelpArticleSearchPage' | 'HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77' | 'HelpArticleTag' | 'HelpArticleTagsFolder' | 'HelpArticleWildcardPage' | 'HelpArticleWildcardPage_e4e2d58c853341deaa6b2a2a136421c4' | 'HelpArticlesGroupFolder' | 'HelpTagMap' | 'HelpTagMappings' | 'HeroBanner' | 'Highlight' | 'HighlightBlock' | 'HighlightBlockFolder' | 'HighlightBlockParametersTemplate' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_aenpgKLNXFjIwUuTFQwphJOVytmWnXoasHV2tDtjXA = { __typename?: 'HighlightFolder' | 'HighlightItem' | 'HighlightParametersTemplate' | 'Home' | 'HomePage' | 'HomePage_0d3963a8171d4080b5f808618578b631' | 'HomePage_6d95c7d946c74a70be07304cc73a2010' | 'HomePage_b407f259b4e34c7db9a06e8907a56b17' | 'HomePage_cde13c51062d426b95569e8202edc963' | 'HomePage_de9353283a3e41c495ba386aed0540c6' | 'IFrame' | 'IFrameFolder' | 'IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2' | 'IFrameParametersTemplate' | 'IFrame_0da12d476de24dfeb4d0f513489bfea1' | 'IFrame_88a6f65f2b78491bb3770b06e48883e1' | 'Icon' | 'IconFolder' | 'Image' | 'ImageFolder' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_CDmoRsf7y8h5Ar2oUgFnNgiYg5Wm5MFB5sWqwpfoA = { __typename?: 'ImageFolder_edc00e86cef24d0cbfa264460becc323' | 'ImageFolder_f7a4527687f14ea5bf25e3c7cb7aa993' | 'ImageParametersTemplate' | 'Image_83bc563c6320490092f8204bff81586a' | 'Image_15185b0e641844499f934ff03b7ee032' | 'Image_d885df8cb2d64007b34b2bbafb527304' | 'Infographics' | 'InfographicsFolder' | 'InputValidationStep' | 'InputValidationStep_088928cf558e40ec87f3342aa9e66757' | 'InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593' | 'InputValidationStep_d028fef2babf4ad1bbe74d62a977992f' | 'IntegerFacet' | 'IntroCopy' | 'IntroCopyFolder' | 'InvestmentTrustAssetClass' | 'InvestmentTrustAssetClassFolder' | 'InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73' | 'InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb' | 'InvestmentTrustRegion' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_N8t11RA4WT7eLeNtmUJb5cX9kSKK4wm7N236sTWE8 = { __typename?: 'InvestmentTrustRegionFolder' | 'InvestmentTrustStyle' | 'InvestmentTrustStyleFolder' | 'InvestorType' | 'InvestorTypesFolder' | 'ItemQueriesFolder' | 'ItemRights' | 'JSBeaconSettings' | 'JSONCheckbox' | 'JSONContent' | 'JSONDate' | 'JSONFile' | 'JSONImage' | 'JSONLayout' | 'JSONList' | 'JSONMultilistReference' | 'JSONPlaceholder' | 'JSONQuery' | 'JSONResults' | 'JSONRichText' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_BkDcm8o8XZ5WuUML3da3j72CB5P5RT7JbmLbgWLMlA = { __typename?: 'JSONScriban' | 'JSONSection' | 'JSONTemplate' | 'JSONText' | 'JSONToken' | 'JSONVariantDefinition' | 'JSONVariants' | 'JSSLayout' | 'JSSSettings_1a6fb678eca242c09ae77a9e7f72a6d0' | 'JSSSettings_6b328292f8314ab79885d89a054ca10a' | 'JSSSettings_457c9d0b61b84adfaf7f82561ed275ff' | 'JSSSettings_5045bf85d2ea430b9f41c2e348436e5d' | 'JSSSettings_a767f80d5ad44bfbb8b750a8da144cb5' | 'JSSSettings_b001fd725bb1476496825a8cb9e995cd' | 'JSSSettings_c643bc8630d14d61a173c7870f5dbbad' | 'JSSSettings_ce3dfd340df34b2d8715e54f85dfcce2' | 'JSSSettings_ef855d0ba8b04a8e87851d1298266d90' | 'JSSSiteGrouping' | 'JSSTenantFolder' | 'JavaScriptRendering' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_0vTag3ZdCtOjrU2vcDVBYggkRMS3OwqfjCaXIaj2FQ = { __typename?: 'JsonRendering' | 'JurisdictionStatus' | 'JurisdictionsFolder' | 'KeyHighlightItem' | 'KeyHighlights' | 'KeyHighlightsFolder' | 'KeyHighlightsParametersTemplate' | 'Language' | 'LanguageSelector' | 'LanguagesFolder' | 'LatestPressReleasesParametersTemplate' | 'LayoutServiceVariants' | 'LimitedDisplayFolder' | 'LimitedDisplayOption' | 'Link' | 'LinkList' | 'LinkListFolder' | 'LinkListFolder_c237d144647a4afeaa7b1570f3e3f139' | 'LinkList_33c9207e3b0446068ef54ca99a97c776' | 'LinkList_97a593ad273141dc80bfceb5ef6a33b7' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_sqVG0VpIjRzdFZ6SEQYGP8HSam7MB22VZyCoZhw = { __typename?: 'LinkList_f7561ffcc0d8477fb53d2703a4060be1' | 'Link_68bd1cb5a7624a969ac6cb16ab5882a3' | 'Link_930f134d56784b35bfd1b77f9d0115f1' | 'Link_e24e0789a05848bfabb6c69c0e60b6b7' | 'LinksFolder' | 'List' | 'ListFacet' | 'ListFolder' | 'ListItem' | 'ListParametersTemplate' | 'ListStyle' | 'ListStyleItem' | 'ListingHeroBanner' | 'ListingHeroParametersTemplate' | 'LiteratureAuthorization' | 'LiteratureAuthorizationsFolder' | 'LiteratureHubSearchPage' | 'LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d' | 'LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e' | 'LiteratureHubSearchPage_d2b2958263564ba8bba5922add46a0ea' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_8Kz6eX5wjZpt4Y3STeWvIdi5bV8U9Oq7PVI9cCpRs = { __typename?: 'LoadMore' | 'LoadMoreFolder' | 'LoadMore_7a3a53e06a0144ff8ba52be46e201fe6' | 'LocationFilter' | 'LocationFilterFolder' | 'LocationFilter_aaad4aad290744dc90b69e4e83a661ec' | 'Log' | 'Login' | 'Login_abed54dc4f7840ddac562289c9c849d8' | 'LogoTextBlockItem' | 'LogoTextBlocks' | 'LogoTextBlocksFolder' | 'Logout' | 'Logout_c2294d8235a6452a94b15eb5e543b602' | 'ManagedRangeFilter' | 'ManagedRangeFilterFolder' | 'ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91' | 'ManagedRangeItem' | 'Map' | 'MapParameters' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_1ZQOYG41E8YTlHUXoc3tPuY0q3xDporuJAVVUivtA = { __typename?: 'MapsFolder' | 'MapsProvider' | 'MediaBlock' | 'MediaBlockFolder' | 'MediaBlockParametersTemplate' | 'MediaFolder_81150e5837f5443fa3c075e14a9321e7' | 'MediaLinkParameters' | 'MediaVirtualFolder' | 'MegaNavigation' | 'MegaNavigationFolder' | 'MetaBranding' | 'MetaRenderingParameters' | 'MetadataPartialDesign' | 'Model' | 'ModelIterator' | 'MyLocationPOI' | 'Navigation' | 'NavigationCategory' | 'NavigationFilter' | 'NavigationFilterFolder' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_FtZZZXkh9e0hJWGo1Kh3UZ4YtGkERO9Cmf4oB7Bk = { __typename?: 'NavigationLink' | 'NavigationSubcategory' | 'Navigation_9ce34bf95c934dff841d8f649c2bd6c8' | 'OneTrustSettings' | 'OptimiserConfiguration' | 'OptimiserConfigurationSection' | 'OptimizedFile' | 'OracleCDPSettings' | 'OverlayContent' | 'OverlayFolderTemplate' | 'Ownership' | 'OwnershipFolder' | 'POI' | 'POIFolder' | 'POIType' | 'POIs' | 'PageBranchesFolder' | 'PageContent' | 'PageContentFolder' | 'PageContent_ef87e73bc7ff49a2ac599b0be83755c3' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_ItxT1uWpfHDU2NZek5ep0dLUbYpkhe2N9hrUVUJc = { __typename?: 'PageDesign' | 'PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0' | 'PageDesignFolder_27d4f8be63b045769a4ef3163c935b47' | 'PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8' | 'PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b' | 'PageDesignFolder_720d01f11e5046fa9c4a697f9321f662' | 'PageDesignFolder_771a0de7e83f44338c5d78727ead93bc' | 'PageDesignFolder_14161ec204984aa7a2a46decadf669f5' | 'PageDesignFolder_c691c2c4e0dd4fedb84a3c29de7002cb' | 'PageDesignFolder_d84605f786ea482da6ff683f6572821c' | 'PageDesign_1105b8f81e00426bbf1fc840742d827b' | 'PageDesigns' | 'PageDesigns_3af52e70e982424b9c85e355542500c9' | 'PageDesigns_9b34083e890b467d8e76b8c3dbbb712d' | 'PageDesigns_48d2d50a150c4f6283603a4fed5646e0' | 'PageDesigns_99a71bba507746729c3fb29b04abee23' | 'PageDesigns_a0f265b42d6241968b65d3ede7cb59c3' | 'PageDesigns_abe5ce6a82ff4433b4973bc50f192e11' | 'PageDesigns_b8d9b352c1694b31bd506848b47ca884' | 'PageDesigns_d3b2e1466f744df0900bec314f699ef3' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_dVvDcTzMNBPRc8A3EbBzjb3wldi0RCtaqrXmOhWdeA0 = { __typename?: 'PageDesigns_fd4b9b54f7474f01abdeba569d4b5bbe' | 'PageLevelTabs' | 'PageLevelTabsFolder' | 'PageList' | 'PageSelector' | 'PageSelectorConfiguration' | 'PageSelectorFolder' | 'PageSelector_59a7bb775f8c435ab810291abde80e63' | 'PageSize' | 'PageSizeFolder' | 'PageSize_b682562e0af64b3e9e3b45273bbe152d' | 'PageTheme' | 'PageThemesFolder' | 'Page_4f49a81db3664f198b89cab92f377d7a' | 'Page_5e66d86353544fe6a27d3b894984d50f' | 'Page_84f342ad2d0646b9aa9a818201145ca2' | 'Page_718df200be51463d93edf4d77ab7a49e' | 'Page_b61d5babe46f4ef39f27b57c4ccefdf7' | 'Page_cfd6e04697e24f3cb9eb41b79afc35dc' | 'Page_dae7821153e14dbabb0ddf0b53a90aaf' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_h2byPJl6xGVOvRywobMkOPhR2654wnDamnfTPKQ5SPs = { __typename?: 'Page_fa608b3e6aeb426388a059d89caabada' | 'Pagging' | 'Pagination' | 'PaginationFolder' | 'Paragraph' | 'PartialDesignFolder_8cf20a4412b746ee801218122c955b2d' | 'PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b' | 'PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8' | 'PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b' | 'PartialDesignFolder_828b5ff144cd4150bcdfe54084165112' | 'PartialDesignFolder_89098e3089aa4062a77346d608caac90' | 'PartialDesignFolder_1695576fb93647d7842ed17730278c32' | 'PartialDesignFolder_f16ae56fb78845639407c88edaffcbcc' | 'PartialDesignFolder_fb58558a3ec946d18524cd30805ab21a' | 'PartialDesign_fd2059fd60434dfe8c04e2437ce87634' | 'PartialDesigns' | 'PartialDesigns_043d3ad0ac4445dba03afc3550d088ec' | 'PartialDesigns_0310a4bf20d1441c886a0418c53e30f4' | 'PartialDesigns_36c869ded22040929ce829f6ed643c66' | 'PartialDesigns_1943dc73710a430895515a342c84b037' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_6JmPkgRXHMuxbwLKLbkgJcjRKmsIlXa0gtgQEjCdNo = { __typename?: 'PartialDesigns_b1e2a6790a1442d8bafa66317b8be117' | 'PartialDesigns_cc6d8635f3e2440ab8ebb93dc1030e9e' | 'PartialDesigns_d52704ed3b704a53abb4292105f687ad' | 'PartialDesigns_d216303f58d8425688da8cd30d00afab' | 'PartialDesigns_facda26791204fa9a0363344348f2c42' | 'PerformanceChartSettings' | 'PerformanceChartTimePeriod' | 'PerformanceChartTimePeriodFolder' | 'PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80' | 'PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d' | 'PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba' | 'Placeholder_1ca0304be5b64810821154426f1752c2' | 'Placeholder_d2a6884c04d54089a64ed27ca9d68d4c' | 'PlainHtmlParametersTemplate' | 'Playlist' | 'PlaylistFolder' | 'PlaylistParametersTemplate' | 'Podcast' | 'PodcastFolder' | 'PodcastPage' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_yHkYyZBv5NKWpeR5pkYUt3mI3oX5bJSUPoCthBFFyGc = { __typename?: 'PodcastPressReleasePage' | 'PoiTypes' | 'PostDeleteStep' | 'PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574' | 'PostDeleteStep_78d6ec9b66e34763987003cf314ee37a' | 'PostDeleteStep_b20857895385413883f096f3767cb156' | 'PostSetupStep' | 'PostSetupStep_6fac654e22154a419a1d59197bebc0fe' | 'PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f' | 'PostSetupStep_341738aa44fe490e90ff7010a3c2463b' | 'PreDeleteStep' | 'PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49' | 'PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b' | 'PreDeleteStep_f0daf401190f45468bda8568d08e161d' | 'PreDeleteValidationStep' | 'PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f' | 'PreDeleteValidationStep_edf1fa4206c44703ab1af23495bc6d8f' | 'PreDeleteValidationStep_f8c52120d0ea4d009de3b49fe12a3f1e' | 'Presentation' | 'Presentation_0a70fa7389234a6eabf34134f25f3221' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_drzV1CJMhZ88IeARb30GphbrzYOHnyNZjm3CgUbIWk = { __typename?: 'PressReleaseContentTypesFolder' | 'PressReleaseFilter' | 'PressReleasePage' | 'PressReleasePlatform' | 'PressReleasePlatformsFolder' | 'PressReleaseSearchPage' | 'PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f' | 'PressReleaseSearchPage_a6c344ca7c6946009de2ca92e27d7b72' | 'PressReleaseSearchPage_b9cd16f585ea4405a1ceda10cb20f64d' | 'PressReleaseSearchPage_c97027442df647cf9c36eedfc6787f58' | 'PressReleaseWildcardPage' | 'PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e' | 'PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79' | 'PressReleaseWildcardPage_b337d30403c642d2b9757e23d08223a1' | 'PressReleaseWildcardPage_e55e9d5bf9614e30b0a2a90327428258' | 'PressReleasesGroupFolder' | 'PrivacyWarning' | 'ProjectFolder' | 'Promo' | 'PromoFolder' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_ENQdzvbQNrNiryOm2NPQhFnmc18Yh4Fp0f0gQFYmFlU = { __typename?: 'PromoFolder_f07cbe8973ae4de692172570260cac6e' | 'Promo_7f21f14d096b4f27bbccf115c6e6f6f1' | 'Promo_881869ca7f5845ea8b34ad1bfd3551a8' | 'Promo_dfed4457d760457abec1c0dccdc44381' | 'PromotedContent' | 'PromotedContentFolder' | 'PropertyListingCard' | 'PropertyListingCards' | 'PropertyListingCategory' | 'PropertyListingFolder' | 'Query_98b413525a4b4067b92418a4b50f0a53' | 'QuickLinks' | 'QuickLinksFolder' | 'QuickLinksParametersTemplate' | 'QuotationBlockItem' | 'QuotationBlocks' | 'QuotationBlocksFolder' | 'QuotationBlocksParametersTemplate' | 'Quote' | 'QuoteFolder' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_QZDJyPms3T6lDHYCbvQFF0sD1nHC1HRs1Ix54YZ6i8 = { __typename?: 'QuoteParametersTemplate' | 'RadiusFilter' | 'RadiusFilterFolder' | 'RadiusFilter_de3fa58eef9d45449f77dcd1dbb05b64' | 'RadiusScheme' | 'RadiusSchemeValue' | 'RangeSliderFilter' | 'RangeSliderFilterFolder' | 'RangeSliderFilter_0a1787c296b54d40828522564a5d8e03' | 'RecentArticles' | 'Redirect' | 'RedirectMap' | 'RedirectMaps' | 'Region' | 'RegionLanguages' | 'RegionLanguagesFolder' | 'RelatedArticles' | 'RelatedArticlesParametersTemplate' | 'RenderEngineType' | 'RenderingFolder_840d4a46550349ecbf9dbd090946c63d' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_mWrj2tqhhIY9lLuI74Ks4zGGWP7srZO3klxwJMlgsg = { __typename?: 'RenderingHost' | 'ResizableIFramePage' | 'ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067' | 'ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68' | 'ResizableIFramePage_b58eacfb27f5417bb536141f94b92521' | 'ResizableIFramePage_d8d76a2407084147bf3900cd5e12e401' | 'ResizableIFramePage_f460ab055585441892023750e7cef6b7' | 'ResponsiveImage' | 'ResultsCount' | 'ResultsCountFolder' | 'ResultsCount_f3c0661ef9a9444ca26d44bf2a68a186' | 'ResultsVariantSelector' | 'RichText' | 'RichTextFolder' | 'RichText_0f3b73366112418c8bbab0526f3887ce' | 'RichText_efcfd8f6596745f48f85b5421928205d' | 'RiskImageMapping' | 'RiskImageMappings' | 'RiskLevelOption' | 'RiskLevelOptionFolder' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_ymNqvHCuEcVRQEfysJpY2kBJE9KwGVyjeu958mFrrlc = { __typename?: 'RiskWarning' | 'RiskWarningFolder' | 'RiskWarningParametersTemplate' | 'RolePlaceholder' | 'RowSplitter' | 'RowSplitter_340c887da1d1415b9678c763af74ea97' | 'Rule' | 'SDRLogoMapping' | 'SDRLogoMappings' | 'SDRTypeOption' | 'SDRTypeOptionFolder' | 'SXAJSSLayout' | 'SXARole' | 'SXAStandardValuesFolder' | 'SalesforceAlertMessage' | 'SalesforceCheckBox' | 'SalesforceCheckBoxType' | 'SalesforceConditionalRadioButton' | 'SalesforceConditionalRadioButtons' | 'SalesforceDateInput' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_4gcPHSCwc2XVOWBJzhReq136cuwdsEF53c96SP5CiZM = { __typename?: 'SalesforceDropdown' | 'SalesforceDropdownOption' | 'SalesforceHiddenField' | 'SalesforceInput' | 'SalesforceInputType' | 'SalesforceIntegratedForm' | 'SalesforceIntegratedFormTypesFolder' | 'SalesforceRepeatableSubSection' | 'SalesforceRichTextArea' | 'SalesforceSection' | 'SalesforceSortCodeInput' | 'SalesforceSubmissionType' | 'Scope' | 'ScopesFolder' | 'Scriban' | 'Scripts' | 'SearchBox' | 'SearchBoxFolder' | 'SearchBox_1c04fd611d874590acfe9cc186865ab3' | 'SearchFolder' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_RcDqArSfGfaeZn2uKE95hARLsahajiVremCkGWPo = { __typename?: 'SearchResults' | 'SearchResultsFolder' | 'SearchResults_a06f7130041d46bb8c2995a2dc00c26a' | 'SecondaryHeroBannerParametersTemplate' | 'SectionHeading' | 'SectionHeadingFolder' | 'SectionHeadingParametersTemplate' | 'SectionHeadingType' | 'SectionHeadingTypeFolder' | 'SectionSelector' | 'SectionSelectorFolder' | 'SectionSelectorTab' | 'Security_33077d51ebad4d1cb4a83b79f51dba13' | 'Series' | 'SeriesFolder' | 'Settings' | 'SettingsFolder' | 'Settings_6c82caca67dc464195698faad083230e' | 'SharePriceSettings' | 'SharedArticlesFolder' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_VFjXTBzpd79LHDBOD35cNMZmSFq180m1mHusZcXs = { __typename?: 'SharedContentFolder' | 'SharedFolder' | 'SharedHelpArticlesFolder' | 'SharedPressReleasesFolder' | 'SharedSettingsFolder' | 'SharedSitesSettings' | 'SharedSitesSettings_c14bf746030f4e598594395f6d299e61' | 'Showcase' | 'ShowcaseFolder' | 'ShowcaseItem' | 'ShowcaseParametersTemplate' | 'Site' | 'SiteContentFolder' | 'SiteDefinition' | 'SiteEntryDisclaimer' | 'SiteFolder' | 'SiteGrouping' | 'SiteManagement' | 'SiteSecurityItemPointer' | 'SiteSelector' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_MkuFXTU9755HLQp8UalGqsyAeKcQHfKk57YtkZFDXo = { __typename?: 'SiteSelector_a44632f56dcd4d10b4892f4e35e193c3' | 'SiteSetupRoot' | 'SiteTheme' | 'Site_e46f3af239fa4866a1577017c4b2a40c' | 'SitecoreFormWrapperParametersTemplate' | 'SitecoreRole' | 'SitemapSettings_c71d856635c849b7a84d9d176e9cbd05' | 'SkipLink' | 'SkipLinkParameters' | 'SkipLinksFolder' | 'Snippet' | 'SnippetItem' | 'SnippetsFolder' | 'SocialLoginWrapper' | 'SocialMediaButtons' | 'SocialMediaFolder' | 'SocialMediaShare' | 'SocialMediaTemplate' | 'SocialNetwork' | 'SocialNetworkFolder' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_ikuxXHO2arpTpiusmpYBomyF1zAxK7cnXIVR5AyNU = { __typename?: 'SocialNetworkLink' | 'SolutionTemplate' | 'SortResults' | 'SortResultsFolder' | 'Sorting' | 'SortingGroups' | 'SpotifyPodcast' | 'SpotifyPodcastFolder' | 'StickyCTA' | 'StickyCTAFolder' | 'StickyCTAParametersTemplate' | 'StrategiesInFocusFolder' | 'StrategyInFocus' | 'Style' | 'Styles' | 'Styles_9c0dac2808aa4b44bc2153363206f6a5' | 'SubscriptionBannerParametersTemplate' | 'Tab' | 'TabItem' | 'TableOfContents' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_NMn3JVcthxkgiQKXEWsmBod9iH6Hnr1ycy3Ortftdx0 = { __typename?: 'TableOfContentsFolder' | 'TableOfContentsSection' | 'TableOfContentsSubsection' | 'Tabs' | 'TabsFolder' | 'Tabs_f26a9560ccf148c59542800e837caf7a' | 'Tag' | 'TagCloud' | 'TagFolder' | 'TagList' | 'TeamBiographySettings' | 'TeamListingCards' | 'TeamListingCardsFolder' | 'TeamMember' | 'TeamMemberCard' | 'TeamMembers' | 'TeamMembersParentPage' | 'TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e' | 'TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e' | 'TeamMembersParentPage_47f304d629a84648a0e2b942513133ff' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_kYbw3Mn6uGrgzxBEykA9MbbLXnIvoKhO2ctQ2PcwVk = { __typename?: 'TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089' | 'TeamMembersParentPage_b4311697c06c4d58b88dca047c0a72b0' | 'TeamMembersWildcardPage' | 'TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e' | 'TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450' | 'TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a' | 'TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29' | 'TeamMembersWildcardPage_ea27a3d835fd49a3a4c797d2a6d52745' | 'TeamProfileCards' | 'TeamProfileCardsFolder' | 'TechzoneArticlePage' | 'Tenant' | 'TenantFolder' | 'TenantSecurityItemPointer' | 'TenantSetupRoot' | 'TertieryHeroBanner' | 'TertieryHeroBannerParametersTemplate' | 'Text' | 'TextBlock' | 'TextBlockHeadingParametersTemplate' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_eW0uqh0FJREFmMD7whlQHSyAhOj6irJCqObW4aiI4 = { __typename?: 'TextBlockHeadingType' | 'TextBlockHeadingTypeFolder' | 'TextBlockLinkType' | 'TextBlockLinkTypeFolder' | 'TextBlocks' | 'TextBlocksFolder' | 'TextBlocksParametersTemplate' | 'TextFolder' | 'TextFolder_b762d56787f5493cbb480c455d834457' | 'Text_b8f5894cb4934016bf784090b0a2fd16' | 'Theme' | 'ThemeTag' | 'ThemeTagsFolder' | 'ThemingMode' | 'ThemingModes' | 'Tile' | 'TileLink' | 'TileParametersTemplate' | 'TileSizeOption' | 'TileSizeOptionFolder' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_sMoHaQ0vl3goS076Rk1HRy3vPbwvd1ZUPxUpMfGI060 = { __typename?: 'TilesFolder' | 'TilesParametersTemplate' | 'Title' | 'Title_a82e893105754175917de904ef7e6dbe' | 'Toggle' | 'ToggleFolder' | 'Toggle_8e4c968e9fa543a89ac4c0baf273ccde' | 'Transformation' | 'TrustArticleHeroParametersTemplate' | 'TrustFinder' | 'TrustFinderFilterOption' | 'TrustRegion' | 'TrustType' | 'TrustTypesFolder' | 'Twitter' | 'TwitterApp' | 'TwitterApps' | 'TwitterFolder' | 'TwitterParametersTemplate' | 'TwitterSettings' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_jHUccxnc96VFbPApwlbfl6lTh5VJX08wTcEabw81G1w = { __typename?: 'UnknownItem' | 'UnminifiedFile' | 'UpgradeScript' | 'UpgradeScriptLibrary' | 'VariantComponentField' | 'VariantDateField' | 'VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55' | 'VariantPlaceholder' | 'VariantReference' | 'VariantSection' | 'VariantTemplate' | 'VariantText' | 'VariantToken' | 'Variants' | 'VectorFolder' | 'VectorTile' | 'VectorTileLink' | 'VectorTilesFolder' | 'VectorTilesParametersTemplate' | 'Version_95ebc23204774dc38ad3465d5fe8da2f' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_9IBNDu4RucbrcxK05T6CyGrZY6xBu9u2f1A7W17QDU = { __typename?: 'Video' | 'VideoCountOption' | 'VideoCountOptions' | 'VideoFolder' | 'VideoFolder_bba49474673e468186ba8b1a20e067a9' | 'VideoPage' | 'VideoParameters' | 'VideoParametersTemplate' | 'VideoPressReleasePage' | 'Video_4bc649610a894242be2dc5026090cf49' | '_AssetsOptimization' | '_BackgroundImage' | '_CompatibleThemes' | '_CompositeTheme' | '_CustomMetadata' | '_CustomRenderingViewPath' | '_DatasourceBehaviour' | '_Favicon' | '_FormsFolderLocation' | '_FundSettings' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_BPtRTuHp8rlvvWHijPSgBpGrAuzCnDphRfUgAxwLC8 = { __typename?: '_HasValidUrlName' | '_LocalDataLink' | '_Login' | '_OpenGraphMetadata' | '_PageDesignTheme' | '_PageSearchScope' | '_SearchCriteria' | '_SearchableWithoutRelatedItems' | '_SeoMetadata' | '_SiteTheme' | '_SitemapSettings' | '_StickyNote' | '_Styleable' | '_TwitterMetadata' | '_Webinar' | '_WildcardSource' };

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_PressReleaseContentType = (
  { __typename?: 'PressReleaseContentType' }
  & { name: Types.Maybe<PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_PressReleaseContentType_name_TextField> }
);

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem = PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_DYs1ksGYYCrvxaXhjPM6OUwdCvGvprMvFTBqgM5oM | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_dxYboWowVqXyFEQIHTW4KbhL0lHEcueHzhBbeD0999E | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_UCMOSvPffh5Tlps5EZhWVbLbLYAlnbiakefGIxYg2c | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_xOJlvcBbMeSH2ZalUPaTM5ZeT2yOsFIN0h3Iv01is | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_TgBsOnUPPY6QvMRCjrAA0aJn3wFokEUMSDZlsVd9leA | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_1Fa5VAiUYUP8Bw87eryyMTnXaWA3g3Hakldosv8 | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_ulsOVUMq3wDI6F3tyWyLZ3nyaAUzdauAXpbf8QIk | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_xUQOkj0GMlc5wv60bmQQj73AHXxb38nIGTeN1leA | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_t5cfgcaU3rr0AvX2OG5htlgnm2iWMKRTcTxzGBh8 | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_4mXqXPHUZr4otYDSpYWX8Y4XMpULNT8i6kWuAJEVV8 | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_eeK09Y7wkhG5t6ox2MHbp12nGtLVIravFt2ix25Urx8 | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_QxspLemKohwcfn6MLuzq31LoWJcDWhvc6FyIrdg3Y | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_pLSvoSlIZBlpRr0oqseIDsMYsAtAKahN2CujcRmUG4 | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_bAtMrDx88rUB43hbWgykdpxX2U1q1LBRCJ4YGeZd4 | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_3TTCxtPd167YL33nF9XBmmHbkUnxZovqTZClaQHWlMw | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_cjYnlIs8UAaiaQsoGXfmJs6J5mZumcliSqpOQJJTEs | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_06OIScbuurQrCIv2RnyRnUL8yzZFIOkwx4bqVVJ1U8 | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_P8mpedaaoE314gdziPbBwa0OJmnSKCgK7OuMwTvh8 | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_riDg0AYVm42AlYT43jww1Ay107z2R3VQxYQLo3qt4w | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_rOmfpST6oLo347EYJ7Raz1NFUvjdcKoBJzJr0H9BgZ0 | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_OotNkMr3fBFvpnup0QnIBAKz5eVEb0STNbTDByrUc | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_OVU4NcIdr6UAPevtvSSCtiep2KkZxR5zGCVShCeVdM | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_PqG8IayP279sjtPG4vxuPRJW1hTc9wDd0Y6bxgfrj9M | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_jX8959OSsL1J6OXLEoQhYbwRZXji5sxbF5Emcsd7hk | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_nG2WofEr8CM8keV1x8PUfr4FiOA16RD19JEgZKAwYOw | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_phPzDO2Ka14Ao7Iqi5urCuijJRssi4yX4Ebgh3FcnbI | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_Cng12S8NWxtlSTgmXuOQLEDPix0BbRxa4F0cvSsv1c | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_Q1eQ5zKp1DmJrdMkqNxGrBxP1DirJ86dHnlUL7O6I | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_UxmIFNNcD8BvR6JmFFbZx6akhkSuYq2XDQUlQUfc6gM | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_K03JPtJ3NPqclv8mEFeFiFxrLZNgqW5QncC2uGSA77Y | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_aenpgKLNXFjIwUuTFQwphJOVytmWnXoasHV2tDtjXA | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_CDmoRsf7y8h5Ar2oUgFnNgiYg5Wm5MFB5sWqwpfoA | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_N8t11RA4WT7eLeNtmUJb5cX9kSKK4wm7N236sTWE8 | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_BkDcm8o8XZ5WuUML3da3j72CB5P5RT7JbmLbgWLMlA | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_0vTag3ZdCtOjrU2vcDVBYggkRMS3OwqfjCaXIaj2FQ | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_sqVG0VpIjRzdFZ6SEQYGP8HSam7MB22VZyCoZhw | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_8Kz6eX5wjZpt4Y3STeWvIdi5bV8U9Oq7PVI9cCpRs | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_1ZQOYG41E8YTlHUXoc3tPuY0q3xDporuJAVVUivtA | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_FtZZZXkh9e0hJWGo1Kh3UZ4YtGkERO9Cmf4oB7Bk | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_ItxT1uWpfHDU2NZek5ep0dLUbYpkhe2N9hrUVUJc | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_dVvDcTzMNBPRc8A3EbBzjb3wldi0RCtaqrXmOhWdeA0 | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_h2byPJl6xGVOvRywobMkOPhR2654wnDamnfTPKQ5SPs | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_6JmPkgRXHMuxbwLKLbkgJcjRKmsIlXa0gtgQEjCdNo | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_yHkYyZBv5NKWpeR5pkYUt3mI3oX5bJSUPoCthBFFyGc | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_drzV1CJMhZ88IeARb30GphbrzYOHnyNZjm3CgUbIWk | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_ENQdzvbQNrNiryOm2NPQhFnmc18Yh4Fp0f0gQFYmFlU | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_QZDJyPms3T6lDHYCbvQFF0sD1nHC1HRs1Ix54YZ6i8 | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_mWrj2tqhhIY9lLuI74Ks4zGGWP7srZO3klxwJMlgsg | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_ymNqvHCuEcVRQEfysJpY2kBJE9KwGVyjeu958mFrrlc | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_4gcPHSCwc2XVOWBJzhReq136cuwdsEF53c96SP5CiZM | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_RcDqArSfGfaeZn2uKE95hARLsahajiVremCkGWPo | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_VFjXTBzpd79LHDBOD35cNMZmSFq180m1mHusZcXs | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_MkuFXTU9755HLQp8UalGqsyAeKcQHfKk57YtkZFDXo | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_ikuxXHO2arpTpiusmpYBomyF1zAxK7cnXIVR5AyNU | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_NMn3JVcthxkgiQKXEWsmBod9iH6Hnr1ycy3Ortftdx0 | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_kYbw3Mn6uGrgzxBEykA9MbbLXnIvoKhO2ctQ2PcwVk | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_eW0uqh0FJREFmMD7whlQHSyAhOj6irJCqObW4aiI4 | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_sMoHaQ0vl3goS076Rk1HRy3vPbwvd1ZUPxUpMfGI060 | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_jHUccxnc96VFbPApwlbfl6lTh5VJX08wTcEabw81G1w | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_9IBNDu4RucbrcxK05T6CyGrZY6xBu9u2f1A7W17QDU | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_BPtRTuHp8rlvvWHijPSgBpGrAuzCnDphRfUgAxwLC8 | PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem_PressReleaseContentType;

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField = (
  { __typename?: 'LookupField' }
  & { targetItem: Types.Maybe<PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField_targetItem> }
);

export type PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePublicationDate_DateField = (
  { __typename?: 'DateField' }
  & Pick<Types.DateField, 'formattedDateValue' | 'value'>
);

export type PressReleaseDataQuery_item_Accordion = (
  { __typename?: 'Accordion' }
  & Pick<Types.Accordion, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_AccordionFolder = (
  { __typename?: 'AccordionFolder' }
  & Pick<Types.AccordionFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_AccordionFolder_03f88fb497884025b46f2cb249f4fcd6 = (
  { __typename?: 'AccordionFolder_03f88fb497884025b46f2cb249f4fcd6' }
  & Pick<Types.AccordionFolder_03f88fb497884025b46f2cb249f4fcd6, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_AccordionItem = (
  { __typename?: 'AccordionItem' }
  & Pick<Types.AccordionItem, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_AccordionItem_8cf671721b2d489e809f4c23db5ab2da = (
  { __typename?: 'AccordionItem_8cf671721b2d489e809f4c23db5ab2da' }
  & Pick<Types.AccordionItem_8cf671721b2d489e809f4c23db5ab2da, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_AccordionParametersTemplate = (
  { __typename?: 'AccordionParametersTemplate' }
  & Pick<Types.AccordionParametersTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_AccordionPresentation = (
  { __typename?: 'AccordionPresentation' }
  & Pick<Types.AccordionPresentation, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_AccordionPresentationFolder = (
  { __typename?: 'AccordionPresentationFolder' }
  & Pick<Types.AccordionPresentationFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Accordion_02d060598cc14423a9ac9ff2365176b7 = (
  { __typename?: 'Accordion_02d060598cc14423a9ac9ff2365176b7' }
  & Pick<Types.Accordion_02d060598cc14423a9ac9ff2365176b7, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1 = (
  { __typename?: 'Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1' }
  & Pick<Types.Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_AddItem = (
  { __typename?: 'AddItem' }
  & Pick<Types.AddItem, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_AddItem_1e1b739ec3784909941d171aca7362e5 = (
  { __typename?: 'AddItem_1e1b739ec3784909941d171aca7362e5' }
  & Pick<Types.AddItem_1e1b739ec3784909941d171aca7362e5, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_AddItem_3aea335cd06d45b1841acbc8d2d1ce40 = (
  { __typename?: 'AddItem_3aea335cd06d45b1841acbc8d2d1ce40' }
  & Pick<Types.AddItem_3aea335cd06d45b1841acbc8d2d1ce40, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_AddItem_de8c75222f3241288f20342f479894eb = (
  { __typename?: 'AddItem_de8c75222f3241288f20342f479894eb' }
  & Pick<Types.AddItem_De8c75222f3241288f20342f479894eb, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_AddItem_ea8a3f269ccd443a95f571b868a94bd0 = (
  { __typename?: 'AddItem_ea8a3f269ccd443a95f571b868a94bd0' }
  & Pick<Types.AddItem_Ea8a3f269ccd443a95f571b868a94bd0, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_AddThisParameters = (
  { __typename?: 'AddThisParameters' }
  & Pick<Types.AddThisParameters, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_AggregatedFacetFilter = (
  { __typename?: 'AggregatedFacetFilter' }
  & Pick<Types.AggregatedFacetFilter, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_AlertMessage = (
  { __typename?: 'AlertMessage' }
  & Pick<Types.AlertMessage, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_AlertMessageFolder = (
  { __typename?: 'AlertMessageFolder' }
  & Pick<Types.AlertMessageFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_AlertMessageParametersTemplate = (
  { __typename?: 'AlertMessageParametersTemplate' }
  & Pick<Types.AlertMessageParametersTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_AlertMessageType = (
  { __typename?: 'AlertMessageType' }
  & Pick<Types.AlertMessageType, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_AllertMessageTypeFolder = (
  { __typename?: 'AllertMessageTypeFolder' }
  & Pick<Types.AllertMessageTypeFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Archive = (
  { __typename?: 'Archive' }
  & Pick<Types.Archive, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ArticleAuthor = (
  { __typename?: 'ArticleAuthor' }
  & Pick<Types.ArticleAuthor, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ArticleAuthorsFolder = (
  { __typename?: 'ArticleAuthorsFolder' }
  & Pick<Types.ArticleAuthorsFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ArticleCategoriesFolder = (
  { __typename?: 'ArticleCategoriesFolder' }
  & Pick<Types.ArticleCategoriesFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ArticleCategory = (
  { __typename?: 'ArticleCategory' }
  & Pick<Types.ArticleCategory, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ArticleChapter = (
  { __typename?: 'ArticleChapter' }
  & Pick<Types.ArticleChapter, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ArticleChapters = (
  { __typename?: 'ArticleChapters' }
  & Pick<Types.ArticleChapters, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ArticleContentType = (
  { __typename?: 'ArticleContentType' }
  & Pick<Types.ArticleContentType, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ArticleContentTypesFolder = (
  { __typename?: 'ArticleContentTypesFolder' }
  & Pick<Types.ArticleContentTypesFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ArticleFilter = (
  { __typename?: 'ArticleFilter' }
  & Pick<Types.ArticleFilter, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ArticleFilterOption = (
  { __typename?: 'ArticleFilterOption' }
  & Pick<Types.ArticleFilterOption, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ArticleFootnote = (
  { __typename?: 'ArticleFootnote' }
  & Pick<Types.ArticleFootnote, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ArticleFootnoteLink = (
  { __typename?: 'ArticleFootnoteLink' }
  & Pick<Types.ArticleFootnoteLink, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ArticleFootnoteText = (
  { __typename?: 'ArticleFootnoteText' }
  & Pick<Types.ArticleFootnoteText, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ArticleInfogramTile = (
  { __typename?: 'ArticleInfogramTile' }
  & Pick<Types.ArticleInfogramTile, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ArticleInfogramTileParametersTemplate = (
  { __typename?: 'ArticleInfogramTileParametersTemplate' }
  & Pick<Types.ArticleInfogramTileParametersTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ArticlePage = (
  { __typename?: 'ArticlePage' }
  & Pick<Types.ArticlePage, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ArticleRegion = (
  { __typename?: 'ArticleRegion' }
  & Pick<Types.ArticleRegion, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ArticleRegionsFolder = (
  { __typename?: 'ArticleRegionsFolder' }
  & Pick<Types.ArticleRegionsFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ArticleSearchPage = (
  { __typename?: 'ArticleSearchPage' }
  & Pick<Types.ArticleSearchPage, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c = (
  { __typename?: 'ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c' }
  & Pick<Types.ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2 = (
  { __typename?: 'ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2' }
  & Pick<Types.ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ArticleSearchPage_be414ff574ac4203abb2694811443e25 = (
  { __typename?: 'ArticleSearchPage_be414ff574ac4203abb2694811443e25' }
  & Pick<Types.ArticleSearchPage_Be414ff574ac4203abb2694811443e25, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ArticleSearchPage_c7ad44ac3cab45158b619465a552a82c = (
  { __typename?: 'ArticleSearchPage_c7ad44ac3cab45158b619465a552a82c' }
  & Pick<Types.ArticleSearchPage_C7ad44ac3cab45158b619465a552a82c, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ArticleSearchPage_cf31bd740a4b4363b03d1f7a88e39907 = (
  { __typename?: 'ArticleSearchPage_cf31bd740a4b4363b03d1f7a88e39907' }
  & Pick<Types.ArticleSearchPage_Cf31bd740a4b4363b03d1f7a88e39907, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ArticleSeriesCollection = (
  { __typename?: 'ArticleSeriesCollection' }
  & Pick<Types.ArticleSeriesCollection, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ArticleSeriesFolder = (
  { __typename?: 'ArticleSeriesFolder' }
  & Pick<Types.ArticleSeriesFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ArticleSettings = (
  { __typename?: 'ArticleSettings' }
  & Pick<Types.ArticleSettings, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ArticleSubscriptionBanner = (
  { __typename?: 'ArticleSubscriptionBanner' }
  & Pick<Types.ArticleSubscriptionBanner, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ArticleSubscriptionBannerFolder = (
  { __typename?: 'ArticleSubscriptionBannerFolder' }
  & Pick<Types.ArticleSubscriptionBannerFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ArticleTag = (
  { __typename?: 'ArticleTag' }
  & Pick<Types.ArticleTag, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ArticleTagsFolder = (
  { __typename?: 'ArticleTagsFolder' }
  & Pick<Types.ArticleTagsFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ArticleTeamAuthor = (
  { __typename?: 'ArticleTeamAuthor' }
  & Pick<Types.ArticleTeamAuthor, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ArticleTileParametersTemplate = (
  { __typename?: 'ArticleTileParametersTemplate' }
  & Pick<Types.ArticleTileParametersTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ArticleTilesParametersTemplate = (
  { __typename?: 'ArticleTilesParametersTemplate' }
  & Pick<Types.ArticleTilesParametersTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f = (
  { __typename?: 'ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f' }
  & Pick<Types.ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8 = (
  { __typename?: 'ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8' }
  & Pick<Types.ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca = (
  { __typename?: 'ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca' }
  & Pick<Types.ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c = (
  { __typename?: 'ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c' }
  & Pick<Types.ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ArticleWildcardPage_405b20252077400383d3b47f09f88b47 = (
  { __typename?: 'ArticleWildcardPage_405b20252077400383d3b47f09f88b47' }
  & Pick<Types.ArticleWildcardPage_405b20252077400383d3b47f09f88b47, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ArticleWildcardPage_b037a577f5cb4ad3b79f07720a96985b = (
  { __typename?: 'ArticleWildcardPage_b037a577f5cb4ad3b79f07720a96985b' }
  & Pick<Types.ArticleWildcardPage_B037a577f5cb4ad3b79f07720a96985b, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ArticlesGroupFolder = (
  { __typename?: 'ArticlesGroupFolder' }
  & Pick<Types.ArticlesGroupFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_AttachThemeExtension = (
  { __typename?: 'AttachThemeExtension' }
  & Pick<Types.AttachThemeExtension, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_AutomaticDocumentListings = (
  { __typename?: 'AutomaticDocumentListings' }
  & Pick<Types.AutomaticDocumentListings, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_AutomaticDocumentListingsFolder = (
  { __typename?: 'AutomaticDocumentListingsFolder' }
  & Pick<Types.AutomaticDocumentListingsFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_AvailableJSONRenderings = (
  { __typename?: 'AvailableJSONRenderings' }
  & Pick<Types.AvailableJsonRenderings, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_AvailableMetaRenderings = (
  { __typename?: 'AvailableMetaRenderings' }
  & Pick<Types.AvailableMetaRenderings, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_AvailableRenderings = (
  { __typename?: 'AvailableRenderings' }
  & Pick<Types.AvailableRenderings, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb = (
  { __typename?: 'AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb' }
  & Pick<Types.AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_AwardsBanner = (
  { __typename?: 'AwardsBanner' }
  & Pick<Types.AwardsBanner, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_AwardsBannerFolder = (
  { __typename?: 'AwardsBannerFolder' }
  & Pick<Types.AwardsBannerFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_AwardsBannerImage = (
  { __typename?: 'AwardsBannerImage' }
  & Pick<Types.AwardsBannerImage, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_AwardsBannerParametersTemplate = (
  { __typename?: 'AwardsBannerParametersTemplate' }
  & Pick<Types.AwardsBannerParametersTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_BYOCWrapperRenderingParameters = (
  { __typename?: 'BYOCWrapperRenderingParameters' }
  & Pick<Types.ByocWrapperRenderingParameters, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_BackgroundColorOption = (
  { __typename?: 'BackgroundColorOption' }
  & Pick<Types.BackgroundColorOption, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_BackgroundColorOptionFolder = (
  { __typename?: 'BackgroundColorOptionFolder' }
  & Pick<Types.BackgroundColorOptionFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_BannerFolder = (
  { __typename?: 'BannerFolder' }
  & Pick<Types.BannerFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_BannerType = (
  { __typename?: 'BannerType' }
  & Pick<Types.BannerType, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_BannerTypeFolder = (
  { __typename?: 'BannerTypeFolder' }
  & Pick<Types.BannerTypeFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_BaseHeading = (
  { __typename?: 'BaseHeading' }
  & Pick<Types.BaseHeading, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_BaseHeadingFolder = (
  { __typename?: 'BaseHeadingFolder' }
  & Pick<Types.BaseHeadingFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_BoolFacet = (
  { __typename?: 'BoolFacet' }
  & Pick<Types.BoolFacet, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_BranchesFolder = (
  { __typename?: 'BranchesFolder' }
  & Pick<Types.BranchesFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Breadcrumb = (
  { __typename?: 'Breadcrumb' }
  & Pick<Types.Breadcrumb, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_BrowserTitleDefinition = (
  { __typename?: 'BrowserTitleDefinition' }
  & Pick<Types.BrowserTitleDefinition, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_CORSEntry = (
  { __typename?: 'CORSEntry' }
  & Pick<Types.CorsEntry, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_CORSGrouping = (
  { __typename?: 'CORSGrouping' }
  & Pick<Types.CorsGrouping, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_CTAPresentationType = (
  { __typename?: 'CTAPresentationType' }
  & Pick<Types.CtaPresentationType, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_CTAPresentationTypeFolder = (
  { __typename?: 'CTAPresentationTypeFolder' }
  & Pick<Types.CtaPresentationTypeFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__AbrdnPage = (
  { __typename?: 'C__AbrdnPage' }
  & Pick<Types.C__AbrdnPage, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__ActionBase = (
  { __typename?: 'C__ActionBase' }
  & Pick<Types.C__ActionBase, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__AdvancedParameter = (
  { __typename?: 'C__AdvancedParameter' }
  & Pick<Types.C__AdvancedParameter, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__App = (
  { __typename?: 'C__App' }
  & Pick<Types.C__App, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c = (
  { __typename?: 'C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c' }
  & Pick<Types.C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__ArticleWildcardPage = (
  { __typename?: 'C__ArticleWildcardPage' }
  & Pick<Types.C__ArticleWildcardPage, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__AvailableRenderingsFolder = (
  { __typename?: 'C__AvailableRenderingsFolder' }
  & Pick<Types.C__AvailableRenderingsFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__BYOCRenderingParameters = (
  { __typename?: 'C__BYOCRenderingParameters' }
  & Pick<Types.C__ByocRenderingParameters, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__BackgroundParametersTemplate = (
  { __typename?: 'C__BackgroundParametersTemplate' }
  & Pick<Types.C__BackgroundParametersTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__BaseCTA = (
  { __typename?: 'C__BaseCTA' }
  & Pick<Types.C__BaseCta, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__BasePage = (
  { __typename?: 'C__BasePage' }
  & Pick<Types.C__BasePage, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__BasePage_037da552a5524fe4aeee331f57ac1378 = (
  { __typename?: 'C__BasePage_037da552a5524fe4aeee331f57ac1378' }
  & Pick<Types.C__BasePage_037da552a5524fe4aeee331f57ac1378, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f = (
  { __typename?: 'C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f' }
  & Pick<Types.C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__BasePage_315fd21bebf04c9d9f00bae191442f1d = (
  { __typename?: 'C__BasePage_315fd21bebf04c9d9f00bae191442f1d' }
  & Pick<Types.C__BasePage_315fd21bebf04c9d9f00bae191442f1d, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd = (
  { __typename?: 'C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd' }
  & Pick<Types.C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__BasePage_728c97b5c56146d9807e21018a972bb5 = (
  { __typename?: 'C__BasePage_728c97b5c56146d9807e21018a972bb5' }
  & Pick<Types.C__BasePage_728c97b5c56146d9807e21018a972bb5, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__BasePage_6105875085f346729dfc8d133b481f26 = (
  { __typename?: 'C__BasePage_6105875085f346729dfc8d133b481f26' }
  & Pick<Types.C__BasePage_6105875085f346729dfc8d133b481f26, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__BasePage_b08130ebd3314a3b9c0f2b5e9b66387b = (
  { __typename?: 'C__BasePage_b08130ebd3314a3b9c0f2b5e9b66387b' }
  & Pick<Types.C__BasePage_B08130ebd3314a3b9c0f2b5e9b66387b, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__BaseRenderingParameters = (
  { __typename?: 'C__BaseRenderingParameters' }
  & Pick<Types.C__BaseRenderingParameters, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__BaseTheme = (
  { __typename?: 'C__BaseTheme' }
  & Pick<Types.C__BaseTheme, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__BaseVariantField = (
  { __typename?: 'C__BaseVariantField' }
  & Pick<Types.C__BaseVariantField, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__Class = (
  { __typename?: 'C__Class' }
  & Pick<Types.C__Class, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__CompositeGroup = (
  { __typename?: 'C__CompositeGroup' }
  & Pick<Types.C__CompositeGroup, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__CompositeSection = (
  { __typename?: 'C__CompositeSection' }
  & Pick<Types.C__CompositeSection, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__EloquaForm = (
  { __typename?: 'C__EloquaForm' }
  & Pick<Types.C__EloquaForm, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__ErrorPage_d40dd5cadbf1461191b8f9e1071e557d = (
  { __typename?: 'C__ErrorPage_d40dd5cadbf1461191b8f9e1071e557d' }
  & Pick<Types.C__ErrorPage_D40dd5cadbf1461191b8f9e1071e557d, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__ExtendedOptions = (
  { __typename?: 'C__ExtendedOptions' }
  & Pick<Types.C__ExtendedOptions, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__ExtendedOptions_2964fb4257a6440fb192218443904c90 = (
  { __typename?: 'C__ExtendedOptions_2964fb4257a6440fb192218443904c90' }
  & Pick<Types.C__ExtendedOptions_2964fb4257a6440fb192218443904c90, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__ExtendedOptions_f1850030f97848b4bdb5884b7e863160 = (
  { __typename?: 'C__ExtendedOptions_f1850030f97848b4bdb5884b7e863160' }
  & Pick<Types.C__ExtendedOptions_F1850030f97848b4bdb5884b7e863160, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__FEaaSRenderingParameters = (
  { __typename?: 'C__FEaaSRenderingParameters' }
  & Pick<Types.C__FEaaSRenderingParameters, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__FacetSelectorConfigBase = (
  { __typename?: 'C__FacetSelectorConfigBase' }
  & Pick<Types.C__FacetSelectorConfigBase, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845 = (
  { __typename?: 'C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845' }
  & Pick<Types.C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b = (
  { __typename?: 'C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b' }
  & Pick<Types.C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__FundDetailsWildcardPage_fb127f7aeeba46458c5fbe9f7c589303 = (
  { __typename?: 'C__FundDetailsWildcardPage_fb127f7aeeba46458c5fbe9f7c589303' }
  & Pick<Types.C__FundDetailsWildcardPage_Fb127f7aeeba46458c5fbe9f7c589303, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__FundSearchPage_d83da2a5ce9042b6bd557aa8820c62c5 = (
  { __typename?: 'C__FundSearchPage_d83da2a5ce9042b6bd557aa8820c62c5' }
  & Pick<Types.C__FundSearchPage_D83da2a5ce9042b6bd557aa8820c62c5, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__FundShareclassDetailsWildcardPage_e3590ad764a84980a419c4f1f926f9fc = (
  { __typename?: 'C__FundShareclassDetailsWildcardPage_e3590ad764a84980a419c4f1f926f9fc' }
  & Pick<Types.C__FundShareclassDetailsWildcardPage_E3590ad764a84980a419c4f1f926f9fc, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__GlobalDatasourceBehavior = (
  { __typename?: 'C__GlobalDatasourceBehavior' }
  & Pick<Types.C__GlobalDatasourceBehavior, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__GridDefinition = (
  { __typename?: 'C__GridDefinition' }
  & Pick<Types.C__GridDefinition, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__GridItemBase = (
  { __typename?: 'C__GridItemBase' }
  & Pick<Types.C__GridItemBase, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__GridParameters = (
  { __typename?: 'C__GridParameters' }
  & Pick<Types.C__GridParameters, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__HeadlessSite = (
  { __typename?: 'C__HeadlessSite' }
  & Pick<Types.C__HeadlessSite, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__HeadlessTenant = (
  { __typename?: 'C__HeadlessTenant' }
  & Pick<Types.C__HeadlessTenant, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__HelpArticleSearchPage_d1c4d91365c8401389dcde7b5fb2f28b = (
  { __typename?: 'C__HelpArticleSearchPage_d1c4d91365c8401389dcde7b5fb2f28b' }
  & Pick<Types.C__HelpArticleSearchPage_D1c4d91365c8401389dcde7b5fb2f28b, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__HelpArticleWildcardPage_c0a939305f6e47a38739f2a8f300e65d = (
  { __typename?: 'C__HelpArticleWildcardPage_c0a939305f6e47a38739f2a8f300e65d' }
  & Pick<Types.C__HelpArticleWildcardPage_C0a939305f6e47a38739f2a8f300e65d, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d = (
  { __typename?: 'C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d' }
  & Pick<Types.C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__IAllowEmpty = (
  { __typename?: 'C__IAllowEmpty' }
  & Pick<Types.C__IAllowEmpty, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__IBaseVariantDefinition = (
  { __typename?: 'C__IBaseVariantDefinition' }
  & Pick<Types.C__IBaseVariantDefinition, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__IBoosting = (
  { __typename?: 'C__IBoosting' }
  & Pick<Types.C__IBoosting, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__ICacheable = (
  { __typename?: 'C__ICacheable' }
  & Pick<Types.C__ICacheable, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__ICompatibleRenderings = (
  { __typename?: 'C__ICompatibleRenderings' }
  & Pick<Types.C__ICompatibleRenderings, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__IComponentVariant = (
  { __typename?: 'C__IComponentVariant' }
  & Pick<Types.C__IComponentVariant, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__IControlType = (
  { __typename?: 'C__IControlType' }
  & Pick<Types.C__IControlType, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__IDynamicPlaceholder = (
  { __typename?: 'C__IDynamicPlaceholder' }
  & Pick<Types.C__IDynamicPlaceholder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__IFEaaSComponentsDataSourceTemplates = (
  { __typename?: 'C__IFEaaSComponentsDataSourceTemplates' }
  & Pick<Types.C__IfEaaSComponentsDataSourceTemplates, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__IFEaaSComponentsEditorScriptURL = (
  { __typename?: 'C__IFEaaSComponentsEditorScriptURL' }
  & Pick<Types.C__IfEaaSComponentsEditorScriptUrl, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__IIcon = (
  { __typename?: 'C__IIcon' }
  & Pick<Types.C__IIcon, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__ILocation = (
  { __typename?: 'C__ILocation' }
  & Pick<Types.C__ILocation, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__IPaginable = (
  { __typename?: 'C__IPaginable' }
  & Pick<Types.C__IPaginable, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__IPagination = (
  { __typename?: 'C__IPagination' }
  & Pick<Types.C__IPagination, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__IPoi = (
  { __typename?: 'C__IPoi' }
  & Pick<Types.C__IPoi, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__IRenderingId = (
  { __typename?: 'C__IRenderingId' }
  & Pick<Types.C__IRenderingId, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__ISplitter = (
  { __typename?: 'C__ISplitter' }
  & Pick<Types.C__ISplitter, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__IStyling = (
  { __typename?: 'C__IStyling' }
  & Pick<Types.C__IStyling, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__IVariantDefinition = (
  { __typename?: 'C__IVariantDefinition' }
  & Pick<Types.C__IVariantDefinition, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__InvestmentTrustPage = (
  { __typename?: 'C__InvestmentTrustPage' }
  & Pick<Types.C__InvestmentTrustPage, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__JSONField = (
  { __typename?: 'C__JSONField' }
  & Pick<Types.C__JsonField, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__JSONReference = (
  { __typename?: 'C__JSONReference' }
  & Pick<Types.C__JsonReference, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__JSSData = (
  { __typename?: 'C__JSSData' }
  & Pick<Types.C__JssData, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__JSSSettings = (
  { __typename?: 'C__JSSSettings' }
  & Pick<Types.C__JssSettings, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__JSSSiteFolder = (
  { __typename?: 'C__JSSSiteFolder' }
  & Pick<Types.C__JssSiteFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__JssRootFolder = (
  { __typename?: 'C__JssRootFolder' }
  & Pick<Types.C__JssRootFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086 = (
  { __typename?: 'C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086' }
  & Pick<Types.C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__Navigation_e6d98f24d01c419e871a4617125a49ed = (
  { __typename?: 'C__Navigation_e6d98f24d01c419e871a4617125a49ed' }
  & Pick<Types.C__Navigation_E6d98f24d01c419e871a4617125a49ed, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__Page = (
  { __typename?: 'C__Page' }
  & Pick<Types.C__Page, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__PageData = (
  { __typename?: 'C__PageData' }
  & Pick<Types.C__PageData, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__PageDesignFolder = (
  { __typename?: 'C__PageDesignFolder' }
  & Pick<Types.C__PageDesignFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd = (
  { __typename?: 'C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd' }
  & Pick<Types.C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__PageDesigns_daaf41fd96db4892be99f62f16d036c4 = (
  { __typename?: 'C__PageDesigns_daaf41fd96db4892be99f62f16d036c4' }
  & Pick<Types.C__PageDesigns_Daaf41fd96db4892be99f62f16d036c4, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__PartialDesign = (
  { __typename?: 'C__PartialDesign' }
  & Pick<Types.C__PartialDesign, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__PartialDesignFolder = (
  { __typename?: 'C__PartialDesignFolder' }
  & Pick<Types.C__PartialDesignFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d = (
  { __typename?: 'C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d' }
  & Pick<Types.C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d = (
  { __typename?: 'C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d' }
  & Pick<Types.C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__PlaceholderWrapper = (
  { __typename?: 'C__PlaceholderWrapper' }
  & Pick<Types.C__PlaceholderWrapper, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac = (
  { __typename?: 'C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac' }
  & Pick<Types.C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b = (
  { __typename?: 'C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b' }
  & Pick<Types.C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__RedirectMapGrouping = (
  { __typename?: 'C__RedirectMapGrouping' }
  & Pick<Types.C__RedirectMapGrouping, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973 = (
  { __typename?: 'C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973' }
  & Pick<Types.C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__Route = (
  { __typename?: 'C__Route' }
  & Pick<Types.C__Route, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__SimpleVideo = (
  { __typename?: 'C__SimpleVideo' }
  & Pick<Types.C__SimpleVideo, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__SiteSettingsFolder = (
  { __typename?: 'C__SiteSettingsFolder' }
  & Pick<Types.C__SiteSettingsFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__SitemapSettings = (
  { __typename?: 'C__SitemapSettings' }
  & Pick<Types.C__SitemapSettings, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__StandardTemplate = (
  { __typename?: 'C__StandardTemplate' }
  & Pick<Types.C__StandardTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c = (
  { __typename?: 'C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c' }
  & Pick<Types.C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65 = (
  { __typename?: 'C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65' }
  & Pick<Types.C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__TrustFolder = (
  { __typename?: 'C__TrustFolder' }
  & Pick<Types.C__TrustFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__VariantDefinition = (
  { __typename?: 'C__VariantDefinition' }
  & Pick<Types.C__VariantDefinition, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__VariantField = (
  { __typename?: 'C__VariantField' }
  & Pick<Types.C__VariantField, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C__VariantsGrouping = (
  { __typename?: 'C__VariantsGrouping' }
  & Pick<Types.C__VariantsGrouping, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___AdvancedItem = (
  { __typename?: 'C___AdvancedItem' }
  & Pick<Types.C___AdvancedItem, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___Arguments = (
  { __typename?: 'C___Arguments' }
  & Pick<Types.C___Arguments, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___Arguments_33fab87cd52f44319a1f589ba7c1e287 = (
  { __typename?: 'C___Arguments_33fab87cd52f44319a1f589ba7c1e287' }
  & Pick<Types.C___Arguments_33fab87cd52f44319a1f589ba7c1e287, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___Article = (
  { __typename?: 'C___Article' }
  & Pick<Types.C___Article, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___ArticlePageWorkflow = (
  { __typename?: 'C___ArticlePageWorkflow' }
  & Pick<Types.C___ArticlePageWorkflow, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___ArticleSearchPage = (
  { __typename?: 'C___ArticleSearchPage' }
  & Pick<Types.C___ArticleSearchPage, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___ArticleWildcard = (
  { __typename?: 'C___ArticleWildcard' }
  & Pick<Types.C___ArticleWildcard, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___AssetServiceThemeMode = (
  { __typename?: 'C___AssetServiceThemeMode' }
  & Pick<Types.C___AssetServiceThemeMode, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___BaseArticle = (
  { __typename?: 'C___BaseArticle' }
  & Pick<Types.C___BaseArticle, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___BaseDataFolder = (
  { __typename?: 'C___BaseDataFolder' }
  & Pick<Types.C___BaseDataFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___BaseHelpArticle = (
  { __typename?: 'C___BaseHelpArticle' }
  & Pick<Types.C___BaseHelpArticle, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___BaseInvestmentTrust = (
  { __typename?: 'C___BaseInvestmentTrust' }
  & Pick<Types.C___BaseInvestmentTrust, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___BaseJSSTenant = (
  { __typename?: 'C___BaseJSSTenant' }
  & Pick<Types.C___BaseJssTenant, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___BasePage = (
  { __typename?: 'C___BasePage' }
  & Pick<Types.C___BasePage, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___BasePageDesign = (
  { __typename?: 'C___BasePageDesign' }
  & Pick<Types.C___BasePageDesign, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___BasePageDesignFolder = (
  { __typename?: 'C___BasePageDesignFolder' }
  & Pick<Types.C___BasePageDesignFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___BasePartialDesign = (
  { __typename?: 'C___BasePartialDesign' }
  & Pick<Types.C___BasePartialDesign, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___BasePartialDesignFolder = (
  { __typename?: 'C___BasePartialDesignFolder' }
  & Pick<Types.C___BasePartialDesignFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___BasePlaceholder = (
  { __typename?: 'C___BasePlaceholder' }
  & Pick<Types.C___BasePlaceholder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___BasePlaceholderSettingsFolder = (
  { __typename?: 'C___BasePlaceholderSettingsFolder' }
  & Pick<Types.C___BasePlaceholderSettingsFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___BasePresentation = (
  { __typename?: 'C___BasePresentation' }
  & Pick<Types.C___BasePresentation, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___BasePressRelease = (
  { __typename?: 'C___BasePressRelease' }
  & Pick<Types.C___BasePressRelease, 'id'>
  & { pressReleaseTitle: Types.Maybe<PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseTitle_TextField>, pressReleaseDescription: Types.Maybe<PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseDescription_TextField>, pressReleasePlatform: Types.Maybe<PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField>, pressReleaseContentType: Types.Maybe<PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField>, pressReleasePublicationDate: Types.Maybe<PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePublicationDate_DateField>, template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___BaseRenderingParameters = (
  { __typename?: 'C___BaseRenderingParameters' }
  & Pick<Types.C___BaseRenderingParameters, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___BaseSXAStandardValuesFolder = (
  { __typename?: 'C___BaseSXAStandardValuesFolder' }
  & Pick<Types.C___BaseSxaStandardValuesFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___BaseSettings = (
  { __typename?: 'C___BaseSettings' }
  & Pick<Types.C___BaseSettings, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___BaseSharedSitesSettings = (
  { __typename?: 'C___BaseSharedSitesSettings' }
  & Pick<Types.C___BaseSharedSitesSettings, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___BaseSiteDefinition = (
  { __typename?: 'C___BaseSiteDefinition' }
  & Pick<Types.C___BaseSiteDefinition, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___BaseSiteFolder = (
  { __typename?: 'C___BaseSiteFolder' }
  & Pick<Types.C___BaseSiteFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___BaseSiteGrouping = (
  { __typename?: 'C___BaseSiteGrouping' }
  & Pick<Types.C___BaseSiteGrouping, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___BaseSiteRoot = (
  { __typename?: 'C___BaseSiteRoot' }
  & Pick<Types.C___BaseSiteRoot, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___BaseTenant = (
  { __typename?: 'C___BaseTenant' }
  & Pick<Types.C___BaseTenant, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___BaseTenantFolder = (
  { __typename?: 'C___BaseTenantFolder' }
  & Pick<Types.C___BaseTenantFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___BucketRules = (
  { __typename?: 'C___BucketRules' }
  & Pick<Types.C___BucketRules, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___CORS = (
  { __typename?: 'C___CORS' }
  & Pick<Types.C___Cors, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___Content = (
  { __typename?: 'C___Content' }
  & Pick<Types.C___Content, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___ContentType = (
  { __typename?: 'C___ContentType' }
  & Pick<Types.C___ContentType, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___DataAttributes = (
  { __typename?: 'C___DataAttributes' }
  & Pick<Types.C___DataAttributes, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___DatasourceWorkflow = (
  { __typename?: 'C___DatasourceWorkflow' }
  & Pick<Types.C___DatasourceWorkflow, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___Dependencies = (
  { __typename?: 'C___Dependencies' }
  & Pick<Types.C___Dependencies, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___Description = (
  { __typename?: 'C___Description' }
  & Pick<Types.C___Description, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___DesignTemplateMapping = (
  { __typename?: 'C___DesignTemplateMapping' }
  & Pick<Types.C___DesignTemplateMapping, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___Designable = (
  { __typename?: 'C___Designable' }
  & Pick<Types.C___Designable, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___EditType = (
  { __typename?: 'C___EditType' }
  & Pick<Types.C___EditType, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___EditType_8a9f84baaa124c5d9096935714809da4 = (
  { __typename?: 'C___EditType_8a9f84baaa124c5d9096935714809da4' }
  & Pick<Types.C___EditType_8a9f84baaa124c5d9096935714809da4, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___EditingTheme = (
  { __typename?: 'C___EditingTheme' }
  & Pick<Types.C___EditingTheme, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___Enabled = (
  { __typename?: 'C___Enabled' }
  & Pick<Types.C___Enabled, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___ErrorHandling = (
  { __typename?: 'C___ErrorHandling' }
  & Pick<Types.C___ErrorHandling, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___ExternalArticle = (
  { __typename?: 'C___ExternalArticle' }
  & Pick<Types.C___ExternalArticle, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___Fields = (
  { __typename?: 'C___Fields' }
  & Pick<Types.C___Fields, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___FilteredArticlesParent = (
  { __typename?: 'C___FilteredArticlesParent' }
  & Pick<Types.C___FilteredArticlesParent, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___FilteredArticlesWildcard = (
  { __typename?: 'C___FilteredArticlesWildcard' }
  & Pick<Types.C___FilteredArticlesWildcard, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___Footnotes = (
  { __typename?: 'C___Footnotes' }
  & Pick<Types.C___Footnotes, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___FundDetailsWildcard = (
  { __typename?: 'C___FundDetailsWildcard' }
  & Pick<Types.C___FundDetailsWildcard, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___FundFormAvailability = (
  { __typename?: 'C___FundFormAvailability' }
  & Pick<Types.C___FundFormAvailability, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___FundMetadataPage = (
  { __typename?: 'C___FundMetadataPage' }
  & Pick<Types.C___FundMetadataPage, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___FundSearchPage = (
  { __typename?: 'C___FundSearchPage' }
  & Pick<Types.C___FundSearchPage, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___FundsFolder = (
  { __typename?: 'C___FundsFolder' }
  & Pick<Types.C___FundsFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___FundsFormsFolder = (
  { __typename?: 'C___FundsFormsFolder' }
  & Pick<Types.C___FundsFormsFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___FundsLiteratureFolder = (
  { __typename?: 'C___FundsLiteratureFolder' }
  & Pick<Types.C___FundsLiteratureFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___FundsShareclassesDetailsWildcard = (
  { __typename?: 'C___FundsShareclassesDetailsWildcard' }
  & Pick<Types.C___FundsShareclassesDetailsWildcard, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___GridMapping = (
  { __typename?: 'C___GridMapping' }
  & Pick<Types.C___GridMapping, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___HelpArticle = (
  { __typename?: 'C___HelpArticle' }
  & Pick<Types.C___HelpArticle, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___HelpArticleSearchPage = (
  { __typename?: 'C___HelpArticleSearchPage' }
  & Pick<Types.C___HelpArticleSearchPage, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___HelpArticleWildcard = (
  { __typename?: 'C___HelpArticleWildcard' }
  & Pick<Types.C___HelpArticleWildcard, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___HorizonDatasourceGrouping = (
  { __typename?: 'C___HorizonDatasourceGrouping' }
  & Pick<Types.C___HorizonDatasourceGrouping, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___Icon = (
  { __typename?: 'C___Icon' }
  & Pick<Types.C___Icon, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___IncludeByDefault = (
  { __typename?: 'C___IncludeByDefault' }
  & Pick<Types.C___IncludeByDefault, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___IncludeIfInstalled = (
  { __typename?: 'C___IncludeIfInstalled' }
  & Pick<Types.C___IncludeIfInstalled, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___InternalArticle = (
  { __typename?: 'C___InternalArticle' }
  & Pick<Types.C___InternalArticle, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___InternetExplorerCompatibilityMode = (
  { __typename?: 'C___InternetExplorerCompatibilityMode' }
  & Pick<Types.C___InternetExplorerCompatibilityMode, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___IsSystemModule = (
  { __typename?: 'C___IsSystemModule' }
  & Pick<Types.C___IsSystemModule, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___JSONVariantPaging = (
  { __typename?: 'C___JSONVariantPaging' }
  & Pick<Types.C___JsonVariantPaging, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___JSONVariantsBase = (
  { __typename?: 'C___JSONVariantsBase' }
  & Pick<Types.C___JsonVariantsBase, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___LimitedDisplay = (
  { __typename?: 'C___LimitedDisplay' }
  & Pick<Types.C___LimitedDisplay, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___LinkAttributes = (
  { __typename?: 'C___LinkAttributes' }
  & Pick<Types.C___LinkAttributes, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___LinkSettings = (
  { __typename?: 'C___LinkSettings' }
  & Pick<Types.C___LinkSettings, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___LiteratureHubSearchPage = (
  { __typename?: 'C___LiteratureHubSearchPage' }
  & Pick<Types.C___LiteratureHubSearchPage, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___ManualKeyInformation = (
  { __typename?: 'C___ManualKeyInformation' }
  & Pick<Types.C___ManualKeyInformation, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___MemberOf = (
  { __typename?: 'C___MemberOf' }
  & Pick<Types.C___MemberOf, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___MetadataPage = (
  { __typename?: 'C___MetadataPage' }
  & Pick<Types.C___MetadataPage, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___Modules = (
  { __typename?: 'C___Modules' }
  & Pick<Types.C___Modules, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___Name = (
  { __typename?: 'C___Name' }
  & Pick<Types.C___Name, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d = (
  { __typename?: 'C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d' }
  & Pick<Types.C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___Name_299cdb154745448a807868d401248eaa = (
  { __typename?: 'C___Name_299cdb154745448a807868d401248eaa' }
  & Pick<Types.C___Name_299cdb154745448a807868d401248eaa, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___Name_b88cf88159a54a19991e71038751cb60 = (
  { __typename?: 'C___Name_b88cf88159a54a19991e71038751cb60' }
  & Pick<Types.C___Name_B88cf88159a54a19991e71038751cb60, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___Navigable = (
  { __typename?: 'C___Navigable' }
  & Pick<Types.C___Navigable, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___NavigablePage = (
  { __typename?: 'C___NavigablePage' }
  & Pick<Types.C___NavigablePage, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___PageContent = (
  { __typename?: 'C___PageContent' }
  & Pick<Types.C___PageContent, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___PageWorkflow = (
  { __typename?: 'C___PageWorkflow' }
  & Pick<Types.C___PageWorkflow, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___PerSiteStandardValues = (
  { __typename?: 'C___PerSiteStandardValues' }
  & Pick<Types.C___PerSiteStandardValues, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___Podcast = (
  { __typename?: 'C___Podcast' }
  & Pick<Types.C___Podcast, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___PodcastPressRelease = (
  { __typename?: 'C___PodcastPressRelease' }
  & Pick<Types.C___PodcastPressRelease, 'id'>
  & { pressReleaseTitle: Types.Maybe<PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseTitle_TextField>, pressReleaseDescription: Types.Maybe<PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseDescription_TextField>, pressReleasePlatform: Types.Maybe<PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField>, pressReleaseContentType: Types.Maybe<PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField>, pressReleasePublicationDate: Types.Maybe<PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePublicationDate_DateField>, template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___PremiumContentPage = (
  { __typename?: 'C___PremiumContentPage' }
  & Pick<Types.C___PremiumContentPage, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___PressRelease = (
  { __typename?: 'C___PressRelease' }
  & Pick<Types.C___PressRelease, 'id'>
  & { pressReleaseTitle: Types.Maybe<PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseTitle_TextField>, pressReleaseDescription: Types.Maybe<PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseDescription_TextField>, pressReleasePlatform: Types.Maybe<PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField>, pressReleaseContentType: Types.Maybe<PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField>, pressReleasePublicationDate: Types.Maybe<PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePublicationDate_DateField>, template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___PressReleaseContentType = (
  { __typename?: 'C___PressReleaseContentType' }
  & Pick<Types.C___PressReleaseContentType, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___PressReleaseSearchPage = (
  { __typename?: 'C___PressReleaseSearchPage' }
  & Pick<Types.C___PressReleaseSearchPage, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___PressReleaseWildcard = (
  { __typename?: 'C___PressReleaseWildcard' }
  & Pick<Types.C___PressReleaseWildcard, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___ProtectedTheme = (
  { __typename?: 'C___ProtectedTheme' }
  & Pick<Types.C___ProtectedTheme, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___PublishingGroupingTemplate = (
  { __typename?: 'C___PublishingGroupingTemplate' }
  & Pick<Types.C___PublishingGroupingTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___RenderingRelatedParameters = (
  { __typename?: 'C___RenderingRelatedParameters' }
  & Pick<Types.C___RenderingRelatedParameters, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___RenderingVariantsBase = (
  { __typename?: 'C___RenderingVariantsBase' }
  & Pick<Types.C___RenderingVariantsBase, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___RenderingsList = (
  { __typename?: 'C___RenderingsList' }
  & Pick<Types.C___RenderingsList, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___RobotsContent = (
  { __typename?: 'C___RobotsContent' }
  & Pick<Types.C___RobotsContent, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___RoleDomain = (
  { __typename?: 'C___RoleDomain' }
  & Pick<Types.C___RoleDomain, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___RoleName = (
  { __typename?: 'C___RoleName' }
  & Pick<Types.C___RoleName, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___RoleType = (
  { __typename?: 'C___RoleType' }
  & Pick<Types.C___RoleType, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___SalesforceCommonValidations = (
  { __typename?: 'C___SalesforceCommonValidations' }
  & Pick<Types.C___SalesforceCommonValidations, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___SalesforceFieldId = (
  { __typename?: 'C___SalesforceFieldId' }
  & Pick<Types.C___SalesforceFieldId, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___SalesforceFieldTitle = (
  { __typename?: 'C___SalesforceFieldTitle' }
  & Pick<Types.C___SalesforceFieldTitle, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___SalesforceFieldValue = (
  { __typename?: 'C___SalesforceFieldValue' }
  & Pick<Types.C___SalesforceFieldValue, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___Script = (
  { __typename?: 'C___Script' }
  & Pick<Types.C___Script, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___SearchSignature = (
  { __typename?: 'C___SearchSignature' }
  & Pick<Types.C___SearchSignature, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___Searchable = (
  { __typename?: 'C___Searchable' }
  & Pick<Types.C___Searchable, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___SecurityItemPointer = (
  { __typename?: 'C___SecurityItemPointer' }
  & Pick<Types.C___SecurityItemPointer, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___SharedArticles = (
  { __typename?: 'C___SharedArticles' }
  & Pick<Types.C___SharedArticles, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___SharedContent = (
  { __typename?: 'C___SharedContent' }
  & Pick<Types.C___SharedContent, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___SharedHelpArticles = (
  { __typename?: 'C___SharedHelpArticles' }
  & Pick<Types.C___SharedHelpArticles, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___SharedPage = (
  { __typename?: 'C___SharedPage' }
  & Pick<Types.C___SharedPage, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___SharedPressReleases = (
  { __typename?: 'C___SharedPressReleases' }
  & Pick<Types.C___SharedPressReleases, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___SharedRoot = (
  { __typename?: 'C___SharedRoot' }
  & Pick<Types.C___SharedRoot, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___SharedSettings = (
  { __typename?: 'C___SharedSettings' }
  & Pick<Types.C___SharedSettings, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___SiteContent = (
  { __typename?: 'C___SiteContent' }
  & Pick<Types.C___SiteContent, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___SiteFolder = (
  { __typename?: 'C___SiteFolder' }
  & Pick<Types.C___SiteFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___SiteMediaLibrary = (
  { __typename?: 'C___SiteMediaLibrary' }
  & Pick<Types.C___SiteMediaLibrary, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___SiteSettings = (
  { __typename?: 'C___SiteSettings' }
  & Pick<Types.C___SiteSettings, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___SiteTemplate = (
  { __typename?: 'C___SiteTemplate' }
  & Pick<Types.C___SiteTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___SitecoreClientSiteManaging = (
  { __typename?: 'C___SitecoreClientSiteManaging' }
  & Pick<Types.C___SitecoreClientSiteManaging, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___Sitemap = (
  { __typename?: 'C___Sitemap' }
  & Pick<Types.C___Sitemap, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___SitemapMediaItems = (
  { __typename?: 'C___SitemapMediaItems' }
  & Pick<Types.C___SitemapMediaItems, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___SlidersRangeSettings = (
  { __typename?: 'C___SlidersRangeSettings' }
  & Pick<Types.C___SlidersRangeSettings, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___SolutionTemplateContent = (
  { __typename?: 'C___SolutionTemplateContent' }
  & Pick<Types.C___SolutionTemplateContent, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___SolutionTemplateDescription = (
  { __typename?: 'C___SolutionTemplateDescription' }
  & Pick<Types.C___SolutionTemplateDescription, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___SolutionTemplateName = (
  { __typename?: 'C___SolutionTemplateName' }
  & Pick<Types.C___SolutionTemplateName, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___SortOrder = (
  { __typename?: 'C___SortOrder' }
  & Pick<Types.C___SortOrder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___StackBreakpoint = (
  { __typename?: 'C___StackBreakpoint' }
  & Pick<Types.C___StackBreakpoint, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___Statistics = (
  { __typename?: 'C___Statistics' }
  & Pick<Types.C___Statistics, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___SupportedLanguages = (
  { __typename?: 'C___SupportedLanguages' }
  & Pick<Types.C___SupportedLanguages, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___Taggable = (
  { __typename?: 'C___Taggable' }
  & Pick<Types.C___Taggable, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___TeamMembersParentPage = (
  { __typename?: 'C___TeamMembersParentPage' }
  & Pick<Types.C___TeamMembersParentPage, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___TeamMembersWildcard = (
  { __typename?: 'C___TeamMembersWildcard' }
  & Pick<Types.C___TeamMembersWildcard, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___TechzoneArticle = (
  { __typename?: 'C___TechzoneArticle' }
  & Pick<Types.C___TechzoneArticle, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___Template = (
  { __typename?: 'C___Template' }
  & Pick<Types.C___Template, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___Title = (
  { __typename?: 'C___Title' }
  & Pick<Types.C___Title, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___Type = (
  { __typename?: 'C___Type' }
  & Pick<Types.C___Type, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___Validation = (
  { __typename?: 'C___Validation' }
  & Pick<Types.C___Validation, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___VariantPaging = (
  { __typename?: 'C___VariantPaging' }
  & Pick<Types.C___VariantPaging, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___VectorTile = (
  { __typename?: 'C___VectorTile' }
  & Pick<Types.C___VectorTile, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___VectorTileLink = (
  { __typename?: 'C___VectorTileLink' }
  & Pick<Types.C___VectorTileLink, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___Video = (
  { __typename?: 'C___Video' }
  & Pick<Types.C___Video, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___VideoPressRelease = (
  { __typename?: 'C___VideoPressRelease' }
  & Pick<Types.C___VideoPressRelease, 'id'>
  & { pressReleaseTitle: Types.Maybe<PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseTitle_TextField>, pressReleaseDescription: Types.Maybe<PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseDescription_TextField>, pressReleasePlatform: Types.Maybe<PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField>, pressReleaseContentType: Types.Maybe<PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField>, pressReleasePublicationDate: Types.Maybe<PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePublicationDate_DateField>, template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___Width = (
  { __typename?: 'C___Width' }
  & Pick<Types.C___Width, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_C___WildcardPage = (
  { __typename?: 'C___WildcardPage' }
  & Pick<Types.C___WildcardPage, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_CacheSetting = (
  { __typename?: 'CacheSetting' }
  & Pick<Types.CacheSetting, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Caching_26fce9bf0256458d8281a713a5bf5520 = (
  { __typename?: 'Caching_26fce9bf0256458d8281a713a5bf5520' }
  & Pick<Types.Caching_26fce9bf0256458d8281a713a5bf5520, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_CalendarEvent = (
  { __typename?: 'CalendarEvent' }
  & Pick<Types.CalendarEvent, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_CallOutSection = (
  { __typename?: 'CallOutSection' }
  & Pick<Types.CallOutSection, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_CallOutSectionDropdownOption = (
  { __typename?: 'CallOutSectionDropdownOption' }
  & Pick<Types.CallOutSectionDropdownOption, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_CallOutSectionFolder = (
  { __typename?: 'CallOutSectionFolder' }
  & Pick<Types.CallOutSectionFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_CallOutSectionParametersTemplate = (
  { __typename?: 'CallOutSectionParametersTemplate' }
  & Pick<Types.CallOutSectionParametersTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_CallToAction = (
  { __typename?: 'CallToAction' }
  & Pick<Types.CallToAction, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_CallToActionFolder = (
  { __typename?: 'CallToActionFolder' }
  & Pick<Types.CallToActionFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_CapabilitiesFolder = (
  { __typename?: 'CapabilitiesFolder' }
  & Pick<Types.CapabilitiesFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Capability = (
  { __typename?: 'Capability' }
  & Pick<Types.Capability, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_CapabilityMap = (
  { __typename?: 'CapabilityMap' }
  & Pick<Types.CapabilityMap, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_CapabilityMappings = (
  { __typename?: 'CapabilityMappings' }
  & Pick<Types.CapabilityMappings, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Carousel = (
  { __typename?: 'Carousel' }
  & Pick<Types.Carousel, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_CarouselFolder = (
  { __typename?: 'CarouselFolder' }
  & Pick<Types.CarouselFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_CarouselSlide = (
  { __typename?: 'CarouselSlide' }
  & Pick<Types.CarouselSlide, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Carousel_2b65f0d87ec54834b4aa1753c0f7036b = (
  { __typename?: 'Carousel_2b65f0d87ec54834b4aa1753c0f7036b' }
  & Pick<Types.Carousel_2b65f0d87ec54834b4aa1753c0f7036b, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Checkbox = (
  { __typename?: 'Checkbox' }
  & Pick<Types.Checkbox, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ChecklistFilter = (
  { __typename?: 'ChecklistFilter' }
  & Pick<Types.ChecklistFilter, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ChecklistFilterFolder = (
  { __typename?: 'ChecklistFilterFolder' }
  & Pick<Types.ChecklistFilterFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee = (
  { __typename?: 'ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee' }
  & Pick<Types.ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ColumnSplitter = (
  { __typename?: 'ColumnSplitter' }
  & Pick<Types.ColumnSplitter, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0 = (
  { __typename?: 'ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0' }
  & Pick<Types.ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_CompatibilityMode = (
  { __typename?: 'CompatibilityMode' }
  & Pick<Types.CompatibilityMode, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ComponentConfiguration = (
  { __typename?: 'ComponentConfiguration' }
  & Pick<Types.ComponentConfiguration, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ComponentThemeConfiguration = (
  { __typename?: 'ComponentThemeConfiguration' }
  & Pick<Types.ComponentThemeConfiguration, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ComponentThemesConfiguration = (
  { __typename?: 'ComponentThemesConfiguration' }
  & Pick<Types.ComponentThemesConfiguration, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ComponentsConfigurations = (
  { __typename?: 'ComponentsConfigurations' }
  & Pick<Types.ComponentsConfigurations, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ConfigurationFolder = (
  { __typename?: 'ConfigurationFolder' }
  & Pick<Types.ConfigurationFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Container = (
  { __typename?: 'Container' }
  & Pick<Types.Container, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ContainerOption = (
  { __typename?: 'ContainerOption' }
  & Pick<Types.ContainerOption, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ContainerOptionsFolder = (
  { __typename?: 'ContainerOptionsFolder' }
  & Pick<Types.ContainerOptionsFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ContainerParametersTemplate = (
  { __typename?: 'ContainerParametersTemplate' }
  & Pick<Types.ContainerParametersTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Container_45130bdbbae34edcaea87b68b9d94c7f = (
  { __typename?: 'Container_45130bdbbae34edcaea87b68b9d94c7f' }
  & Pick<Types.Container_45130bdbbae34edcaea87b68b9d94c7f, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ContentBlock = (
  { __typename?: 'ContentBlock' }
  & Pick<Types.ContentBlock, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ContentBlockFolder = (
  { __typename?: 'ContentBlockFolder' }
  & Pick<Types.ContentBlockFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ContentToken = (
  { __typename?: 'ContentToken' }
  & Pick<Types.ContentToken, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ContentTokenFolder = (
  { __typename?: 'ContentTokenFolder' }
  & Pick<Types.ContentTokenFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ContentType = (
  { __typename?: 'ContentType' }
  & Pick<Types.ContentType, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_CorporateTheme = (
  { __typename?: 'CorporateTheme' }
  & Pick<Types.CorporateTheme, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_CorporateThemesFolder = (
  { __typename?: 'CorporateThemesFolder' }
  & Pick<Types.CorporateThemesFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Country = (
  { __typename?: 'Country' }
  & Pick<Types.Country, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_CountryISOCode = (
  { __typename?: 'CountryISOCode' }
  & Pick<Types.CountryIsoCode, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_CountryISOCodesFolder = (
  { __typename?: 'CountryISOCodesFolder' }
  & Pick<Types.CountryIsoCodesFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_CustomerReviewFolder = (
  { __typename?: 'CustomerReviewFolder' }
  & Pick<Types.CustomerReviewFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_CustomerReviewTile = (
  { __typename?: 'CustomerReviewTile' }
  & Pick<Types.CustomerReviewTile, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_CustomerReviewTileParametersTemplate = (
  { __typename?: 'CustomerReviewTileParametersTemplate' }
  & Pick<Types.CustomerReviewTileParametersTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_DataBridgeDocumentCategoryMap = (
  { __typename?: 'DataBridgeDocumentCategoryMap' }
  & Pick<Types.DataBridgeDocumentCategoryMap, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_DataBridgeFund = (
  { __typename?: 'DataBridgeFund' }
  & Pick<Types.DataBridgeFund, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_DataBridgeFundRangeName = (
  { __typename?: 'DataBridgeFundRangeName' }
  & Pick<Types.DataBridgeFundRangeName, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_DataBridgeSettingsFolder = (
  { __typename?: 'DataBridgeSettingsFolder' }
  & Pick<Types.DataBridgeSettingsFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_DataBridgeShareClass = (
  { __typename?: 'DataBridgeShareClass' }
  & Pick<Types.DataBridgeShareClass, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_DataFolder = (
  { __typename?: 'DataFolder' }
  & Pick<Types.DataFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_DatasourceConfiguration = (
  { __typename?: 'DatasourceConfiguration' }
  & Pick<Types.DatasourceConfiguration, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_DatasourceConfigurations = (
  { __typename?: 'DatasourceConfigurations' }
  & Pick<Types.DatasourceConfigurations, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_DatasourceWorkflowAction = (
  { __typename?: 'DatasourceWorkflowAction' }
  & Pick<Types.DatasourceWorkflowAction, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_DateFacet = (
  { __typename?: 'DateFacet' }
  & Pick<Types.DateFacet, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_DateFilter = (
  { __typename?: 'DateFilter' }
  & Pick<Types.DateFilter, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_DateFilterFolder = (
  { __typename?: 'DateFilterFolder' }
  & Pick<Types.DateFilterFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_DateFilter_ad89c1f1e99148ef865938ab13aa28f1 = (
  { __typename?: 'DateFilter_ad89c1f1e99148ef865938ab13aa28f1' }
  & Pick<Types.DateFilter_Ad89c1f1e99148ef865938ab13aa28f1, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_DefaultColumnLayout = (
  { __typename?: 'DefaultColumnLayout' }
  & Pick<Types.DefaultColumnLayout, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_DefaultShareclassMapping = (
  { __typename?: 'DefaultShareclassMapping' }
  & Pick<Types.DefaultShareclassMapping, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_DefaultShareclassMappings = (
  { __typename?: 'DefaultShareclassMappings' }
  & Pick<Types.DefaultShareclassMappings, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_DescriptiveHighlight = (
  { __typename?: 'DescriptiveHighlight' }
  & Pick<Types.DescriptiveHighlight, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_DescriptiveHighlightFolder = (
  { __typename?: 'DescriptiveHighlightFolder' }
  & Pick<Types.DescriptiveHighlightFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_DescriptiveHighlightItem = (
  { __typename?: 'DescriptiveHighlightItem' }
  & Pick<Types.DescriptiveHighlightItem, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_DescriptiveHighlightParametersTemplate = (
  { __typename?: 'DescriptiveHighlightParametersTemplate' }
  & Pick<Types.DescriptiveHighlightParametersTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Device = (
  { __typename?: 'Device' }
  & Pick<Types.Device, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Device_7c27ec70f42e40428a0fabaa2f8eda18 = (
  { __typename?: 'Device_7c27ec70f42e40428a0fabaa2f8eda18' }
  & Pick<Types.Device_7c27ec70f42e40428a0fabaa2f8eda18, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Devices = (
  { __typename?: 'Devices' }
  & Pick<Types.Devices, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_DictionaryFolder = (
  { __typename?: 'DictionaryFolder' }
  & Pick<Types.DictionaryFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_DisqusParameters = (
  { __typename?: 'DisqusParameters' }
  & Pick<Types.DisqusParameters, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_DistanceFacet = (
  { __typename?: 'DistanceFacet' }
  & Pick<Types.DistanceFacet, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Divider = (
  { __typename?: 'Divider' }
  & Pick<Types.Divider, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_DocumentItem = (
  { __typename?: 'DocumentItem' }
  & Pick<Types.DocumentItem, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_DocumentListings = (
  { __typename?: 'DocumentListings' }
  & Pick<Types.DocumentListings, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_DocumentListingsFolder = (
  { __typename?: 'DocumentListingsFolder' }
  & Pick<Types.DocumentListingsFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_DocumentTypeFolder = (
  { __typename?: 'DocumentTypeFolder' }
  & Pick<Types.DocumentTypeFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_DominantLanguageMapping = (
  { __typename?: 'DominantLanguageMapping' }
  & Pick<Types.DominantLanguageMapping, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Dropdown = (
  { __typename?: 'Dropdown' }
  & Pick<Types.Dropdown, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_DropdownFilter = (
  { __typename?: 'DropdownFilter' }
  & Pick<Types.DropdownFilter, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_DropdownFilterFolder = (
  { __typename?: 'DropdownFilterFolder' }
  & Pick<Types.DropdownFilterFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_DropdownFilter_790c0f2c16214604a6c672b9f8ae830d = (
  { __typename?: 'DropdownFilter_790c0f2c16214604a6c672b9f8ae830d' }
  & Pick<Types.DropdownFilter_790c0f2c16214604a6c672b9f8ae830d, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_EditEditingTheme = (
  { __typename?: 'EditEditingTheme' }
  & Pick<Types.EditEditingTheme, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_EditFrame = (
  { __typename?: 'EditFrame' }
  & Pick<Types.EditFrame, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_EditModePanel = (
  { __typename?: 'EditModePanel' }
  & Pick<Types.EditModePanel, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_EditSiteItem = (
  { __typename?: 'EditSiteItem' }
  & Pick<Types.EditSiteItem, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_EditSiteItem_f040db0387fe4e10ae4053c63175e31b = (
  { __typename?: 'EditSiteItem_f040db0387fe4e10ae4053c63175e31b' }
  & Pick<Types.EditSiteItem_F040db0387fe4e10ae4053c63175e31b, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_EditSiteTheme = (
  { __typename?: 'EditSiteTheme' }
  & Pick<Types.EditSiteTheme, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_EditTenantTemplate = (
  { __typename?: 'EditTenantTemplate' }
  & Pick<Types.EditTenantTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_EditTenantTemplate_a7d9fcbcc8944274935f9b9659c000d3 = (
  { __typename?: 'EditTenantTemplate_a7d9fcbcc8944274935f9b9659c000d3' }
  & Pick<Types.EditTenantTemplate_A7d9fcbcc8944274935f9b9659c000d3, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_EditType = (
  { __typename?: 'EditType' }
  & Pick<Types.EditType, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_EloquaFormFolder = (
  { __typename?: 'EloquaFormFolder' }
  & Pick<Types.EloquaFormFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_EloquaFundForm = (
  { __typename?: 'EloquaFundForm' }
  & Pick<Types.EloquaFundForm, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Enum = (
  { __typename?: 'Enum' }
  & Pick<Types.Enum, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Enums = (
  { __typename?: 'Enums' }
  & Pick<Types.Enums, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ErrorPage = (
  { __typename?: 'ErrorPage' }
  & Pick<Types.ErrorPage, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171 = (
  { __typename?: 'ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171' }
  & Pick<Types.ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ErrorPage_4dbccce416d1491f94198496e3f77c6d = (
  { __typename?: 'ErrorPage_4dbccce416d1491f94198496e3f77c6d' }
  & Pick<Types.ErrorPage_4dbccce416d1491f94198496e3f77c6d, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ErrorPage_45d797cc048740ffb693214883ff35c2 = (
  { __typename?: 'ErrorPage_45d797cc048740ffb693214883ff35c2' }
  & Pick<Types.ErrorPage_45d797cc048740ffb693214883ff35c2, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9 = (
  { __typename?: 'ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9' }
  & Pick<Types.ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ErrorPage_a7dfa49761224679bf9949fffacd5fa1 = (
  { __typename?: 'ErrorPage_a7dfa49761224679bf9949fffacd5fa1' }
  & Pick<Types.ErrorPage_A7dfa49761224679bf9949fffacd5fa1, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_EventCalendarParameters = (
  { __typename?: 'EventCalendarParameters' }
  & Pick<Types.EventCalendarParameters, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_EventList = (
  { __typename?: 'EventList' }
  & Pick<Types.EventList, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_EventListParameters = (
  { __typename?: 'EventListParameters' }
  & Pick<Types.EventListParameters, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_EventTypes = (
  { __typename?: 'EventTypes' }
  & Pick<Types.EventTypes, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_EventsFolder = (
  { __typename?: 'EventsFolder' }
  & Pick<Types.EventsFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ExecuteScript = (
  { __typename?: 'ExecuteScript' }
  & Pick<Types.ExecuteScript, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f = (
  { __typename?: 'ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f' }
  & Pick<Types.ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a = (
  { __typename?: 'ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a' }
  & Pick<Types.ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ExecuteScript_b06460c28b7b47a59e2cf966f689b6ca = (
  { __typename?: 'ExecuteScript_b06460c28b7b47a59e2cf966f689b6ca' }
  & Pick<Types.ExecuteScript_B06460c28b7b47a59e2cf966f689b6ca, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ExecuteScript_bc9bb68436df4285888bd8b4d87b10de = (
  { __typename?: 'ExecuteScript_bc9bb68436df4285888bd8b4d87b10de' }
  & Pick<Types.ExecuteScript_Bc9bb68436df4285888bd8b4d87b10de, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ExecuteScript_e14c08721a97459eafef0acaaaf1ffbb = (
  { __typename?: 'ExecuteScript_e14c08721a97459eafef0acaaaf1ffbb' }
  & Pick<Types.ExecuteScript_E14c08721a97459eafef0acaaaf1ffbb, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ExtendSiteTheme = (
  { __typename?: 'ExtendSiteTheme' }
  & Pick<Types.ExtendSiteTheme, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ExternalLiterature = (
  { __typename?: 'ExternalLiterature' }
  & Pick<Types.ExternalLiterature, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FEaaSWrapperRenderingParameters = (
  { __typename?: 'FEaaSWrapperRenderingParameters' }
  & Pick<Types.FEaaSWrapperRenderingParameters, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FacebookCommentsParametersTemplate = (
  { __typename?: 'FacebookCommentsParametersTemplate' }
  & Pick<Types.FacebookCommentsParametersTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FacetSlider = (
  { __typename?: 'FacetSlider' }
  & Pick<Types.FacetSlider, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FacetSliderFolder = (
  { __typename?: 'FacetSliderFolder' }
  & Pick<Types.FacetSliderFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FacetSlider_995ce2c7319f478b84fe22053ac85bb7 = (
  { __typename?: 'FacetSlider_995ce2c7319f478b84fe22053ac85bb7' }
  & Pick<Types.FacetSlider_995ce2c7319f478b84fe22053ac85bb7, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FacetSummary = (
  { __typename?: 'FacetSummary' }
  & Pick<Types.FacetSummary, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FacetSummaryFolder = (
  { __typename?: 'FacetSummaryFolder' }
  & Pick<Types.FacetSummaryFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FacetSummary_cd5c935c1f604d899a6b88ce28305cf2 = (
  { __typename?: 'FacetSummary_cd5c935c1f604d899a6b88ce28305cf2' }
  & Pick<Types.FacetSummary_Cd5c935c1f604d899a6b88ce28305cf2, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FacetsGrouping = (
  { __typename?: 'FacetsGrouping' }
  & Pick<Types.FacetsGrouping, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FakeNavigationItem = (
  { __typename?: 'FakeNavigationItem' }
  & Pick<Types.FakeNavigationItem, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FeatureBanner = (
  { __typename?: 'FeatureBanner' }
  & Pick<Types.FeatureBanner, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FeatureBannerParametersTemplate = (
  { __typename?: 'FeatureBannerParametersTemplate' }
  & Pick<Types.FeatureBannerParametersTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FeaturedArticles = (
  { __typename?: 'FeaturedArticles' }
  & Pick<Types.FeaturedArticles, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FeaturedArticlesFolder = (
  { __typename?: 'FeaturedArticlesFolder' }
  & Pick<Types.FeaturedArticlesFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FeaturedTheme = (
  { __typename?: 'FeaturedTheme' }
  & Pick<Types.FeaturedTheme, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FeaturedThemesFolder = (
  { __typename?: 'FeaturedThemesFolder' }
  & Pick<Types.FeaturedThemesFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Feed = (
  { __typename?: 'Feed' }
  & Pick<Types.Feed, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FeedFolder = (
  { __typename?: 'FeedFolder' }
  & Pick<Types.FeedFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FeedParameters = (
  { __typename?: 'FeedParameters' }
  & Pick<Types.FeedParameters, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FieldEditor = (
  { __typename?: 'FieldEditor' }
  & Pick<Types.FieldEditor, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FieldRenderer = (
  { __typename?: 'FieldRenderer' }
  & Pick<Types.FieldRenderer, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FileList = (
  { __typename?: 'FileList' }
  & Pick<Types.FileList, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FileListFolder = (
  { __typename?: 'FileListFolder' }
  & Pick<Types.FileListFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FileListParametersTemplate = (
  { __typename?: 'FileListParametersTemplate' }
  & Pick<Types.FileListParametersTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_File_04129321770849c1801baee196e1c0a8 = (
  { __typename?: 'File_04129321770849c1801baee196e1c0a8' }
  & Pick<Types.File_04129321770849c1801baee196e1c0a8, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FilterCriteria = (
  { __typename?: 'FilterCriteria' }
  & Pick<Types.FilterCriteria, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FilterCriteriaFolder = (
  { __typename?: 'FilterCriteriaFolder' }
  & Pick<Types.FilterCriteriaFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FilterTaxonomyOption = (
  { __typename?: 'FilterTaxonomyOption' }
  & Pick<Types.FilterTaxonomyOption, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FilterTaxonomyOptions = (
  { __typename?: 'FilterTaxonomyOptions' }
  & Pick<Types.FilterTaxonomyOptions, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FilteredArticlesParentPage = (
  { __typename?: 'FilteredArticlesParentPage' }
  & Pick<Types.FilteredArticlesParentPage, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d = (
  { __typename?: 'FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d' }
  & Pick<Types.FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941 = (
  { __typename?: 'FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941' }
  & Pick<Types.FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FilteredArticlesParentPage_a34845039cf1441f8c967a5bbbdd7616 = (
  { __typename?: 'FilteredArticlesParentPage_a34845039cf1441f8c967a5bbbdd7616' }
  & Pick<Types.FilteredArticlesParentPage_A34845039cf1441f8c967a5bbbdd7616, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FilteredArticlesParentPage_e4f65f074322485787460a4058d378f9 = (
  { __typename?: 'FilteredArticlesParentPage_e4f65f074322485787460a4058d378f9' }
  & Pick<Types.FilteredArticlesParentPage_E4f65f074322485787460a4058d378f9, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FilteredArticlesParentPage_f099104e87204d52a6ab75aa44d159ce = (
  { __typename?: 'FilteredArticlesParentPage_f099104e87204d52a6ab75aa44d159ce' }
  & Pick<Types.FilteredArticlesParentPage_F099104e87204d52a6ab75aa44d159ce, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FilteredArticlesWildcardPage = (
  { __typename?: 'FilteredArticlesWildcardPage' }
  & Pick<Types.FilteredArticlesWildcardPage, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e = (
  { __typename?: 'FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e' }
  & Pick<Types.FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835 = (
  { __typename?: 'FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835' }
  & Pick<Types.FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2 = (
  { __typename?: 'FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2' }
  & Pick<Types.FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FilteredArticlesWildcardPage_ceac9aa72d344797adf00f73f9a55f96 = (
  { __typename?: 'FilteredArticlesWildcardPage_ceac9aa72d344797adf00f73f9a55f96' }
  & Pick<Types.FilteredArticlesWildcardPage_Ceac9aa72d344797adf00f73f9a55f96, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FilteredArticlesWildcardPage_da761c9a4e8f4a91b99040d8f5baa260 = (
  { __typename?: 'FilteredArticlesWildcardPage_da761c9a4e8f4a91b99040d8f5baa260' }
  & Pick<Types.FilteredArticlesWildcardPage_Da761c9a4e8f4a91b99040d8f5baa260, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Flip = (
  { __typename?: 'Flip' }
  & Pick<Types.Flip, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FlipFolder = (
  { __typename?: 'FlipFolder' }
  & Pick<Types.FlipFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Flip_5ef078504c044b839dafefd752cfaba8 = (
  { __typename?: 'Flip_5ef078504c044b839dafefd752cfaba8' }
  & Pick<Types.Flip_5ef078504c044b839dafefd752cfaba8, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Flipside = (
  { __typename?: 'Flipside' }
  & Pick<Types.Flipside, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FloatFacet = (
  { __typename?: 'FloatFacet' }
  & Pick<Types.FloatFacet, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Footer = (
  { __typename?: 'Footer' }
  & Pick<Types.Footer, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FooterFolder = (
  { __typename?: 'FooterFolder' }
  & Pick<Types.FooterFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FooterLink = (
  { __typename?: 'FooterLink' }
  & Pick<Types.FooterLink, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FormRenderingParameters = (
  { __typename?: 'FormRenderingParameters' }
  & Pick<Types.FormRenderingParameters, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FundAssetClass = (
  { __typename?: 'FundAssetClass' }
  & Pick<Types.FundAssetClass, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FundAssetClassesFolder = (
  { __typename?: 'FundAssetClassesFolder' }
  & Pick<Types.FundAssetClassesFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FundDetailsWildcardPage = (
  { __typename?: 'FundDetailsWildcardPage' }
  & Pick<Types.FundDetailsWildcardPage, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734 = (
  { __typename?: 'FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734' }
  & Pick<Types.FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f = (
  { __typename?: 'FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f' }
  & Pick<Types.FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b = (
  { __typename?: 'FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b' }
  & Pick<Types.FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FundFormsFolder = (
  { __typename?: 'FundFormsFolder' }
  & Pick<Types.FundFormsFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FundInFocus = (
  { __typename?: 'FundInFocus' }
  & Pick<Types.FundInFocus, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FundInFocusShareClass = (
  { __typename?: 'FundInFocusShareClass' }
  & Pick<Types.FundInFocusShareClass, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FundSearchPage = (
  { __typename?: 'FundSearchPage' }
  & Pick<Types.FundSearchPage, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FundSearchPage_5505b84dba1f47c7b8054749d802d926 = (
  { __typename?: 'FundSearchPage_5505b84dba1f47c7b8054749d802d926' }
  & Pick<Types.FundSearchPage_5505b84dba1f47c7b8054749d802d926, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FundSearchPage_5806f83c03bc443380678ff955f4310f = (
  { __typename?: 'FundSearchPage_5806f83c03bc443380678ff955f4310f' }
  & Pick<Types.FundSearchPage_5806f83c03bc443380678ff955f4310f, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FundSearchPage_7432205c04214a419ca064c4cb37501c = (
  { __typename?: 'FundSearchPage_7432205c04214a419ca064c4cb37501c' }
  & Pick<Types.FundSearchPage_7432205c04214a419ca064c4cb37501c, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FundSearchPage_edc9df02132e4c0a8435dd60057cbb0a = (
  { __typename?: 'FundSearchPage_edc9df02132e4c0a8435dd60057cbb0a' }
  & Pick<Types.FundSearchPage_Edc9df02132e4c0a8435dd60057cbb0a, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FundSettings = (
  { __typename?: 'FundSettings' }
  & Pick<Types.FundSettings, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FundShareclassDetailsWildcardPage = (
  { __typename?: 'FundShareclassDetailsWildcardPage' }
  & Pick<Types.FundShareclassDetailsWildcardPage, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c = (
  { __typename?: 'FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c' }
  & Pick<Types.FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3 = (
  { __typename?: 'FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3' }
  & Pick<Types.FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FundShareclassDetailsWildcardPage_cf3f2635270b49779bb3822ab90f1dcc = (
  { __typename?: 'FundShareclassDetailsWildcardPage_cf3f2635270b49779bb3822ab90f1dcc' }
  & Pick<Types.FundShareclassDetailsWildcardPage_Cf3f2635270b49779bb3822ab90f1dcc, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FundShareclassDetailsWildcardPage_d7e686d9c3bc4ef9974e201972b59eee = (
  { __typename?: 'FundShareclassDetailsWildcardPage_d7e686d9c3bc4ef9974e201972b59eee' }
  & Pick<Types.FundShareclassDetailsWildcardPage_D7e686d9c3bc4ef9974e201972b59eee, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FundSubAssetClass = (
  { __typename?: 'FundSubAssetClass' }
  & Pick<Types.FundSubAssetClass, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FundSubAssetClassesFolder = (
  { __typename?: 'FundSubAssetClassesFolder' }
  & Pick<Types.FundSubAssetClassesFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FundsExternalLiteratureFolder = (
  { __typename?: 'FundsExternalLiteratureFolder' }
  & Pick<Types.FundsExternalLiteratureFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FundsFolder = (
  { __typename?: 'FundsFolder' }
  & Pick<Types.FundsFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FundsInFocusFolder = (
  { __typename?: 'FundsInFocusFolder' }
  & Pick<Types.FundsInFocusFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FundsInFocusParametersTemplate = (
  { __typename?: 'FundsInFocusParametersTemplate' }
  & Pick<Types.FundsInFocusParametersTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FundsLiteratureFolder = (
  { __typename?: 'FundsLiteratureFolder' }
  & Pick<Types.FundsLiteratureFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_FundsLiteratureMappingsFolder = (
  { __typename?: 'FundsLiteratureMappingsFolder' }
  & Pick<Types.FundsLiteratureMappingsFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Gallery = (
  { __typename?: 'Gallery' }
  & Pick<Types.Gallery, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_GalleryFolder = (
  { __typename?: 'GalleryFolder' }
  & Pick<Types.GalleryFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_GalleryImage = (
  { __typename?: 'GalleryImage' }
  & Pick<Types.GalleryImage, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_GalleryParametersTemplate = (
  { __typename?: 'GalleryParametersTemplate' }
  & Pick<Types.GalleryParametersTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_GalleryVideo = (
  { __typename?: 'GalleryVideo' }
  & Pick<Types.GalleryVideo, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_GatedAccordionContainer = (
  { __typename?: 'GatedAccordionContainer' }
  & Pick<Types.GatedAccordionContainer, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_GlobalLanguageSelector = (
  { __typename?: 'GlobalLanguageSelector' }
  & Pick<Types.GlobalLanguageSelector, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_GlobalNavigationBar = (
  { __typename?: 'GlobalNavigationBar' }
  & Pick<Types.GlobalNavigationBar, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_GoogleAnalytics = (
  { __typename?: 'GoogleAnalytics' }
  & Pick<Types.GoogleAnalytics, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_GoogleTagManager = (
  { __typename?: 'GoogleTagManager' }
  & Pick<Types.GoogleTagManager, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_GoogleTagManagerFolder = (
  { __typename?: 'GoogleTagManagerFolder' }
  & Pick<Types.GoogleTagManagerFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_GridSetup = (
  { __typename?: 'GridSetup' }
  & Pick<Types.GridSetup, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_GridTheme = (
  { __typename?: 'GridTheme' }
  & Pick<Types.GridTheme, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HTMLCode = (
  { __typename?: 'HTMLCode' }
  & Pick<Types.HtmlCode, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HTMLCodeFolder = (
  { __typename?: 'HTMLCodeFolder' }
  & Pick<Types.HtmlCodeFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HTMLInclude = (
  { __typename?: 'HTMLInclude' }
  & Pick<Types.HtmlInclude, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HTMLIncludesFolder = (
  { __typename?: 'HTMLIncludesFolder' }
  & Pick<Types.HtmlIncludesFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HTMLSnippet = (
  { __typename?: 'HTMLSnippet' }
  & Pick<Types.HtmlSnippet, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HTMLSnippetFolder = (
  { __typename?: 'HTMLSnippetFolder' }
  & Pick<Types.HtmlSnippetFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HTMLTag = (
  { __typename?: 'HTMLTag' }
  & Pick<Types.HtmlTag, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Header = (
  { __typename?: 'Header' }
  & Pick<Types.Header, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HeaderFolder = (
  { __typename?: 'HeaderFolder' }
  & Pick<Types.HeaderFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Heading = (
  { __typename?: 'Heading' }
  & Pick<Types.Heading, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HeadlessSiteSetupRoot = (
  { __typename?: 'HeadlessSiteSetupRoot' }
  & Pick<Types.HeadlessSiteSetupRoot, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HeadlessSite_00d050988bad49e5b65db1e08b03ca1b = (
  { __typename?: 'HeadlessSite_00d050988bad49e5b65db1e08b03ca1b' }
  & Pick<Types.HeadlessSite_00d050988bad49e5b65db1e08b03ca1b, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1 = (
  { __typename?: 'HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1' }
  & Pick<Types.HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HeadlessSite_8ca001453c4b4715959d8a05292ecbc5 = (
  { __typename?: 'HeadlessSite_8ca001453c4b4715959d8a05292ecbc5' }
  & Pick<Types.HeadlessSite_8ca001453c4b4715959d8a05292ecbc5, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HeadlessSite_68ffa40c5aab45548f774742b163f318 = (
  { __typename?: 'HeadlessSite_68ffa40c5aab45548f774742b163f318' }
  & Pick<Types.HeadlessSite_68ffa40c5aab45548f774742b163f318, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HeadlessSite_89d464c8c03e4b0287e9a878d95d7149 = (
  { __typename?: 'HeadlessSite_89d464c8c03e4b0287e9a878d95d7149' }
  & Pick<Types.HeadlessSite_89d464c8c03e4b0287e9a878d95d7149, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HeadlessSite_229484893ca144958b9937167dfb5064 = (
  { __typename?: 'HeadlessSite_229484893ca144958b9937167dfb5064' }
  & Pick<Types.HeadlessSite_229484893ca144958b9937167dfb5064, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HeadlessSite_b28055626acc45a2913a9617398c9730 = (
  { __typename?: 'HeadlessSite_b28055626acc45a2913a9617398c9730' }
  & Pick<Types.HeadlessSite_B28055626acc45a2913a9617398c9730, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HeadlessSite_f1cab1661abb450d84d55d938e7699cb = (
  { __typename?: 'HeadlessSite_f1cab1661abb450d84d55d938e7699cb' }
  & Pick<Types.HeadlessSite_F1cab1661abb450d84d55d938e7699cb, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HeadlessSite_f3884baa0e1548f59a6d7154a4559604 = (
  { __typename?: 'HeadlessSite_f3884baa0e1548f59a6d7154a4559604' }
  & Pick<Types.HeadlessSite_F3884baa0e1548f59a6d7154a4559604, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HeadlessSolutionTemplateFolder = (
  { __typename?: 'HeadlessSolutionTemplateFolder' }
  & Pick<Types.HeadlessSolutionTemplateFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HeadlessTenantSetupRoot = (
  { __typename?: 'HeadlessTenantSetupRoot' }
  & Pick<Types.HeadlessTenantSetupRoot, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HeadlessTenant_07248c4700af499eb2a9cb7789f72372 = (
  { __typename?: 'HeadlessTenant_07248c4700af499eb2a9cb7789f72372' }
  & Pick<Types.HeadlessTenant_07248c4700af499eb2a9cb7789f72372, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8 = (
  { __typename?: 'HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8' }
  & Pick<Types.HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HeadlessTenant_5d72df6049c74324969205b55767ad7b = (
  { __typename?: 'HeadlessTenant_5d72df6049c74324969205b55767ad7b' }
  & Pick<Types.HeadlessTenant_5d72df6049c74324969205b55767ad7b, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3 = (
  { __typename?: 'HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3' }
  & Pick<Types.HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HeadlessTenant_77a403a2094e48afafa60943d349d23d = (
  { __typename?: 'HeadlessTenant_77a403a2094e48afafa60943d349d23d' }
  & Pick<Types.HeadlessTenant_77a403a2094e48afafa60943d349d23d, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2 = (
  { __typename?: 'HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2' }
  & Pick<Types.HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HeadlessTenant_94824ac390d748499e5af0275d10811f = (
  { __typename?: 'HeadlessTenant_94824ac390d748499e5af0275d10811f' }
  & Pick<Types.HeadlessTenant_94824ac390d748499e5af0275d10811f, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HeadlessTenant_4797571864fd40929cf2412c39757ec3 = (
  { __typename?: 'HeadlessTenant_4797571864fd40929cf2412c39757ec3' }
  & Pick<Types.HeadlessTenant_4797571864fd40929cf2412c39757ec3, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HeadlessTenant_c102fb48f40f49fb9c21f8e3e1b0c107 = (
  { __typename?: 'HeadlessTenant_c102fb48f40f49fb9c21f8e3e1b0c107' }
  & Pick<Types.HeadlessTenant_C102fb48f40f49fb9c21f8e3e1b0c107, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HeadlessTrustSite = (
  { __typename?: 'HeadlessTrustSite' }
  & Pick<Types.HeadlessTrustSite, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HeadlessVariants = (
  { __typename?: 'HeadlessVariants' }
  & Pick<Types.HeadlessVariants, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HeadlessVariantsGrouping = (
  { __typename?: 'HeadlessVariantsGrouping' }
  & Pick<Types.HeadlessVariantsGrouping, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HelpArticlePage = (
  { __typename?: 'HelpArticlePage' }
  & Pick<Types.HelpArticlePage, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HelpArticlePlatform = (
  { __typename?: 'HelpArticlePlatform' }
  & Pick<Types.HelpArticlePlatform, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HelpArticlePlatformMap = (
  { __typename?: 'HelpArticlePlatformMap' }
  & Pick<Types.HelpArticlePlatformMap, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HelpArticlePlatformMappings = (
  { __typename?: 'HelpArticlePlatformMappings' }
  & Pick<Types.HelpArticlePlatformMappings, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HelpArticlePlatformsFolder = (
  { __typename?: 'HelpArticlePlatformsFolder' }
  & Pick<Types.HelpArticlePlatformsFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HelpArticleSearchPage = (
  { __typename?: 'HelpArticleSearchPage' }
  & Pick<Types.HelpArticleSearchPage, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77 = (
  { __typename?: 'HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77' }
  & Pick<Types.HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HelpArticleTag = (
  { __typename?: 'HelpArticleTag' }
  & Pick<Types.HelpArticleTag, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HelpArticleTagsFolder = (
  { __typename?: 'HelpArticleTagsFolder' }
  & Pick<Types.HelpArticleTagsFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HelpArticleWildcardPage = (
  { __typename?: 'HelpArticleWildcardPage' }
  & Pick<Types.HelpArticleWildcardPage, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HelpArticleWildcardPage_e4e2d58c853341deaa6b2a2a136421c4 = (
  { __typename?: 'HelpArticleWildcardPage_e4e2d58c853341deaa6b2a2a136421c4' }
  & Pick<Types.HelpArticleWildcardPage_E4e2d58c853341deaa6b2a2a136421c4, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HelpArticlesGroupFolder = (
  { __typename?: 'HelpArticlesGroupFolder' }
  & Pick<Types.HelpArticlesGroupFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HelpTagMap = (
  { __typename?: 'HelpTagMap' }
  & Pick<Types.HelpTagMap, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HelpTagMappings = (
  { __typename?: 'HelpTagMappings' }
  & Pick<Types.HelpTagMappings, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HeroBanner = (
  { __typename?: 'HeroBanner' }
  & Pick<Types.HeroBanner, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Highlight = (
  { __typename?: 'Highlight' }
  & Pick<Types.Highlight, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HighlightBlock = (
  { __typename?: 'HighlightBlock' }
  & Pick<Types.HighlightBlock, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HighlightBlockFolder = (
  { __typename?: 'HighlightBlockFolder' }
  & Pick<Types.HighlightBlockFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HighlightBlockParametersTemplate = (
  { __typename?: 'HighlightBlockParametersTemplate' }
  & Pick<Types.HighlightBlockParametersTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HighlightFolder = (
  { __typename?: 'HighlightFolder' }
  & Pick<Types.HighlightFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HighlightItem = (
  { __typename?: 'HighlightItem' }
  & Pick<Types.HighlightItem, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HighlightParametersTemplate = (
  { __typename?: 'HighlightParametersTemplate' }
  & Pick<Types.HighlightParametersTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Home = (
  { __typename?: 'Home' }
  & Pick<Types.Home, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HomePage = (
  { __typename?: 'HomePage' }
  & Pick<Types.HomePage, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HomePage_0d3963a8171d4080b5f808618578b631 = (
  { __typename?: 'HomePage_0d3963a8171d4080b5f808618578b631' }
  & Pick<Types.HomePage_0d3963a8171d4080b5f808618578b631, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HomePage_6d95c7d946c74a70be07304cc73a2010 = (
  { __typename?: 'HomePage_6d95c7d946c74a70be07304cc73a2010' }
  & Pick<Types.HomePage_6d95c7d946c74a70be07304cc73a2010, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HomePage_b407f259b4e34c7db9a06e8907a56b17 = (
  { __typename?: 'HomePage_b407f259b4e34c7db9a06e8907a56b17' }
  & Pick<Types.HomePage_B407f259b4e34c7db9a06e8907a56b17, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HomePage_cde13c51062d426b95569e8202edc963 = (
  { __typename?: 'HomePage_cde13c51062d426b95569e8202edc963' }
  & Pick<Types.HomePage_Cde13c51062d426b95569e8202edc963, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_HomePage_de9353283a3e41c495ba386aed0540c6 = (
  { __typename?: 'HomePage_de9353283a3e41c495ba386aed0540c6' }
  & Pick<Types.HomePage_De9353283a3e41c495ba386aed0540c6, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_IFrame = (
  { __typename?: 'IFrame' }
  & Pick<Types.IFrame, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_IFrameFolder = (
  { __typename?: 'IFrameFolder' }
  & Pick<Types.IFrameFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2 = (
  { __typename?: 'IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2' }
  & Pick<Types.IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_IFrameParametersTemplate = (
  { __typename?: 'IFrameParametersTemplate' }
  & Pick<Types.IFrameParametersTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_IFrame_0da12d476de24dfeb4d0f513489bfea1 = (
  { __typename?: 'IFrame_0da12d476de24dfeb4d0f513489bfea1' }
  & Pick<Types.IFrame_0da12d476de24dfeb4d0f513489bfea1, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_IFrame_88a6f65f2b78491bb3770b06e48883e1 = (
  { __typename?: 'IFrame_88a6f65f2b78491bb3770b06e48883e1' }
  & Pick<Types.IFrame_88a6f65f2b78491bb3770b06e48883e1, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Icon = (
  { __typename?: 'Icon' }
  & Pick<Types.Icon, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_IconFolder = (
  { __typename?: 'IconFolder' }
  & Pick<Types.IconFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Image = (
  { __typename?: 'Image' }
  & Pick<Types.Image, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ImageFolder = (
  { __typename?: 'ImageFolder' }
  & Pick<Types.ImageFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ImageFolder_edc00e86cef24d0cbfa264460becc323 = (
  { __typename?: 'ImageFolder_edc00e86cef24d0cbfa264460becc323' }
  & Pick<Types.ImageFolder_Edc00e86cef24d0cbfa264460becc323, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ImageFolder_f7a4527687f14ea5bf25e3c7cb7aa993 = (
  { __typename?: 'ImageFolder_f7a4527687f14ea5bf25e3c7cb7aa993' }
  & Pick<Types.ImageFolder_F7a4527687f14ea5bf25e3c7cb7aa993, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ImageParametersTemplate = (
  { __typename?: 'ImageParametersTemplate' }
  & Pick<Types.ImageParametersTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Image_83bc563c6320490092f8204bff81586a = (
  { __typename?: 'Image_83bc563c6320490092f8204bff81586a' }
  & Pick<Types.Image_83bc563c6320490092f8204bff81586a, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Image_15185b0e641844499f934ff03b7ee032 = (
  { __typename?: 'Image_15185b0e641844499f934ff03b7ee032' }
  & Pick<Types.Image_15185b0e641844499f934ff03b7ee032, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Image_d885df8cb2d64007b34b2bbafb527304 = (
  { __typename?: 'Image_d885df8cb2d64007b34b2bbafb527304' }
  & Pick<Types.Image_D885df8cb2d64007b34b2bbafb527304, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Infographics = (
  { __typename?: 'Infographics' }
  & Pick<Types.Infographics, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_InfographicsFolder = (
  { __typename?: 'InfographicsFolder' }
  & Pick<Types.InfographicsFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_InputValidationStep = (
  { __typename?: 'InputValidationStep' }
  & Pick<Types.InputValidationStep, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_InputValidationStep_088928cf558e40ec87f3342aa9e66757 = (
  { __typename?: 'InputValidationStep_088928cf558e40ec87f3342aa9e66757' }
  & Pick<Types.InputValidationStep_088928cf558e40ec87f3342aa9e66757, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593 = (
  { __typename?: 'InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593' }
  & Pick<Types.InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_InputValidationStep_d028fef2babf4ad1bbe74d62a977992f = (
  { __typename?: 'InputValidationStep_d028fef2babf4ad1bbe74d62a977992f' }
  & Pick<Types.InputValidationStep_D028fef2babf4ad1bbe74d62a977992f, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_IntegerFacet = (
  { __typename?: 'IntegerFacet' }
  & Pick<Types.IntegerFacet, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_IntroCopy = (
  { __typename?: 'IntroCopy' }
  & Pick<Types.IntroCopy, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_IntroCopyFolder = (
  { __typename?: 'IntroCopyFolder' }
  & Pick<Types.IntroCopyFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_InvestmentTrustAssetClass = (
  { __typename?: 'InvestmentTrustAssetClass' }
  & Pick<Types.InvestmentTrustAssetClass, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_InvestmentTrustAssetClassFolder = (
  { __typename?: 'InvestmentTrustAssetClassFolder' }
  & Pick<Types.InvestmentTrustAssetClassFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73 = (
  { __typename?: 'InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73' }
  & Pick<Types.InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb = (
  { __typename?: 'InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb' }
  & Pick<Types.InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_InvestmentTrustRegion = (
  { __typename?: 'InvestmentTrustRegion' }
  & Pick<Types.InvestmentTrustRegion, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_InvestmentTrustRegionFolder = (
  { __typename?: 'InvestmentTrustRegionFolder' }
  & Pick<Types.InvestmentTrustRegionFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_InvestmentTrustStyle = (
  { __typename?: 'InvestmentTrustStyle' }
  & Pick<Types.InvestmentTrustStyle, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_InvestmentTrustStyleFolder = (
  { __typename?: 'InvestmentTrustStyleFolder' }
  & Pick<Types.InvestmentTrustStyleFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_InvestorType = (
  { __typename?: 'InvestorType' }
  & Pick<Types.InvestorType, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_InvestorTypesFolder = (
  { __typename?: 'InvestorTypesFolder' }
  & Pick<Types.InvestorTypesFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ItemQueriesFolder = (
  { __typename?: 'ItemQueriesFolder' }
  & Pick<Types.ItemQueriesFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ItemRights = (
  { __typename?: 'ItemRights' }
  & Pick<Types.ItemRights, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_JSBeaconSettings = (
  { __typename?: 'JSBeaconSettings' }
  & Pick<Types.JsBeaconSettings, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_JSONCheckbox = (
  { __typename?: 'JSONCheckbox' }
  & Pick<Types.JsonCheckbox, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_JSONContent = (
  { __typename?: 'JSONContent' }
  & Pick<Types.JsonContent, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_JSONDate = (
  { __typename?: 'JSONDate' }
  & Pick<Types.JsonDate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_JSONFile = (
  { __typename?: 'JSONFile' }
  & Pick<Types.JsonFile, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_JSONImage = (
  { __typename?: 'JSONImage' }
  & Pick<Types.JsonImage, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_JSONLayout = (
  { __typename?: 'JSONLayout' }
  & Pick<Types.JsonLayout, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_JSONList = (
  { __typename?: 'JSONList' }
  & Pick<Types.JsonList, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_JSONMultilistReference = (
  { __typename?: 'JSONMultilistReference' }
  & Pick<Types.JsonMultilistReference, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_JSONPlaceholder = (
  { __typename?: 'JSONPlaceholder' }
  & Pick<Types.JsonPlaceholder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_JSONQuery = (
  { __typename?: 'JSONQuery' }
  & Pick<Types.JsonQuery, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_JSONResults = (
  { __typename?: 'JSONResults' }
  & Pick<Types.JsonResults, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_JSONRichText = (
  { __typename?: 'JSONRichText' }
  & Pick<Types.JsonRichText, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_JSONScriban = (
  { __typename?: 'JSONScriban' }
  & Pick<Types.JsonScriban, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_JSONSection = (
  { __typename?: 'JSONSection' }
  & Pick<Types.JsonSection, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_JSONTemplate = (
  { __typename?: 'JSONTemplate' }
  & Pick<Types.JsonTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_JSONText = (
  { __typename?: 'JSONText' }
  & Pick<Types.JsonText, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_JSONToken = (
  { __typename?: 'JSONToken' }
  & Pick<Types.JsonToken, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_JSONVariantDefinition = (
  { __typename?: 'JSONVariantDefinition' }
  & Pick<Types.JsonVariantDefinition, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_JSONVariants = (
  { __typename?: 'JSONVariants' }
  & Pick<Types.JsonVariants, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_JSSLayout = (
  { __typename?: 'JSSLayout' }
  & Pick<Types.JssLayout, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_JSSSettings_1a6fb678eca242c09ae77a9e7f72a6d0 = (
  { __typename?: 'JSSSettings_1a6fb678eca242c09ae77a9e7f72a6d0' }
  & Pick<Types.JssSettings_1a6fb678eca242c09ae77a9e7f72a6d0, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_JSSSettings_6b328292f8314ab79885d89a054ca10a = (
  { __typename?: 'JSSSettings_6b328292f8314ab79885d89a054ca10a' }
  & Pick<Types.JssSettings_6b328292f8314ab79885d89a054ca10a, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_JSSSettings_457c9d0b61b84adfaf7f82561ed275ff = (
  { __typename?: 'JSSSettings_457c9d0b61b84adfaf7f82561ed275ff' }
  & Pick<Types.JssSettings_457c9d0b61b84adfaf7f82561ed275ff, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_JSSSettings_5045bf85d2ea430b9f41c2e348436e5d = (
  { __typename?: 'JSSSettings_5045bf85d2ea430b9f41c2e348436e5d' }
  & Pick<Types.JssSettings_5045bf85d2ea430b9f41c2e348436e5d, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_JSSSettings_a767f80d5ad44bfbb8b750a8da144cb5 = (
  { __typename?: 'JSSSettings_a767f80d5ad44bfbb8b750a8da144cb5' }
  & Pick<Types.JssSettings_A767f80d5ad44bfbb8b750a8da144cb5, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_JSSSettings_b001fd725bb1476496825a8cb9e995cd = (
  { __typename?: 'JSSSettings_b001fd725bb1476496825a8cb9e995cd' }
  & Pick<Types.JssSettings_B001fd725bb1476496825a8cb9e995cd, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_JSSSettings_c643bc8630d14d61a173c7870f5dbbad = (
  { __typename?: 'JSSSettings_c643bc8630d14d61a173c7870f5dbbad' }
  & Pick<Types.JssSettings_C643bc8630d14d61a173c7870f5dbbad, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_JSSSettings_ce3dfd340df34b2d8715e54f85dfcce2 = (
  { __typename?: 'JSSSettings_ce3dfd340df34b2d8715e54f85dfcce2' }
  & Pick<Types.JssSettings_Ce3dfd340df34b2d8715e54f85dfcce2, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_JSSSettings_ef855d0ba8b04a8e87851d1298266d90 = (
  { __typename?: 'JSSSettings_ef855d0ba8b04a8e87851d1298266d90' }
  & Pick<Types.JssSettings_Ef855d0ba8b04a8e87851d1298266d90, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_JSSSiteGrouping = (
  { __typename?: 'JSSSiteGrouping' }
  & Pick<Types.JssSiteGrouping, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_JSSTenantFolder = (
  { __typename?: 'JSSTenantFolder' }
  & Pick<Types.JssTenantFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_JavaScriptRendering = (
  { __typename?: 'JavaScriptRendering' }
  & Pick<Types.JavaScriptRendering, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_JsonRendering = (
  { __typename?: 'JsonRendering' }
  & Pick<Types.JsonRendering, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_JurisdictionStatus = (
  { __typename?: 'JurisdictionStatus' }
  & Pick<Types.JurisdictionStatus, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_JurisdictionsFolder = (
  { __typename?: 'JurisdictionsFolder' }
  & Pick<Types.JurisdictionsFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_KeyHighlightItem = (
  { __typename?: 'KeyHighlightItem' }
  & Pick<Types.KeyHighlightItem, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_KeyHighlights = (
  { __typename?: 'KeyHighlights' }
  & Pick<Types.KeyHighlights, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_KeyHighlightsFolder = (
  { __typename?: 'KeyHighlightsFolder' }
  & Pick<Types.KeyHighlightsFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_KeyHighlightsParametersTemplate = (
  { __typename?: 'KeyHighlightsParametersTemplate' }
  & Pick<Types.KeyHighlightsParametersTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Language = (
  { __typename?: 'Language' }
  & Pick<Types.Language, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_LanguageSelector = (
  { __typename?: 'LanguageSelector' }
  & Pick<Types.LanguageSelector, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_LanguagesFolder = (
  { __typename?: 'LanguagesFolder' }
  & Pick<Types.LanguagesFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_LatestPressReleasesParametersTemplate = (
  { __typename?: 'LatestPressReleasesParametersTemplate' }
  & Pick<Types.LatestPressReleasesParametersTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_LayoutServiceVariants = (
  { __typename?: 'LayoutServiceVariants' }
  & Pick<Types.LayoutServiceVariants, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_LimitedDisplayFolder = (
  { __typename?: 'LimitedDisplayFolder' }
  & Pick<Types.LimitedDisplayFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_LimitedDisplayOption = (
  { __typename?: 'LimitedDisplayOption' }
  & Pick<Types.LimitedDisplayOption, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Link = (
  { __typename?: 'Link' }
  & Pick<Types.Link, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_LinkList = (
  { __typename?: 'LinkList' }
  & Pick<Types.LinkList, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_LinkListFolder = (
  { __typename?: 'LinkListFolder' }
  & Pick<Types.LinkListFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_LinkListFolder_c237d144647a4afeaa7b1570f3e3f139 = (
  { __typename?: 'LinkListFolder_c237d144647a4afeaa7b1570f3e3f139' }
  & Pick<Types.LinkListFolder_C237d144647a4afeaa7b1570f3e3f139, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_LinkList_33c9207e3b0446068ef54ca99a97c776 = (
  { __typename?: 'LinkList_33c9207e3b0446068ef54ca99a97c776' }
  & Pick<Types.LinkList_33c9207e3b0446068ef54ca99a97c776, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_LinkList_97a593ad273141dc80bfceb5ef6a33b7 = (
  { __typename?: 'LinkList_97a593ad273141dc80bfceb5ef6a33b7' }
  & Pick<Types.LinkList_97a593ad273141dc80bfceb5ef6a33b7, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_LinkList_f7561ffcc0d8477fb53d2703a4060be1 = (
  { __typename?: 'LinkList_f7561ffcc0d8477fb53d2703a4060be1' }
  & Pick<Types.LinkList_F7561ffcc0d8477fb53d2703a4060be1, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Link_68bd1cb5a7624a969ac6cb16ab5882a3 = (
  { __typename?: 'Link_68bd1cb5a7624a969ac6cb16ab5882a3' }
  & Pick<Types.Link_68bd1cb5a7624a969ac6cb16ab5882a3, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Link_930f134d56784b35bfd1b77f9d0115f1 = (
  { __typename?: 'Link_930f134d56784b35bfd1b77f9d0115f1' }
  & Pick<Types.Link_930f134d56784b35bfd1b77f9d0115f1, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Link_e24e0789a05848bfabb6c69c0e60b6b7 = (
  { __typename?: 'Link_e24e0789a05848bfabb6c69c0e60b6b7' }
  & Pick<Types.Link_E24e0789a05848bfabb6c69c0e60b6b7, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_LinksFolder = (
  { __typename?: 'LinksFolder' }
  & Pick<Types.LinksFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_List = (
  { __typename?: 'List' }
  & Pick<Types.List, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ListFacet = (
  { __typename?: 'ListFacet' }
  & Pick<Types.ListFacet, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ListFolder = (
  { __typename?: 'ListFolder' }
  & Pick<Types.ListFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ListItem = (
  { __typename?: 'ListItem' }
  & Pick<Types.ListItem, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ListParametersTemplate = (
  { __typename?: 'ListParametersTemplate' }
  & Pick<Types.ListParametersTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ListStyle = (
  { __typename?: 'ListStyle' }
  & Pick<Types.ListStyle, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ListStyleItem = (
  { __typename?: 'ListStyleItem' }
  & Pick<Types.ListStyleItem, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ListingHeroBanner = (
  { __typename?: 'ListingHeroBanner' }
  & Pick<Types.ListingHeroBanner, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ListingHeroParametersTemplate = (
  { __typename?: 'ListingHeroParametersTemplate' }
  & Pick<Types.ListingHeroParametersTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_LiteratureAuthorization = (
  { __typename?: 'LiteratureAuthorization' }
  & Pick<Types.LiteratureAuthorization, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_LiteratureAuthorizationsFolder = (
  { __typename?: 'LiteratureAuthorizationsFolder' }
  & Pick<Types.LiteratureAuthorizationsFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_LiteratureHubSearchPage = (
  { __typename?: 'LiteratureHubSearchPage' }
  & Pick<Types.LiteratureHubSearchPage, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d = (
  { __typename?: 'LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d' }
  & Pick<Types.LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e = (
  { __typename?: 'LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e' }
  & Pick<Types.LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_LiteratureHubSearchPage_d2b2958263564ba8bba5922add46a0ea = (
  { __typename?: 'LiteratureHubSearchPage_d2b2958263564ba8bba5922add46a0ea' }
  & Pick<Types.LiteratureHubSearchPage_D2b2958263564ba8bba5922add46a0ea, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_LoadMore = (
  { __typename?: 'LoadMore' }
  & Pick<Types.LoadMore, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_LoadMoreFolder = (
  { __typename?: 'LoadMoreFolder' }
  & Pick<Types.LoadMoreFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_LoadMore_7a3a53e06a0144ff8ba52be46e201fe6 = (
  { __typename?: 'LoadMore_7a3a53e06a0144ff8ba52be46e201fe6' }
  & Pick<Types.LoadMore_7a3a53e06a0144ff8ba52be46e201fe6, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_LocationFilter = (
  { __typename?: 'LocationFilter' }
  & Pick<Types.LocationFilter, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_LocationFilterFolder = (
  { __typename?: 'LocationFilterFolder' }
  & Pick<Types.LocationFilterFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_LocationFilter_aaad4aad290744dc90b69e4e83a661ec = (
  { __typename?: 'LocationFilter_aaad4aad290744dc90b69e4e83a661ec' }
  & Pick<Types.LocationFilter_Aaad4aad290744dc90b69e4e83a661ec, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Log = (
  { __typename?: 'Log' }
  & Pick<Types.Log, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Login = (
  { __typename?: 'Login' }
  & Pick<Types.Login, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Login_abed54dc4f7840ddac562289c9c849d8 = (
  { __typename?: 'Login_abed54dc4f7840ddac562289c9c849d8' }
  & Pick<Types.Login_Abed54dc4f7840ddac562289c9c849d8, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_LogoTextBlockItem = (
  { __typename?: 'LogoTextBlockItem' }
  & Pick<Types.LogoTextBlockItem, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_LogoTextBlocks = (
  { __typename?: 'LogoTextBlocks' }
  & Pick<Types.LogoTextBlocks, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_LogoTextBlocksFolder = (
  { __typename?: 'LogoTextBlocksFolder' }
  & Pick<Types.LogoTextBlocksFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Logout = (
  { __typename?: 'Logout' }
  & Pick<Types.Logout, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Logout_c2294d8235a6452a94b15eb5e543b602 = (
  { __typename?: 'Logout_c2294d8235a6452a94b15eb5e543b602' }
  & Pick<Types.Logout_C2294d8235a6452a94b15eb5e543b602, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ManagedRangeFilter = (
  { __typename?: 'ManagedRangeFilter' }
  & Pick<Types.ManagedRangeFilter, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ManagedRangeFilterFolder = (
  { __typename?: 'ManagedRangeFilterFolder' }
  & Pick<Types.ManagedRangeFilterFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91 = (
  { __typename?: 'ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91' }
  & Pick<Types.ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ManagedRangeItem = (
  { __typename?: 'ManagedRangeItem' }
  & Pick<Types.ManagedRangeItem, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Map = (
  { __typename?: 'Map' }
  & Pick<Types.Map, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_MapParameters = (
  { __typename?: 'MapParameters' }
  & Pick<Types.MapParameters, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_MapsFolder = (
  { __typename?: 'MapsFolder' }
  & Pick<Types.MapsFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_MapsProvider = (
  { __typename?: 'MapsProvider' }
  & Pick<Types.MapsProvider, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_MediaBlock = (
  { __typename?: 'MediaBlock' }
  & Pick<Types.MediaBlock, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_MediaBlockFolder = (
  { __typename?: 'MediaBlockFolder' }
  & Pick<Types.MediaBlockFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_MediaBlockParametersTemplate = (
  { __typename?: 'MediaBlockParametersTemplate' }
  & Pick<Types.MediaBlockParametersTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_MediaFolder_81150e5837f5443fa3c075e14a9321e7 = (
  { __typename?: 'MediaFolder_81150e5837f5443fa3c075e14a9321e7' }
  & Pick<Types.MediaFolder_81150e5837f5443fa3c075e14a9321e7, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_MediaLinkParameters = (
  { __typename?: 'MediaLinkParameters' }
  & Pick<Types.MediaLinkParameters, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_MediaVirtualFolder = (
  { __typename?: 'MediaVirtualFolder' }
  & Pick<Types.MediaVirtualFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_MegaNavigation = (
  { __typename?: 'MegaNavigation' }
  & Pick<Types.MegaNavigation, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_MegaNavigationFolder = (
  { __typename?: 'MegaNavigationFolder' }
  & Pick<Types.MegaNavigationFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_MetaBranding = (
  { __typename?: 'MetaBranding' }
  & Pick<Types.MetaBranding, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_MetaRenderingParameters = (
  { __typename?: 'MetaRenderingParameters' }
  & Pick<Types.MetaRenderingParameters, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_MetadataPartialDesign = (
  { __typename?: 'MetadataPartialDesign' }
  & Pick<Types.MetadataPartialDesign, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Model = (
  { __typename?: 'Model' }
  & Pick<Types.Model, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ModelIterator = (
  { __typename?: 'ModelIterator' }
  & Pick<Types.ModelIterator, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_MyLocationPOI = (
  { __typename?: 'MyLocationPOI' }
  & Pick<Types.MyLocationPoi, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Navigation = (
  { __typename?: 'Navigation' }
  & Pick<Types.Navigation, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_NavigationCategory = (
  { __typename?: 'NavigationCategory' }
  & Pick<Types.NavigationCategory, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_NavigationFilter = (
  { __typename?: 'NavigationFilter' }
  & Pick<Types.NavigationFilter, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_NavigationFilterFolder = (
  { __typename?: 'NavigationFilterFolder' }
  & Pick<Types.NavigationFilterFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_NavigationLink = (
  { __typename?: 'NavigationLink' }
  & Pick<Types.NavigationLink, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_NavigationSubcategory = (
  { __typename?: 'NavigationSubcategory' }
  & Pick<Types.NavigationSubcategory, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Navigation_9ce34bf95c934dff841d8f649c2bd6c8 = (
  { __typename?: 'Navigation_9ce34bf95c934dff841d8f649c2bd6c8' }
  & Pick<Types.Navigation_9ce34bf95c934dff841d8f649c2bd6c8, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_OneTrustSettings = (
  { __typename?: 'OneTrustSettings' }
  & Pick<Types.OneTrustSettings, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_OptimiserConfiguration = (
  { __typename?: 'OptimiserConfiguration' }
  & Pick<Types.OptimiserConfiguration, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_OptimiserConfigurationSection = (
  { __typename?: 'OptimiserConfigurationSection' }
  & Pick<Types.OptimiserConfigurationSection, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_OptimizedFile = (
  { __typename?: 'OptimizedFile' }
  & Pick<Types.OptimizedFile, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_OracleCDPSettings = (
  { __typename?: 'OracleCDPSettings' }
  & Pick<Types.OracleCdpSettings, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_OverlayContent = (
  { __typename?: 'OverlayContent' }
  & Pick<Types.OverlayContent, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_OverlayFolderTemplate = (
  { __typename?: 'OverlayFolderTemplate' }
  & Pick<Types.OverlayFolderTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Ownership = (
  { __typename?: 'Ownership' }
  & Pick<Types.Ownership, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_OwnershipFolder = (
  { __typename?: 'OwnershipFolder' }
  & Pick<Types.OwnershipFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_POI = (
  { __typename?: 'POI' }
  & Pick<Types.Poi, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_POIFolder = (
  { __typename?: 'POIFolder' }
  & Pick<Types.PoiFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_POIType = (
  { __typename?: 'POIType' }
  & Pick<Types.PoiType, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_POIs = (
  { __typename?: 'POIs' }
  & Pick<Types.PoIs, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PageBranchesFolder = (
  { __typename?: 'PageBranchesFolder' }
  & Pick<Types.PageBranchesFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PageContent = (
  { __typename?: 'PageContent' }
  & Pick<Types.PageContent, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PageContentFolder = (
  { __typename?: 'PageContentFolder' }
  & Pick<Types.PageContentFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PageContent_ef87e73bc7ff49a2ac599b0be83755c3 = (
  { __typename?: 'PageContent_ef87e73bc7ff49a2ac599b0be83755c3' }
  & Pick<Types.PageContent_Ef87e73bc7ff49a2ac599b0be83755c3, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PageDesign = (
  { __typename?: 'PageDesign' }
  & Pick<Types.PageDesign, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0 = (
  { __typename?: 'PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0' }
  & Pick<Types.PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PageDesignFolder_27d4f8be63b045769a4ef3163c935b47 = (
  { __typename?: 'PageDesignFolder_27d4f8be63b045769a4ef3163c935b47' }
  & Pick<Types.PageDesignFolder_27d4f8be63b045769a4ef3163c935b47, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8 = (
  { __typename?: 'PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8' }
  & Pick<Types.PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b = (
  { __typename?: 'PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b' }
  & Pick<Types.PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PageDesignFolder_720d01f11e5046fa9c4a697f9321f662 = (
  { __typename?: 'PageDesignFolder_720d01f11e5046fa9c4a697f9321f662' }
  & Pick<Types.PageDesignFolder_720d01f11e5046fa9c4a697f9321f662, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PageDesignFolder_771a0de7e83f44338c5d78727ead93bc = (
  { __typename?: 'PageDesignFolder_771a0de7e83f44338c5d78727ead93bc' }
  & Pick<Types.PageDesignFolder_771a0de7e83f44338c5d78727ead93bc, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PageDesignFolder_14161ec204984aa7a2a46decadf669f5 = (
  { __typename?: 'PageDesignFolder_14161ec204984aa7a2a46decadf669f5' }
  & Pick<Types.PageDesignFolder_14161ec204984aa7a2a46decadf669f5, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PageDesignFolder_c691c2c4e0dd4fedb84a3c29de7002cb = (
  { __typename?: 'PageDesignFolder_c691c2c4e0dd4fedb84a3c29de7002cb' }
  & Pick<Types.PageDesignFolder_C691c2c4e0dd4fedb84a3c29de7002cb, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PageDesignFolder_d84605f786ea482da6ff683f6572821c = (
  { __typename?: 'PageDesignFolder_d84605f786ea482da6ff683f6572821c' }
  & Pick<Types.PageDesignFolder_D84605f786ea482da6ff683f6572821c, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PageDesign_1105b8f81e00426bbf1fc840742d827b = (
  { __typename?: 'PageDesign_1105b8f81e00426bbf1fc840742d827b' }
  & Pick<Types.PageDesign_1105b8f81e00426bbf1fc840742d827b, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PageDesigns = (
  { __typename?: 'PageDesigns' }
  & Pick<Types.PageDesigns, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PageDesigns_3af52e70e982424b9c85e355542500c9 = (
  { __typename?: 'PageDesigns_3af52e70e982424b9c85e355542500c9' }
  & Pick<Types.PageDesigns_3af52e70e982424b9c85e355542500c9, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PageDesigns_9b34083e890b467d8e76b8c3dbbb712d = (
  { __typename?: 'PageDesigns_9b34083e890b467d8e76b8c3dbbb712d' }
  & Pick<Types.PageDesigns_9b34083e890b467d8e76b8c3dbbb712d, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PageDesigns_48d2d50a150c4f6283603a4fed5646e0 = (
  { __typename?: 'PageDesigns_48d2d50a150c4f6283603a4fed5646e0' }
  & Pick<Types.PageDesigns_48d2d50a150c4f6283603a4fed5646e0, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PageDesigns_99a71bba507746729c3fb29b04abee23 = (
  { __typename?: 'PageDesigns_99a71bba507746729c3fb29b04abee23' }
  & Pick<Types.PageDesigns_99a71bba507746729c3fb29b04abee23, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PageDesigns_a0f265b42d6241968b65d3ede7cb59c3 = (
  { __typename?: 'PageDesigns_a0f265b42d6241968b65d3ede7cb59c3' }
  & Pick<Types.PageDesigns_A0f265b42d6241968b65d3ede7cb59c3, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PageDesigns_abe5ce6a82ff4433b4973bc50f192e11 = (
  { __typename?: 'PageDesigns_abe5ce6a82ff4433b4973bc50f192e11' }
  & Pick<Types.PageDesigns_Abe5ce6a82ff4433b4973bc50f192e11, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PageDesigns_b8d9b352c1694b31bd506848b47ca884 = (
  { __typename?: 'PageDesigns_b8d9b352c1694b31bd506848b47ca884' }
  & Pick<Types.PageDesigns_B8d9b352c1694b31bd506848b47ca884, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PageDesigns_d3b2e1466f744df0900bec314f699ef3 = (
  { __typename?: 'PageDesigns_d3b2e1466f744df0900bec314f699ef3' }
  & Pick<Types.PageDesigns_D3b2e1466f744df0900bec314f699ef3, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PageDesigns_fd4b9b54f7474f01abdeba569d4b5bbe = (
  { __typename?: 'PageDesigns_fd4b9b54f7474f01abdeba569d4b5bbe' }
  & Pick<Types.PageDesigns_Fd4b9b54f7474f01abdeba569d4b5bbe, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PageLevelTabs = (
  { __typename?: 'PageLevelTabs' }
  & Pick<Types.PageLevelTabs, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PageLevelTabsFolder = (
  { __typename?: 'PageLevelTabsFolder' }
  & Pick<Types.PageLevelTabsFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PageList = (
  { __typename?: 'PageList' }
  & Pick<Types.PageList, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PageSelector = (
  { __typename?: 'PageSelector' }
  & Pick<Types.PageSelector, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PageSelectorConfiguration = (
  { __typename?: 'PageSelectorConfiguration' }
  & Pick<Types.PageSelectorConfiguration, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PageSelectorFolder = (
  { __typename?: 'PageSelectorFolder' }
  & Pick<Types.PageSelectorFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PageSelector_59a7bb775f8c435ab810291abde80e63 = (
  { __typename?: 'PageSelector_59a7bb775f8c435ab810291abde80e63' }
  & Pick<Types.PageSelector_59a7bb775f8c435ab810291abde80e63, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PageSize = (
  { __typename?: 'PageSize' }
  & Pick<Types.PageSize, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PageSizeFolder = (
  { __typename?: 'PageSizeFolder' }
  & Pick<Types.PageSizeFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PageSize_b682562e0af64b3e9e3b45273bbe152d = (
  { __typename?: 'PageSize_b682562e0af64b3e9e3b45273bbe152d' }
  & Pick<Types.PageSize_B682562e0af64b3e9e3b45273bbe152d, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PageTheme = (
  { __typename?: 'PageTheme' }
  & Pick<Types.PageTheme, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PageThemesFolder = (
  { __typename?: 'PageThemesFolder' }
  & Pick<Types.PageThemesFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Page_4f49a81db3664f198b89cab92f377d7a = (
  { __typename?: 'Page_4f49a81db3664f198b89cab92f377d7a' }
  & Pick<Types.Page_4f49a81db3664f198b89cab92f377d7a, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Page_5e66d86353544fe6a27d3b894984d50f = (
  { __typename?: 'Page_5e66d86353544fe6a27d3b894984d50f' }
  & Pick<Types.Page_5e66d86353544fe6a27d3b894984d50f, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Page_84f342ad2d0646b9aa9a818201145ca2 = (
  { __typename?: 'Page_84f342ad2d0646b9aa9a818201145ca2' }
  & Pick<Types.Page_84f342ad2d0646b9aa9a818201145ca2, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Page_718df200be51463d93edf4d77ab7a49e = (
  { __typename?: 'Page_718df200be51463d93edf4d77ab7a49e' }
  & Pick<Types.Page_718df200be51463d93edf4d77ab7a49e, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Page_b61d5babe46f4ef39f27b57c4ccefdf7 = (
  { __typename?: 'Page_b61d5babe46f4ef39f27b57c4ccefdf7' }
  & Pick<Types.Page_B61d5babe46f4ef39f27b57c4ccefdf7, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Page_cfd6e04697e24f3cb9eb41b79afc35dc = (
  { __typename?: 'Page_cfd6e04697e24f3cb9eb41b79afc35dc' }
  & Pick<Types.Page_Cfd6e04697e24f3cb9eb41b79afc35dc, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Page_dae7821153e14dbabb0ddf0b53a90aaf = (
  { __typename?: 'Page_dae7821153e14dbabb0ddf0b53a90aaf' }
  & Pick<Types.Page_Dae7821153e14dbabb0ddf0b53a90aaf, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Page_fa608b3e6aeb426388a059d89caabada = (
  { __typename?: 'Page_fa608b3e6aeb426388a059d89caabada' }
  & Pick<Types.Page_Fa608b3e6aeb426388a059d89caabada, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Pagging = (
  { __typename?: 'Pagging' }
  & Pick<Types.Pagging, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Pagination = (
  { __typename?: 'Pagination' }
  & Pick<Types.Pagination, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PaginationFolder = (
  { __typename?: 'PaginationFolder' }
  & Pick<Types.PaginationFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Paragraph = (
  { __typename?: 'Paragraph' }
  & Pick<Types.Paragraph, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PartialDesignFolder_8cf20a4412b746ee801218122c955b2d = (
  { __typename?: 'PartialDesignFolder_8cf20a4412b746ee801218122c955b2d' }
  & Pick<Types.PartialDesignFolder_8cf20a4412b746ee801218122c955b2d, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b = (
  { __typename?: 'PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b' }
  & Pick<Types.PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8 = (
  { __typename?: 'PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8' }
  & Pick<Types.PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b = (
  { __typename?: 'PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b' }
  & Pick<Types.PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PartialDesignFolder_828b5ff144cd4150bcdfe54084165112 = (
  { __typename?: 'PartialDesignFolder_828b5ff144cd4150bcdfe54084165112' }
  & Pick<Types.PartialDesignFolder_828b5ff144cd4150bcdfe54084165112, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PartialDesignFolder_89098e3089aa4062a77346d608caac90 = (
  { __typename?: 'PartialDesignFolder_89098e3089aa4062a77346d608caac90' }
  & Pick<Types.PartialDesignFolder_89098e3089aa4062a77346d608caac90, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PartialDesignFolder_1695576fb93647d7842ed17730278c32 = (
  { __typename?: 'PartialDesignFolder_1695576fb93647d7842ed17730278c32' }
  & Pick<Types.PartialDesignFolder_1695576fb93647d7842ed17730278c32, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PartialDesignFolder_f16ae56fb78845639407c88edaffcbcc = (
  { __typename?: 'PartialDesignFolder_f16ae56fb78845639407c88edaffcbcc' }
  & Pick<Types.PartialDesignFolder_F16ae56fb78845639407c88edaffcbcc, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PartialDesignFolder_fb58558a3ec946d18524cd30805ab21a = (
  { __typename?: 'PartialDesignFolder_fb58558a3ec946d18524cd30805ab21a' }
  & Pick<Types.PartialDesignFolder_Fb58558a3ec946d18524cd30805ab21a, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PartialDesign_fd2059fd60434dfe8c04e2437ce87634 = (
  { __typename?: 'PartialDesign_fd2059fd60434dfe8c04e2437ce87634' }
  & Pick<Types.PartialDesign_Fd2059fd60434dfe8c04e2437ce87634, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PartialDesigns = (
  { __typename?: 'PartialDesigns' }
  & Pick<Types.PartialDesigns, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PartialDesigns_043d3ad0ac4445dba03afc3550d088ec = (
  { __typename?: 'PartialDesigns_043d3ad0ac4445dba03afc3550d088ec' }
  & Pick<Types.PartialDesigns_043d3ad0ac4445dba03afc3550d088ec, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PartialDesigns_0310a4bf20d1441c886a0418c53e30f4 = (
  { __typename?: 'PartialDesigns_0310a4bf20d1441c886a0418c53e30f4' }
  & Pick<Types.PartialDesigns_0310a4bf20d1441c886a0418c53e30f4, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PartialDesigns_36c869ded22040929ce829f6ed643c66 = (
  { __typename?: 'PartialDesigns_36c869ded22040929ce829f6ed643c66' }
  & Pick<Types.PartialDesigns_36c869ded22040929ce829f6ed643c66, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PartialDesigns_1943dc73710a430895515a342c84b037 = (
  { __typename?: 'PartialDesigns_1943dc73710a430895515a342c84b037' }
  & Pick<Types.PartialDesigns_1943dc73710a430895515a342c84b037, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PartialDesigns_b1e2a6790a1442d8bafa66317b8be117 = (
  { __typename?: 'PartialDesigns_b1e2a6790a1442d8bafa66317b8be117' }
  & Pick<Types.PartialDesigns_B1e2a6790a1442d8bafa66317b8be117, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PartialDesigns_cc6d8635f3e2440ab8ebb93dc1030e9e = (
  { __typename?: 'PartialDesigns_cc6d8635f3e2440ab8ebb93dc1030e9e' }
  & Pick<Types.PartialDesigns_Cc6d8635f3e2440ab8ebb93dc1030e9e, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PartialDesigns_d52704ed3b704a53abb4292105f687ad = (
  { __typename?: 'PartialDesigns_d52704ed3b704a53abb4292105f687ad' }
  & Pick<Types.PartialDesigns_D52704ed3b704a53abb4292105f687ad, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PartialDesigns_d216303f58d8425688da8cd30d00afab = (
  { __typename?: 'PartialDesigns_d216303f58d8425688da8cd30d00afab' }
  & Pick<Types.PartialDesigns_D216303f58d8425688da8cd30d00afab, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PartialDesigns_facda26791204fa9a0363344348f2c42 = (
  { __typename?: 'PartialDesigns_facda26791204fa9a0363344348f2c42' }
  & Pick<Types.PartialDesigns_Facda26791204fa9a0363344348f2c42, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PerformanceChartSettings = (
  { __typename?: 'PerformanceChartSettings' }
  & Pick<Types.PerformanceChartSettings, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PerformanceChartTimePeriod = (
  { __typename?: 'PerformanceChartTimePeriod' }
  & Pick<Types.PerformanceChartTimePeriod, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PerformanceChartTimePeriodFolder = (
  { __typename?: 'PerformanceChartTimePeriodFolder' }
  & Pick<Types.PerformanceChartTimePeriodFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80 = (
  { __typename?: 'PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80' }
  & Pick<Types.PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d = (
  { __typename?: 'PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d' }
  & Pick<Types.PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba = (
  { __typename?: 'PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba' }
  & Pick<Types.PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Placeholder_1ca0304be5b64810821154426f1752c2 = (
  { __typename?: 'Placeholder_1ca0304be5b64810821154426f1752c2' }
  & Pick<Types.Placeholder_1ca0304be5b64810821154426f1752c2, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Placeholder_d2a6884c04d54089a64ed27ca9d68d4c = (
  { __typename?: 'Placeholder_d2a6884c04d54089a64ed27ca9d68d4c' }
  & Pick<Types.Placeholder_D2a6884c04d54089a64ed27ca9d68d4c, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PlainHtmlParametersTemplate = (
  { __typename?: 'PlainHtmlParametersTemplate' }
  & Pick<Types.PlainHtmlParametersTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Playlist = (
  { __typename?: 'Playlist' }
  & Pick<Types.Playlist, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PlaylistFolder = (
  { __typename?: 'PlaylistFolder' }
  & Pick<Types.PlaylistFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PlaylistParametersTemplate = (
  { __typename?: 'PlaylistParametersTemplate' }
  & Pick<Types.PlaylistParametersTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Podcast = (
  { __typename?: 'Podcast' }
  & Pick<Types.Podcast, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PodcastFolder = (
  { __typename?: 'PodcastFolder' }
  & Pick<Types.PodcastFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PodcastPage = (
  { __typename?: 'PodcastPage' }
  & Pick<Types.PodcastPage, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PodcastPressReleasePage = (
  { __typename?: 'PodcastPressReleasePage' }
  & Pick<Types.PodcastPressReleasePage, 'id'>
  & { pressReleaseTitle: Types.Maybe<PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseTitle_TextField>, pressReleaseDescription: Types.Maybe<PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseDescription_TextField>, pressReleasePlatform: Types.Maybe<PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField>, pressReleaseContentType: Types.Maybe<PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField>, pressReleasePublicationDate: Types.Maybe<PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePublicationDate_DateField>, template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PoiTypes = (
  { __typename?: 'PoiTypes' }
  & Pick<Types.PoiTypes, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PostDeleteStep = (
  { __typename?: 'PostDeleteStep' }
  & Pick<Types.PostDeleteStep, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574 = (
  { __typename?: 'PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574' }
  & Pick<Types.PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PostDeleteStep_78d6ec9b66e34763987003cf314ee37a = (
  { __typename?: 'PostDeleteStep_78d6ec9b66e34763987003cf314ee37a' }
  & Pick<Types.PostDeleteStep_78d6ec9b66e34763987003cf314ee37a, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PostDeleteStep_b20857895385413883f096f3767cb156 = (
  { __typename?: 'PostDeleteStep_b20857895385413883f096f3767cb156' }
  & Pick<Types.PostDeleteStep_B20857895385413883f096f3767cb156, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PostSetupStep = (
  { __typename?: 'PostSetupStep' }
  & Pick<Types.PostSetupStep, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PostSetupStep_6fac654e22154a419a1d59197bebc0fe = (
  { __typename?: 'PostSetupStep_6fac654e22154a419a1d59197bebc0fe' }
  & Pick<Types.PostSetupStep_6fac654e22154a419a1d59197bebc0fe, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f = (
  { __typename?: 'PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f' }
  & Pick<Types.PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PostSetupStep_341738aa44fe490e90ff7010a3c2463b = (
  { __typename?: 'PostSetupStep_341738aa44fe490e90ff7010a3c2463b' }
  & Pick<Types.PostSetupStep_341738aa44fe490e90ff7010a3c2463b, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PreDeleteStep = (
  { __typename?: 'PreDeleteStep' }
  & Pick<Types.PreDeleteStep, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49 = (
  { __typename?: 'PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49' }
  & Pick<Types.PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b = (
  { __typename?: 'PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b' }
  & Pick<Types.PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PreDeleteStep_f0daf401190f45468bda8568d08e161d = (
  { __typename?: 'PreDeleteStep_f0daf401190f45468bda8568d08e161d' }
  & Pick<Types.PreDeleteStep_F0daf401190f45468bda8568d08e161d, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PreDeleteValidationStep = (
  { __typename?: 'PreDeleteValidationStep' }
  & Pick<Types.PreDeleteValidationStep, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f = (
  { __typename?: 'PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f' }
  & Pick<Types.PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PreDeleteValidationStep_edf1fa4206c44703ab1af23495bc6d8f = (
  { __typename?: 'PreDeleteValidationStep_edf1fa4206c44703ab1af23495bc6d8f' }
  & Pick<Types.PreDeleteValidationStep_Edf1fa4206c44703ab1af23495bc6d8f, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PreDeleteValidationStep_f8c52120d0ea4d009de3b49fe12a3f1e = (
  { __typename?: 'PreDeleteValidationStep_f8c52120d0ea4d009de3b49fe12a3f1e' }
  & Pick<Types.PreDeleteValidationStep_F8c52120d0ea4d009de3b49fe12a3f1e, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Presentation = (
  { __typename?: 'Presentation' }
  & Pick<Types.Presentation, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Presentation_0a70fa7389234a6eabf34134f25f3221 = (
  { __typename?: 'Presentation_0a70fa7389234a6eabf34134f25f3221' }
  & Pick<Types.Presentation_0a70fa7389234a6eabf34134f25f3221, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PressReleaseContentType = (
  { __typename?: 'PressReleaseContentType' }
  & Pick<Types.PressReleaseContentType, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PressReleaseContentTypesFolder = (
  { __typename?: 'PressReleaseContentTypesFolder' }
  & Pick<Types.PressReleaseContentTypesFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PressReleaseFilter = (
  { __typename?: 'PressReleaseFilter' }
  & Pick<Types.PressReleaseFilter, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PressReleasePage = (
  { __typename?: 'PressReleasePage' }
  & Pick<Types.PressReleasePage, 'id'>
  & { pressReleaseTitle: Types.Maybe<PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseTitle_TextField>, pressReleaseDescription: Types.Maybe<PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseDescription_TextField>, pressReleasePlatform: Types.Maybe<PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField>, pressReleaseContentType: Types.Maybe<PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField>, pressReleasePublicationDate: Types.Maybe<PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePublicationDate_DateField>, template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PressReleasePlatform = (
  { __typename?: 'PressReleasePlatform' }
  & Pick<Types.PressReleasePlatform, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PressReleasePlatformsFolder = (
  { __typename?: 'PressReleasePlatformsFolder' }
  & Pick<Types.PressReleasePlatformsFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PressReleaseSearchPage = (
  { __typename?: 'PressReleaseSearchPage' }
  & Pick<Types.PressReleaseSearchPage, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f = (
  { __typename?: 'PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f' }
  & Pick<Types.PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PressReleaseSearchPage_a6c344ca7c6946009de2ca92e27d7b72 = (
  { __typename?: 'PressReleaseSearchPage_a6c344ca7c6946009de2ca92e27d7b72' }
  & Pick<Types.PressReleaseSearchPage_A6c344ca7c6946009de2ca92e27d7b72, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PressReleaseSearchPage_b9cd16f585ea4405a1ceda10cb20f64d = (
  { __typename?: 'PressReleaseSearchPage_b9cd16f585ea4405a1ceda10cb20f64d' }
  & Pick<Types.PressReleaseSearchPage_B9cd16f585ea4405a1ceda10cb20f64d, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PressReleaseSearchPage_c97027442df647cf9c36eedfc6787f58 = (
  { __typename?: 'PressReleaseSearchPage_c97027442df647cf9c36eedfc6787f58' }
  & Pick<Types.PressReleaseSearchPage_C97027442df647cf9c36eedfc6787f58, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PressReleaseWildcardPage = (
  { __typename?: 'PressReleaseWildcardPage' }
  & Pick<Types.PressReleaseWildcardPage, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e = (
  { __typename?: 'PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e' }
  & Pick<Types.PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79 = (
  { __typename?: 'PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79' }
  & Pick<Types.PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PressReleaseWildcardPage_b337d30403c642d2b9757e23d08223a1 = (
  { __typename?: 'PressReleaseWildcardPage_b337d30403c642d2b9757e23d08223a1' }
  & Pick<Types.PressReleaseWildcardPage_B337d30403c642d2b9757e23d08223a1, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PressReleaseWildcardPage_e55e9d5bf9614e30b0a2a90327428258 = (
  { __typename?: 'PressReleaseWildcardPage_e55e9d5bf9614e30b0a2a90327428258' }
  & Pick<Types.PressReleaseWildcardPage_E55e9d5bf9614e30b0a2a90327428258, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PressReleasesGroupFolder = (
  { __typename?: 'PressReleasesGroupFolder' }
  & Pick<Types.PressReleasesGroupFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PrivacyWarning = (
  { __typename?: 'PrivacyWarning' }
  & Pick<Types.PrivacyWarning, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ProjectFolder = (
  { __typename?: 'ProjectFolder' }
  & Pick<Types.ProjectFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Promo = (
  { __typename?: 'Promo' }
  & Pick<Types.Promo, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PromoFolder = (
  { __typename?: 'PromoFolder' }
  & Pick<Types.PromoFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PromoFolder_f07cbe8973ae4de692172570260cac6e = (
  { __typename?: 'PromoFolder_f07cbe8973ae4de692172570260cac6e' }
  & Pick<Types.PromoFolder_F07cbe8973ae4de692172570260cac6e, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Promo_7f21f14d096b4f27bbccf115c6e6f6f1 = (
  { __typename?: 'Promo_7f21f14d096b4f27bbccf115c6e6f6f1' }
  & Pick<Types.Promo_7f21f14d096b4f27bbccf115c6e6f6f1, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Promo_881869ca7f5845ea8b34ad1bfd3551a8 = (
  { __typename?: 'Promo_881869ca7f5845ea8b34ad1bfd3551a8' }
  & Pick<Types.Promo_881869ca7f5845ea8b34ad1bfd3551a8, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Promo_dfed4457d760457abec1c0dccdc44381 = (
  { __typename?: 'Promo_dfed4457d760457abec1c0dccdc44381' }
  & Pick<Types.Promo_Dfed4457d760457abec1c0dccdc44381, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PromotedContent = (
  { __typename?: 'PromotedContent' }
  & Pick<Types.PromotedContent, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PromotedContentFolder = (
  { __typename?: 'PromotedContentFolder' }
  & Pick<Types.PromotedContentFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PropertyListingCard = (
  { __typename?: 'PropertyListingCard' }
  & Pick<Types.PropertyListingCard, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PropertyListingCards = (
  { __typename?: 'PropertyListingCards' }
  & Pick<Types.PropertyListingCards, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PropertyListingCategory = (
  { __typename?: 'PropertyListingCategory' }
  & Pick<Types.PropertyListingCategory, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_PropertyListingFolder = (
  { __typename?: 'PropertyListingFolder' }
  & Pick<Types.PropertyListingFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Query_98b413525a4b4067b92418a4b50f0a53 = (
  { __typename?: 'Query_98b413525a4b4067b92418a4b50f0a53' }
  & Pick<Types.Query_98b413525a4b4067b92418a4b50f0a53, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_QuickLinks = (
  { __typename?: 'QuickLinks' }
  & Pick<Types.QuickLinks, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_QuickLinksFolder = (
  { __typename?: 'QuickLinksFolder' }
  & Pick<Types.QuickLinksFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_QuickLinksParametersTemplate = (
  { __typename?: 'QuickLinksParametersTemplate' }
  & Pick<Types.QuickLinksParametersTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_QuotationBlockItem = (
  { __typename?: 'QuotationBlockItem' }
  & Pick<Types.QuotationBlockItem, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_QuotationBlocks = (
  { __typename?: 'QuotationBlocks' }
  & Pick<Types.QuotationBlocks, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_QuotationBlocksFolder = (
  { __typename?: 'QuotationBlocksFolder' }
  & Pick<Types.QuotationBlocksFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_QuotationBlocksParametersTemplate = (
  { __typename?: 'QuotationBlocksParametersTemplate' }
  & Pick<Types.QuotationBlocksParametersTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Quote = (
  { __typename?: 'Quote' }
  & Pick<Types.Quote, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_QuoteFolder = (
  { __typename?: 'QuoteFolder' }
  & Pick<Types.QuoteFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_QuoteParametersTemplate = (
  { __typename?: 'QuoteParametersTemplate' }
  & Pick<Types.QuoteParametersTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_RadiusFilter = (
  { __typename?: 'RadiusFilter' }
  & Pick<Types.RadiusFilter, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_RadiusFilterFolder = (
  { __typename?: 'RadiusFilterFolder' }
  & Pick<Types.RadiusFilterFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_RadiusFilter_de3fa58eef9d45449f77dcd1dbb05b64 = (
  { __typename?: 'RadiusFilter_de3fa58eef9d45449f77dcd1dbb05b64' }
  & Pick<Types.RadiusFilter_De3fa58eef9d45449f77dcd1dbb05b64, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_RadiusScheme = (
  { __typename?: 'RadiusScheme' }
  & Pick<Types.RadiusScheme, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_RadiusSchemeValue = (
  { __typename?: 'RadiusSchemeValue' }
  & Pick<Types.RadiusSchemeValue, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_RangeSliderFilter = (
  { __typename?: 'RangeSliderFilter' }
  & Pick<Types.RangeSliderFilter, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_RangeSliderFilterFolder = (
  { __typename?: 'RangeSliderFilterFolder' }
  & Pick<Types.RangeSliderFilterFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_RangeSliderFilter_0a1787c296b54d40828522564a5d8e03 = (
  { __typename?: 'RangeSliderFilter_0a1787c296b54d40828522564a5d8e03' }
  & Pick<Types.RangeSliderFilter_0a1787c296b54d40828522564a5d8e03, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_RecentArticles = (
  { __typename?: 'RecentArticles' }
  & Pick<Types.RecentArticles, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Redirect = (
  { __typename?: 'Redirect' }
  & Pick<Types.Redirect, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_RedirectMap = (
  { __typename?: 'RedirectMap' }
  & Pick<Types.RedirectMap, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_RedirectMaps = (
  { __typename?: 'RedirectMaps' }
  & Pick<Types.RedirectMaps, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Region = (
  { __typename?: 'Region' }
  & Pick<Types.Region, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_RegionLanguages = (
  { __typename?: 'RegionLanguages' }
  & Pick<Types.RegionLanguages, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_RegionLanguagesFolder = (
  { __typename?: 'RegionLanguagesFolder' }
  & Pick<Types.RegionLanguagesFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_RelatedArticles = (
  { __typename?: 'RelatedArticles' }
  & Pick<Types.RelatedArticles, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_RelatedArticlesParametersTemplate = (
  { __typename?: 'RelatedArticlesParametersTemplate' }
  & Pick<Types.RelatedArticlesParametersTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_RenderEngineType = (
  { __typename?: 'RenderEngineType' }
  & Pick<Types.RenderEngineType, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_RenderingFolder_840d4a46550349ecbf9dbd090946c63d = (
  { __typename?: 'RenderingFolder_840d4a46550349ecbf9dbd090946c63d' }
  & Pick<Types.RenderingFolder_840d4a46550349ecbf9dbd090946c63d, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_RenderingHost = (
  { __typename?: 'RenderingHost' }
  & Pick<Types.RenderingHost, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ResizableIFramePage = (
  { __typename?: 'ResizableIFramePage' }
  & Pick<Types.ResizableIFramePage, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067 = (
  { __typename?: 'ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067' }
  & Pick<Types.ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68 = (
  { __typename?: 'ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68' }
  & Pick<Types.ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ResizableIFramePage_b58eacfb27f5417bb536141f94b92521 = (
  { __typename?: 'ResizableIFramePage_b58eacfb27f5417bb536141f94b92521' }
  & Pick<Types.ResizableIFramePage_B58eacfb27f5417bb536141f94b92521, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ResizableIFramePage_d8d76a2407084147bf3900cd5e12e401 = (
  { __typename?: 'ResizableIFramePage_d8d76a2407084147bf3900cd5e12e401' }
  & Pick<Types.ResizableIFramePage_D8d76a2407084147bf3900cd5e12e401, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ResizableIFramePage_f460ab055585441892023750e7cef6b7 = (
  { __typename?: 'ResizableIFramePage_f460ab055585441892023750e7cef6b7' }
  & Pick<Types.ResizableIFramePage_F460ab055585441892023750e7cef6b7, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ResponsiveImage = (
  { __typename?: 'ResponsiveImage' }
  & Pick<Types.ResponsiveImage, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ResultsCount = (
  { __typename?: 'ResultsCount' }
  & Pick<Types.ResultsCount, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ResultsCountFolder = (
  { __typename?: 'ResultsCountFolder' }
  & Pick<Types.ResultsCountFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ResultsCount_f3c0661ef9a9444ca26d44bf2a68a186 = (
  { __typename?: 'ResultsCount_f3c0661ef9a9444ca26d44bf2a68a186' }
  & Pick<Types.ResultsCount_F3c0661ef9a9444ca26d44bf2a68a186, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ResultsVariantSelector = (
  { __typename?: 'ResultsVariantSelector' }
  & Pick<Types.ResultsVariantSelector, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_RichText = (
  { __typename?: 'RichText' }
  & Pick<Types.RichText, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_RichTextFolder = (
  { __typename?: 'RichTextFolder' }
  & Pick<Types.RichTextFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_RichText_0f3b73366112418c8bbab0526f3887ce = (
  { __typename?: 'RichText_0f3b73366112418c8bbab0526f3887ce' }
  & Pick<Types.RichText_0f3b73366112418c8bbab0526f3887ce, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_RichText_efcfd8f6596745f48f85b5421928205d = (
  { __typename?: 'RichText_efcfd8f6596745f48f85b5421928205d' }
  & Pick<Types.RichText_Efcfd8f6596745f48f85b5421928205d, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_RiskImageMapping = (
  { __typename?: 'RiskImageMapping' }
  & Pick<Types.RiskImageMapping, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_RiskImageMappings = (
  { __typename?: 'RiskImageMappings' }
  & Pick<Types.RiskImageMappings, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_RiskLevelOption = (
  { __typename?: 'RiskLevelOption' }
  & Pick<Types.RiskLevelOption, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_RiskLevelOptionFolder = (
  { __typename?: 'RiskLevelOptionFolder' }
  & Pick<Types.RiskLevelOptionFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_RiskWarning = (
  { __typename?: 'RiskWarning' }
  & Pick<Types.RiskWarning, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_RiskWarningFolder = (
  { __typename?: 'RiskWarningFolder' }
  & Pick<Types.RiskWarningFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_RiskWarningParametersTemplate = (
  { __typename?: 'RiskWarningParametersTemplate' }
  & Pick<Types.RiskWarningParametersTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_RolePlaceholder = (
  { __typename?: 'RolePlaceholder' }
  & Pick<Types.RolePlaceholder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_RowSplitter = (
  { __typename?: 'RowSplitter' }
  & Pick<Types.RowSplitter, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_RowSplitter_340c887da1d1415b9678c763af74ea97 = (
  { __typename?: 'RowSplitter_340c887da1d1415b9678c763af74ea97' }
  & Pick<Types.RowSplitter_340c887da1d1415b9678c763af74ea97, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Rule = (
  { __typename?: 'Rule' }
  & Pick<Types.Rule, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SDRLogoMapping = (
  { __typename?: 'SDRLogoMapping' }
  & Pick<Types.SdrLogoMapping, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SDRLogoMappings = (
  { __typename?: 'SDRLogoMappings' }
  & Pick<Types.SdrLogoMappings, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SDRTypeOption = (
  { __typename?: 'SDRTypeOption' }
  & Pick<Types.SdrTypeOption, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SDRTypeOptionFolder = (
  { __typename?: 'SDRTypeOptionFolder' }
  & Pick<Types.SdrTypeOptionFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SXAJSSLayout = (
  { __typename?: 'SXAJSSLayout' }
  & Pick<Types.SxajssLayout, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SXARole = (
  { __typename?: 'SXARole' }
  & Pick<Types.SxaRole, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SXAStandardValuesFolder = (
  { __typename?: 'SXAStandardValuesFolder' }
  & Pick<Types.SxaStandardValuesFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SalesforceAlertMessage = (
  { __typename?: 'SalesforceAlertMessage' }
  & Pick<Types.SalesforceAlertMessage, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SalesforceCheckBox = (
  { __typename?: 'SalesforceCheckBox' }
  & Pick<Types.SalesforceCheckBox, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SalesforceCheckBoxType = (
  { __typename?: 'SalesforceCheckBoxType' }
  & Pick<Types.SalesforceCheckBoxType, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SalesforceConditionalRadioButton = (
  { __typename?: 'SalesforceConditionalRadioButton' }
  & Pick<Types.SalesforceConditionalRadioButton, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SalesforceConditionalRadioButtons = (
  { __typename?: 'SalesforceConditionalRadioButtons' }
  & Pick<Types.SalesforceConditionalRadioButtons, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SalesforceDateInput = (
  { __typename?: 'SalesforceDateInput' }
  & Pick<Types.SalesforceDateInput, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SalesforceDropdown = (
  { __typename?: 'SalesforceDropdown' }
  & Pick<Types.SalesforceDropdown, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SalesforceDropdownOption = (
  { __typename?: 'SalesforceDropdownOption' }
  & Pick<Types.SalesforceDropdownOption, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SalesforceHiddenField = (
  { __typename?: 'SalesforceHiddenField' }
  & Pick<Types.SalesforceHiddenField, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SalesforceInput = (
  { __typename?: 'SalesforceInput' }
  & Pick<Types.SalesforceInput, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SalesforceInputType = (
  { __typename?: 'SalesforceInputType' }
  & Pick<Types.SalesforceInputType, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SalesforceIntegratedForm = (
  { __typename?: 'SalesforceIntegratedForm' }
  & Pick<Types.SalesforceIntegratedForm, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SalesforceIntegratedFormTypesFolder = (
  { __typename?: 'SalesforceIntegratedFormTypesFolder' }
  & Pick<Types.SalesforceIntegratedFormTypesFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SalesforceRepeatableSubSection = (
  { __typename?: 'SalesforceRepeatableSubSection' }
  & Pick<Types.SalesforceRepeatableSubSection, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SalesforceRichTextArea = (
  { __typename?: 'SalesforceRichTextArea' }
  & Pick<Types.SalesforceRichTextArea, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SalesforceSection = (
  { __typename?: 'SalesforceSection' }
  & Pick<Types.SalesforceSection, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SalesforceSortCodeInput = (
  { __typename?: 'SalesforceSortCodeInput' }
  & Pick<Types.SalesforceSortCodeInput, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SalesforceSubmissionType = (
  { __typename?: 'SalesforceSubmissionType' }
  & Pick<Types.SalesforceSubmissionType, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Scope = (
  { __typename?: 'Scope' }
  & Pick<Types.Scope, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ScopesFolder = (
  { __typename?: 'ScopesFolder' }
  & Pick<Types.ScopesFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Scriban = (
  { __typename?: 'Scriban' }
  & Pick<Types.Scriban, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Scripts = (
  { __typename?: 'Scripts' }
  & Pick<Types.Scripts, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SearchBox = (
  { __typename?: 'SearchBox' }
  & Pick<Types.SearchBox, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SearchBoxFolder = (
  { __typename?: 'SearchBoxFolder' }
  & Pick<Types.SearchBoxFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SearchBox_1c04fd611d874590acfe9cc186865ab3 = (
  { __typename?: 'SearchBox_1c04fd611d874590acfe9cc186865ab3' }
  & Pick<Types.SearchBox_1c04fd611d874590acfe9cc186865ab3, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SearchFolder = (
  { __typename?: 'SearchFolder' }
  & Pick<Types.SearchFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SearchResults = (
  { __typename?: 'SearchResults' }
  & Pick<Types.SearchResults, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SearchResultsFolder = (
  { __typename?: 'SearchResultsFolder' }
  & Pick<Types.SearchResultsFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SearchResults_a06f7130041d46bb8c2995a2dc00c26a = (
  { __typename?: 'SearchResults_a06f7130041d46bb8c2995a2dc00c26a' }
  & Pick<Types.SearchResults_A06f7130041d46bb8c2995a2dc00c26a, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SecondaryHeroBannerParametersTemplate = (
  { __typename?: 'SecondaryHeroBannerParametersTemplate' }
  & Pick<Types.SecondaryHeroBannerParametersTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SectionHeading = (
  { __typename?: 'SectionHeading' }
  & Pick<Types.SectionHeading, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SectionHeadingFolder = (
  { __typename?: 'SectionHeadingFolder' }
  & Pick<Types.SectionHeadingFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SectionHeadingParametersTemplate = (
  { __typename?: 'SectionHeadingParametersTemplate' }
  & Pick<Types.SectionHeadingParametersTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SectionHeadingType = (
  { __typename?: 'SectionHeadingType' }
  & Pick<Types.SectionHeadingType, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SectionHeadingTypeFolder = (
  { __typename?: 'SectionHeadingTypeFolder' }
  & Pick<Types.SectionHeadingTypeFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SectionSelector = (
  { __typename?: 'SectionSelector' }
  & Pick<Types.SectionSelector, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SectionSelectorFolder = (
  { __typename?: 'SectionSelectorFolder' }
  & Pick<Types.SectionSelectorFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SectionSelectorTab = (
  { __typename?: 'SectionSelectorTab' }
  & Pick<Types.SectionSelectorTab, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Security_33077d51ebad4d1cb4a83b79f51dba13 = (
  { __typename?: 'Security_33077d51ebad4d1cb4a83b79f51dba13' }
  & Pick<Types.Security_33077d51ebad4d1cb4a83b79f51dba13, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Series = (
  { __typename?: 'Series' }
  & Pick<Types.Series, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SeriesFolder = (
  { __typename?: 'SeriesFolder' }
  & Pick<Types.SeriesFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Settings = (
  { __typename?: 'Settings' }
  & Pick<Types.Settings, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SettingsFolder = (
  { __typename?: 'SettingsFolder' }
  & Pick<Types.SettingsFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Settings_6c82caca67dc464195698faad083230e = (
  { __typename?: 'Settings_6c82caca67dc464195698faad083230e' }
  & Pick<Types.Settings_6c82caca67dc464195698faad083230e, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SharePriceSettings = (
  { __typename?: 'SharePriceSettings' }
  & Pick<Types.SharePriceSettings, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SharedArticlesFolder = (
  { __typename?: 'SharedArticlesFolder' }
  & Pick<Types.SharedArticlesFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SharedContentFolder = (
  { __typename?: 'SharedContentFolder' }
  & Pick<Types.SharedContentFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SharedFolder = (
  { __typename?: 'SharedFolder' }
  & Pick<Types.SharedFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SharedHelpArticlesFolder = (
  { __typename?: 'SharedHelpArticlesFolder' }
  & Pick<Types.SharedHelpArticlesFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SharedPressReleasesFolder = (
  { __typename?: 'SharedPressReleasesFolder' }
  & Pick<Types.SharedPressReleasesFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SharedSettingsFolder = (
  { __typename?: 'SharedSettingsFolder' }
  & Pick<Types.SharedSettingsFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SharedSitesSettings = (
  { __typename?: 'SharedSitesSettings' }
  & Pick<Types.SharedSitesSettings, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SharedSitesSettings_c14bf746030f4e598594395f6d299e61 = (
  { __typename?: 'SharedSitesSettings_c14bf746030f4e598594395f6d299e61' }
  & Pick<Types.SharedSitesSettings_C14bf746030f4e598594395f6d299e61, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Showcase = (
  { __typename?: 'Showcase' }
  & Pick<Types.Showcase, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ShowcaseFolder = (
  { __typename?: 'ShowcaseFolder' }
  & Pick<Types.ShowcaseFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ShowcaseItem = (
  { __typename?: 'ShowcaseItem' }
  & Pick<Types.ShowcaseItem, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ShowcaseParametersTemplate = (
  { __typename?: 'ShowcaseParametersTemplate' }
  & Pick<Types.ShowcaseParametersTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Site = (
  { __typename?: 'Site' }
  & Pick<Types.Site, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SiteContentFolder = (
  { __typename?: 'SiteContentFolder' }
  & Pick<Types.SiteContentFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SiteDefinition = (
  { __typename?: 'SiteDefinition' }
  & Pick<Types.SiteDefinition, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SiteEntryDisclaimer = (
  { __typename?: 'SiteEntryDisclaimer' }
  & Pick<Types.SiteEntryDisclaimer, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SiteFolder = (
  { __typename?: 'SiteFolder' }
  & Pick<Types.SiteFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SiteGrouping = (
  { __typename?: 'SiteGrouping' }
  & Pick<Types.SiteGrouping, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SiteManagement = (
  { __typename?: 'SiteManagement' }
  & Pick<Types.SiteManagement, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SiteSecurityItemPointer = (
  { __typename?: 'SiteSecurityItemPointer' }
  & Pick<Types.SiteSecurityItemPointer, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SiteSelector = (
  { __typename?: 'SiteSelector' }
  & Pick<Types.SiteSelector, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SiteSelector_a44632f56dcd4d10b4892f4e35e193c3 = (
  { __typename?: 'SiteSelector_a44632f56dcd4d10b4892f4e35e193c3' }
  & Pick<Types.SiteSelector_A44632f56dcd4d10b4892f4e35e193c3, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SiteSetupRoot = (
  { __typename?: 'SiteSetupRoot' }
  & Pick<Types.SiteSetupRoot, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SiteTheme = (
  { __typename?: 'SiteTheme' }
  & Pick<Types.SiteTheme, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Site_e46f3af239fa4866a1577017c4b2a40c = (
  { __typename?: 'Site_e46f3af239fa4866a1577017c4b2a40c' }
  & Pick<Types.Site_E46f3af239fa4866a1577017c4b2a40c, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SitecoreFormWrapperParametersTemplate = (
  { __typename?: 'SitecoreFormWrapperParametersTemplate' }
  & Pick<Types.SitecoreFormWrapperParametersTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SitecoreRole = (
  { __typename?: 'SitecoreRole' }
  & Pick<Types.SitecoreRole, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SitemapSettings_c71d856635c849b7a84d9d176e9cbd05 = (
  { __typename?: 'SitemapSettings_c71d856635c849b7a84d9d176e9cbd05' }
  & Pick<Types.SitemapSettings_C71d856635c849b7a84d9d176e9cbd05, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SkipLink = (
  { __typename?: 'SkipLink' }
  & Pick<Types.SkipLink, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SkipLinkParameters = (
  { __typename?: 'SkipLinkParameters' }
  & Pick<Types.SkipLinkParameters, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SkipLinksFolder = (
  { __typename?: 'SkipLinksFolder' }
  & Pick<Types.SkipLinksFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Snippet = (
  { __typename?: 'Snippet' }
  & Pick<Types.Snippet, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SnippetItem = (
  { __typename?: 'SnippetItem' }
  & Pick<Types.SnippetItem, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SnippetsFolder = (
  { __typename?: 'SnippetsFolder' }
  & Pick<Types.SnippetsFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SocialLoginWrapper = (
  { __typename?: 'SocialLoginWrapper' }
  & Pick<Types.SocialLoginWrapper, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SocialMediaButtons = (
  { __typename?: 'SocialMediaButtons' }
  & Pick<Types.SocialMediaButtons, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SocialMediaFolder = (
  { __typename?: 'SocialMediaFolder' }
  & Pick<Types.SocialMediaFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SocialMediaShare = (
  { __typename?: 'SocialMediaShare' }
  & Pick<Types.SocialMediaShare, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SocialMediaTemplate = (
  { __typename?: 'SocialMediaTemplate' }
  & Pick<Types.SocialMediaTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SocialNetwork = (
  { __typename?: 'SocialNetwork' }
  & Pick<Types.SocialNetwork, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SocialNetworkFolder = (
  { __typename?: 'SocialNetworkFolder' }
  & Pick<Types.SocialNetworkFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SocialNetworkLink = (
  { __typename?: 'SocialNetworkLink' }
  & Pick<Types.SocialNetworkLink, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SolutionTemplate = (
  { __typename?: 'SolutionTemplate' }
  & Pick<Types.SolutionTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SortResults = (
  { __typename?: 'SortResults' }
  & Pick<Types.SortResults, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SortResultsFolder = (
  { __typename?: 'SortResultsFolder' }
  & Pick<Types.SortResultsFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Sorting = (
  { __typename?: 'Sorting' }
  & Pick<Types.Sorting, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SortingGroups = (
  { __typename?: 'SortingGroups' }
  & Pick<Types.SortingGroups, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SpotifyPodcast = (
  { __typename?: 'SpotifyPodcast' }
  & Pick<Types.SpotifyPodcast, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SpotifyPodcastFolder = (
  { __typename?: 'SpotifyPodcastFolder' }
  & Pick<Types.SpotifyPodcastFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_StickyCTA = (
  { __typename?: 'StickyCTA' }
  & Pick<Types.StickyCta, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_StickyCTAFolder = (
  { __typename?: 'StickyCTAFolder' }
  & Pick<Types.StickyCtaFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_StickyCTAParametersTemplate = (
  { __typename?: 'StickyCTAParametersTemplate' }
  & Pick<Types.StickyCtaParametersTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_StrategiesInFocusFolder = (
  { __typename?: 'StrategiesInFocusFolder' }
  & Pick<Types.StrategiesInFocusFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_StrategyInFocus = (
  { __typename?: 'StrategyInFocus' }
  & Pick<Types.StrategyInFocus, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Style = (
  { __typename?: 'Style' }
  & Pick<Types.Style, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Styles = (
  { __typename?: 'Styles' }
  & Pick<Types.Styles, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Styles_9c0dac2808aa4b44bc2153363206f6a5 = (
  { __typename?: 'Styles_9c0dac2808aa4b44bc2153363206f6a5' }
  & Pick<Types.Styles_9c0dac2808aa4b44bc2153363206f6a5, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_SubscriptionBannerParametersTemplate = (
  { __typename?: 'SubscriptionBannerParametersTemplate' }
  & Pick<Types.SubscriptionBannerParametersTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Tab = (
  { __typename?: 'Tab' }
  & Pick<Types.Tab, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TabItem = (
  { __typename?: 'TabItem' }
  & Pick<Types.TabItem, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TableOfContents = (
  { __typename?: 'TableOfContents' }
  & Pick<Types.TableOfContents, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TableOfContentsFolder = (
  { __typename?: 'TableOfContentsFolder' }
  & Pick<Types.TableOfContentsFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TableOfContentsSection = (
  { __typename?: 'TableOfContentsSection' }
  & Pick<Types.TableOfContentsSection, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TableOfContentsSubsection = (
  { __typename?: 'TableOfContentsSubsection' }
  & Pick<Types.TableOfContentsSubsection, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Tabs = (
  { __typename?: 'Tabs' }
  & Pick<Types.Tabs, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TabsFolder = (
  { __typename?: 'TabsFolder' }
  & Pick<Types.TabsFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Tabs_f26a9560ccf148c59542800e837caf7a = (
  { __typename?: 'Tabs_f26a9560ccf148c59542800e837caf7a' }
  & Pick<Types.Tabs_F26a9560ccf148c59542800e837caf7a, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Tag = (
  { __typename?: 'Tag' }
  & Pick<Types.Tag, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TagCloud = (
  { __typename?: 'TagCloud' }
  & Pick<Types.TagCloud, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TagFolder = (
  { __typename?: 'TagFolder' }
  & Pick<Types.TagFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TagList = (
  { __typename?: 'TagList' }
  & Pick<Types.TagList, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TeamBiographySettings = (
  { __typename?: 'TeamBiographySettings' }
  & Pick<Types.TeamBiographySettings, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TeamListingCards = (
  { __typename?: 'TeamListingCards' }
  & Pick<Types.TeamListingCards, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TeamListingCardsFolder = (
  { __typename?: 'TeamListingCardsFolder' }
  & Pick<Types.TeamListingCardsFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TeamMember = (
  { __typename?: 'TeamMember' }
  & Pick<Types.TeamMember, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TeamMemberCard = (
  { __typename?: 'TeamMemberCard' }
  & Pick<Types.TeamMemberCard, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TeamMembers = (
  { __typename?: 'TeamMembers' }
  & Pick<Types.TeamMembers, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TeamMembersParentPage = (
  { __typename?: 'TeamMembersParentPage' }
  & Pick<Types.TeamMembersParentPage, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e = (
  { __typename?: 'TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e' }
  & Pick<Types.TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e = (
  { __typename?: 'TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e' }
  & Pick<Types.TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TeamMembersParentPage_47f304d629a84648a0e2b942513133ff = (
  { __typename?: 'TeamMembersParentPage_47f304d629a84648a0e2b942513133ff' }
  & Pick<Types.TeamMembersParentPage_47f304d629a84648a0e2b942513133ff, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089 = (
  { __typename?: 'TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089' }
  & Pick<Types.TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TeamMembersParentPage_b4311697c06c4d58b88dca047c0a72b0 = (
  { __typename?: 'TeamMembersParentPage_b4311697c06c4d58b88dca047c0a72b0' }
  & Pick<Types.TeamMembersParentPage_B4311697c06c4d58b88dca047c0a72b0, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TeamMembersWildcardPage = (
  { __typename?: 'TeamMembersWildcardPage' }
  & Pick<Types.TeamMembersWildcardPage, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e = (
  { __typename?: 'TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e' }
  & Pick<Types.TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450 = (
  { __typename?: 'TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450' }
  & Pick<Types.TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a = (
  { __typename?: 'TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a' }
  & Pick<Types.TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29 = (
  { __typename?: 'TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29' }
  & Pick<Types.TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TeamMembersWildcardPage_ea27a3d835fd49a3a4c797d2a6d52745 = (
  { __typename?: 'TeamMembersWildcardPage_ea27a3d835fd49a3a4c797d2a6d52745' }
  & Pick<Types.TeamMembersWildcardPage_Ea27a3d835fd49a3a4c797d2a6d52745, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TeamProfileCards = (
  { __typename?: 'TeamProfileCards' }
  & Pick<Types.TeamProfileCards, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TeamProfileCardsFolder = (
  { __typename?: 'TeamProfileCardsFolder' }
  & Pick<Types.TeamProfileCardsFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TechzoneArticlePage = (
  { __typename?: 'TechzoneArticlePage' }
  & Pick<Types.TechzoneArticlePage, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Tenant = (
  { __typename?: 'Tenant' }
  & Pick<Types.Tenant, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TenantFolder = (
  { __typename?: 'TenantFolder' }
  & Pick<Types.TenantFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TenantSecurityItemPointer = (
  { __typename?: 'TenantSecurityItemPointer' }
  & Pick<Types.TenantSecurityItemPointer, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TenantSetupRoot = (
  { __typename?: 'TenantSetupRoot' }
  & Pick<Types.TenantSetupRoot, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TertieryHeroBanner = (
  { __typename?: 'TertieryHeroBanner' }
  & Pick<Types.TertieryHeroBanner, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TertieryHeroBannerParametersTemplate = (
  { __typename?: 'TertieryHeroBannerParametersTemplate' }
  & Pick<Types.TertieryHeroBannerParametersTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Text = (
  { __typename?: 'Text' }
  & Pick<Types.Text, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TextBlock = (
  { __typename?: 'TextBlock' }
  & Pick<Types.TextBlock, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TextBlockHeadingParametersTemplate = (
  { __typename?: 'TextBlockHeadingParametersTemplate' }
  & Pick<Types.TextBlockHeadingParametersTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TextBlockHeadingType = (
  { __typename?: 'TextBlockHeadingType' }
  & Pick<Types.TextBlockHeadingType, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TextBlockHeadingTypeFolder = (
  { __typename?: 'TextBlockHeadingTypeFolder' }
  & Pick<Types.TextBlockHeadingTypeFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TextBlockLinkType = (
  { __typename?: 'TextBlockLinkType' }
  & Pick<Types.TextBlockLinkType, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TextBlockLinkTypeFolder = (
  { __typename?: 'TextBlockLinkTypeFolder' }
  & Pick<Types.TextBlockLinkTypeFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TextBlocks = (
  { __typename?: 'TextBlocks' }
  & Pick<Types.TextBlocks, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TextBlocksFolder = (
  { __typename?: 'TextBlocksFolder' }
  & Pick<Types.TextBlocksFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TextBlocksParametersTemplate = (
  { __typename?: 'TextBlocksParametersTemplate' }
  & Pick<Types.TextBlocksParametersTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TextFolder = (
  { __typename?: 'TextFolder' }
  & Pick<Types.TextFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TextFolder_b762d56787f5493cbb480c455d834457 = (
  { __typename?: 'TextFolder_b762d56787f5493cbb480c455d834457' }
  & Pick<Types.TextFolder_B762d56787f5493cbb480c455d834457, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Text_b8f5894cb4934016bf784090b0a2fd16 = (
  { __typename?: 'Text_b8f5894cb4934016bf784090b0a2fd16' }
  & Pick<Types.Text_B8f5894cb4934016bf784090b0a2fd16, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Theme = (
  { __typename?: 'Theme' }
  & Pick<Types.Theme, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ThemeTag = (
  { __typename?: 'ThemeTag' }
  & Pick<Types.ThemeTag, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ThemeTagsFolder = (
  { __typename?: 'ThemeTagsFolder' }
  & Pick<Types.ThemeTagsFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ThemingMode = (
  { __typename?: 'ThemingMode' }
  & Pick<Types.ThemingMode, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ThemingModes = (
  { __typename?: 'ThemingModes' }
  & Pick<Types.ThemingModes, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Tile = (
  { __typename?: 'Tile' }
  & Pick<Types.Tile, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TileLink = (
  { __typename?: 'TileLink' }
  & Pick<Types.TileLink, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TileParametersTemplate = (
  { __typename?: 'TileParametersTemplate' }
  & Pick<Types.TileParametersTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TileSizeOption = (
  { __typename?: 'TileSizeOption' }
  & Pick<Types.TileSizeOption, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TileSizeOptionFolder = (
  { __typename?: 'TileSizeOptionFolder' }
  & Pick<Types.TileSizeOptionFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TilesFolder = (
  { __typename?: 'TilesFolder' }
  & Pick<Types.TilesFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TilesParametersTemplate = (
  { __typename?: 'TilesParametersTemplate' }
  & Pick<Types.TilesParametersTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Title = (
  { __typename?: 'Title' }
  & Pick<Types.Title, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Title_a82e893105754175917de904ef7e6dbe = (
  { __typename?: 'Title_a82e893105754175917de904ef7e6dbe' }
  & Pick<Types.Title_A82e893105754175917de904ef7e6dbe, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Toggle = (
  { __typename?: 'Toggle' }
  & Pick<Types.Toggle, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_ToggleFolder = (
  { __typename?: 'ToggleFolder' }
  & Pick<Types.ToggleFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Toggle_8e4c968e9fa543a89ac4c0baf273ccde = (
  { __typename?: 'Toggle_8e4c968e9fa543a89ac4c0baf273ccde' }
  & Pick<Types.Toggle_8e4c968e9fa543a89ac4c0baf273ccde, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Transformation = (
  { __typename?: 'Transformation' }
  & Pick<Types.Transformation, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TrustArticleHeroParametersTemplate = (
  { __typename?: 'TrustArticleHeroParametersTemplate' }
  & Pick<Types.TrustArticleHeroParametersTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TrustFinder = (
  { __typename?: 'TrustFinder' }
  & Pick<Types.TrustFinder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TrustFinderFilterOption = (
  { __typename?: 'TrustFinderFilterOption' }
  & Pick<Types.TrustFinderFilterOption, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TrustRegion = (
  { __typename?: 'TrustRegion' }
  & Pick<Types.TrustRegion, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TrustType = (
  { __typename?: 'TrustType' }
  & Pick<Types.TrustType, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TrustTypesFolder = (
  { __typename?: 'TrustTypesFolder' }
  & Pick<Types.TrustTypesFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Twitter = (
  { __typename?: 'Twitter' }
  & Pick<Types.Twitter, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TwitterApp = (
  { __typename?: 'TwitterApp' }
  & Pick<Types.TwitterApp, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TwitterApps = (
  { __typename?: 'TwitterApps' }
  & Pick<Types.TwitterApps, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TwitterFolder = (
  { __typename?: 'TwitterFolder' }
  & Pick<Types.TwitterFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TwitterParametersTemplate = (
  { __typename?: 'TwitterParametersTemplate' }
  & Pick<Types.TwitterParametersTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_TwitterSettings = (
  { __typename?: 'TwitterSettings' }
  & Pick<Types.TwitterSettings, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_UnknownItem = (
  { __typename?: 'UnknownItem' }
  & Pick<Types.UnknownItem, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_UnminifiedFile = (
  { __typename?: 'UnminifiedFile' }
  & Pick<Types.UnminifiedFile, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_UpgradeScript = (
  { __typename?: 'UpgradeScript' }
  & Pick<Types.UpgradeScript, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_UpgradeScriptLibrary = (
  { __typename?: 'UpgradeScriptLibrary' }
  & Pick<Types.UpgradeScriptLibrary, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_VariantComponentField = (
  { __typename?: 'VariantComponentField' }
  & Pick<Types.VariantComponentField, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_VariantDateField = (
  { __typename?: 'VariantDateField' }
  & Pick<Types.VariantDateField, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55 = (
  { __typename?: 'VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55' }
  & Pick<Types.VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_VariantPlaceholder = (
  { __typename?: 'VariantPlaceholder' }
  & Pick<Types.VariantPlaceholder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_VariantReference = (
  { __typename?: 'VariantReference' }
  & Pick<Types.VariantReference, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_VariantSection = (
  { __typename?: 'VariantSection' }
  & Pick<Types.VariantSection, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_VariantTemplate = (
  { __typename?: 'VariantTemplate' }
  & Pick<Types.VariantTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_VariantText = (
  { __typename?: 'VariantText' }
  & Pick<Types.VariantText, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_VariantToken = (
  { __typename?: 'VariantToken' }
  & Pick<Types.VariantToken, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Variants = (
  { __typename?: 'Variants' }
  & Pick<Types.Variants, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_VectorFolder = (
  { __typename?: 'VectorFolder' }
  & Pick<Types.VectorFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_VectorTile = (
  { __typename?: 'VectorTile' }
  & Pick<Types.VectorTile, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_VectorTileLink = (
  { __typename?: 'VectorTileLink' }
  & Pick<Types.VectorTileLink, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_VectorTilesFolder = (
  { __typename?: 'VectorTilesFolder' }
  & Pick<Types.VectorTilesFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_VectorTilesParametersTemplate = (
  { __typename?: 'VectorTilesParametersTemplate' }
  & Pick<Types.VectorTilesParametersTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Version_95ebc23204774dc38ad3465d5fe8da2f = (
  { __typename?: 'Version_95ebc23204774dc38ad3465d5fe8da2f' }
  & Pick<Types.Version_95ebc23204774dc38ad3465d5fe8da2f, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Video = (
  { __typename?: 'Video' }
  & Pick<Types.Video, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_VideoCountOption = (
  { __typename?: 'VideoCountOption' }
  & Pick<Types.VideoCountOption, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_VideoCountOptions = (
  { __typename?: 'VideoCountOptions' }
  & Pick<Types.VideoCountOptions, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_VideoFolder = (
  { __typename?: 'VideoFolder' }
  & Pick<Types.VideoFolder, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_VideoFolder_bba49474673e468186ba8b1a20e067a9 = (
  { __typename?: 'VideoFolder_bba49474673e468186ba8b1a20e067a9' }
  & Pick<Types.VideoFolder_Bba49474673e468186ba8b1a20e067a9, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_VideoPage = (
  { __typename?: 'VideoPage' }
  & Pick<Types.VideoPage, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_VideoParameters = (
  { __typename?: 'VideoParameters' }
  & Pick<Types.VideoParameters, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_VideoParametersTemplate = (
  { __typename?: 'VideoParametersTemplate' }
  & Pick<Types.VideoParametersTemplate, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_VideoPressReleasePage = (
  { __typename?: 'VideoPressReleasePage' }
  & Pick<Types.VideoPressReleasePage, 'id'>
  & { pressReleaseTitle: Types.Maybe<PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseTitle_TextField>, pressReleaseDescription: Types.Maybe<PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseDescription_TextField>, pressReleasePlatform: Types.Maybe<PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePlatform_LookupField>, pressReleaseContentType: Types.Maybe<PressReleaseDataQuery_item_C___BasePressRelease_pressReleaseContentType_LookupField>, pressReleasePublicationDate: Types.Maybe<PressReleaseDataQuery_item_C___BasePressRelease_pressReleasePublicationDate_DateField>, template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item_Video_4bc649610a894242be2dc5026090cf49 = (
  { __typename?: 'Video_4bc649610a894242be2dc5026090cf49' }
  & Pick<Types.Video_4bc649610a894242be2dc5026090cf49, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item__AssetsOptimization = (
  { __typename?: '_AssetsOptimization' }
  & Pick<Types._AssetsOptimization, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item__BackgroundImage = (
  { __typename?: '_BackgroundImage' }
  & Pick<Types._BackgroundImage, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item__CompatibleThemes = (
  { __typename?: '_CompatibleThemes' }
  & Pick<Types._CompatibleThemes, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item__CompositeTheme = (
  { __typename?: '_CompositeTheme' }
  & Pick<Types._CompositeTheme, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item__CustomMetadata = (
  { __typename?: '_CustomMetadata' }
  & Pick<Types._CustomMetadata, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item__CustomRenderingViewPath = (
  { __typename?: '_CustomRenderingViewPath' }
  & Pick<Types._CustomRenderingViewPath, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item__DatasourceBehaviour = (
  { __typename?: '_DatasourceBehaviour' }
  & Pick<Types._DatasourceBehaviour, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item__Favicon = (
  { __typename?: '_Favicon' }
  & Pick<Types._Favicon, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item__FormsFolderLocation = (
  { __typename?: '_FormsFolderLocation' }
  & Pick<Types._FormsFolderLocation, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item__FundSettings = (
  { __typename?: '_FundSettings' }
  & Pick<Types._FundSettings, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item__HasValidUrlName = (
  { __typename?: '_HasValidUrlName' }
  & Pick<Types._HasValidUrlName, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item__LocalDataLink = (
  { __typename?: '_LocalDataLink' }
  & Pick<Types._LocalDataLink, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item__Login = (
  { __typename?: '_Login' }
  & Pick<Types._Login, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item__OpenGraphMetadata = (
  { __typename?: '_OpenGraphMetadata' }
  & Pick<Types._OpenGraphMetadata, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item__PageDesignTheme = (
  { __typename?: '_PageDesignTheme' }
  & Pick<Types._PageDesignTheme, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item__PageSearchScope = (
  { __typename?: '_PageSearchScope' }
  & Pick<Types._PageSearchScope, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item__SearchCriteria = (
  { __typename?: '_SearchCriteria' }
  & Pick<Types._SearchCriteria, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item__SearchableWithoutRelatedItems = (
  { __typename?: '_SearchableWithoutRelatedItems' }
  & Pick<Types._SearchableWithoutRelatedItems, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item__SeoMetadata = (
  { __typename?: '_SeoMetadata' }
  & Pick<Types._SeoMetadata, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item__SiteTheme = (
  { __typename?: '_SiteTheme' }
  & Pick<Types._SiteTheme, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item__SitemapSettings = (
  { __typename?: '_SitemapSettings' }
  & Pick<Types._SitemapSettings, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item__StickyNote = (
  { __typename?: '_StickyNote' }
  & Pick<Types._StickyNote, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item__Styleable = (
  { __typename?: '_Styleable' }
  & Pick<Types._Styleable, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item__TwitterMetadata = (
  { __typename?: '_TwitterMetadata' }
  & Pick<Types._TwitterMetadata, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item__Webinar = (
  { __typename?: '_Webinar' }
  & Pick<Types._Webinar, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item__WildcardSource = (
  { __typename?: '_WildcardSource' }
  & Pick<Types._WildcardSource, 'id'>
  & { template: PressReleaseDataQuery_item_Accordion_template_ItemTemplate }
);

export type PressReleaseDataQuery_item = PressReleaseDataQuery_item_Accordion | PressReleaseDataQuery_item_AccordionFolder | PressReleaseDataQuery_item_AccordionFolder_03f88fb497884025b46f2cb249f4fcd6 | PressReleaseDataQuery_item_AccordionItem | PressReleaseDataQuery_item_AccordionItem_8cf671721b2d489e809f4c23db5ab2da | PressReleaseDataQuery_item_AccordionParametersTemplate | PressReleaseDataQuery_item_AccordionPresentation | PressReleaseDataQuery_item_AccordionPresentationFolder | PressReleaseDataQuery_item_Accordion_02d060598cc14423a9ac9ff2365176b7 | PressReleaseDataQuery_item_Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1 | PressReleaseDataQuery_item_AddItem | PressReleaseDataQuery_item_AddItem_1e1b739ec3784909941d171aca7362e5 | PressReleaseDataQuery_item_AddItem_3aea335cd06d45b1841acbc8d2d1ce40 | PressReleaseDataQuery_item_AddItem_de8c75222f3241288f20342f479894eb | PressReleaseDataQuery_item_AddItem_ea8a3f269ccd443a95f571b868a94bd0 | PressReleaseDataQuery_item_AddThisParameters | PressReleaseDataQuery_item_AggregatedFacetFilter | PressReleaseDataQuery_item_AlertMessage | PressReleaseDataQuery_item_AlertMessageFolder | PressReleaseDataQuery_item_AlertMessageParametersTemplate | PressReleaseDataQuery_item_AlertMessageType | PressReleaseDataQuery_item_AllertMessageTypeFolder | PressReleaseDataQuery_item_Archive | PressReleaseDataQuery_item_ArticleAuthor | PressReleaseDataQuery_item_ArticleAuthorsFolder | PressReleaseDataQuery_item_ArticleCategoriesFolder | PressReleaseDataQuery_item_ArticleCategory | PressReleaseDataQuery_item_ArticleChapter | PressReleaseDataQuery_item_ArticleChapters | PressReleaseDataQuery_item_ArticleContentType | PressReleaseDataQuery_item_ArticleContentTypesFolder | PressReleaseDataQuery_item_ArticleFilter | PressReleaseDataQuery_item_ArticleFilterOption | PressReleaseDataQuery_item_ArticleFootnote | PressReleaseDataQuery_item_ArticleFootnoteLink | PressReleaseDataQuery_item_ArticleFootnoteText | PressReleaseDataQuery_item_ArticleInfogramTile | PressReleaseDataQuery_item_ArticleInfogramTileParametersTemplate | PressReleaseDataQuery_item_ArticlePage | PressReleaseDataQuery_item_ArticleRegion | PressReleaseDataQuery_item_ArticleRegionsFolder | PressReleaseDataQuery_item_ArticleSearchPage | PressReleaseDataQuery_item_ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c | PressReleaseDataQuery_item_ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2 | PressReleaseDataQuery_item_ArticleSearchPage_be414ff574ac4203abb2694811443e25 | PressReleaseDataQuery_item_ArticleSearchPage_c7ad44ac3cab45158b619465a552a82c | PressReleaseDataQuery_item_ArticleSearchPage_cf31bd740a4b4363b03d1f7a88e39907 | PressReleaseDataQuery_item_ArticleSeriesCollection | PressReleaseDataQuery_item_ArticleSeriesFolder | PressReleaseDataQuery_item_ArticleSettings | PressReleaseDataQuery_item_ArticleSubscriptionBanner | PressReleaseDataQuery_item_ArticleSubscriptionBannerFolder | PressReleaseDataQuery_item_ArticleTag | PressReleaseDataQuery_item_ArticleTagsFolder | PressReleaseDataQuery_item_ArticleTeamAuthor | PressReleaseDataQuery_item_ArticleTileParametersTemplate | PressReleaseDataQuery_item_ArticleTilesParametersTemplate | PressReleaseDataQuery_item_ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f | PressReleaseDataQuery_item_ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8 | PressReleaseDataQuery_item_ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca | PressReleaseDataQuery_item_ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c | PressReleaseDataQuery_item_ArticleWildcardPage_405b20252077400383d3b47f09f88b47 | PressReleaseDataQuery_item_ArticleWildcardPage_b037a577f5cb4ad3b79f07720a96985b | PressReleaseDataQuery_item_ArticlesGroupFolder | PressReleaseDataQuery_item_AttachThemeExtension | PressReleaseDataQuery_item_AutomaticDocumentListings | PressReleaseDataQuery_item_AutomaticDocumentListingsFolder | PressReleaseDataQuery_item_AvailableJSONRenderings | PressReleaseDataQuery_item_AvailableMetaRenderings | PressReleaseDataQuery_item_AvailableRenderings | PressReleaseDataQuery_item_AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb | PressReleaseDataQuery_item_AwardsBanner | PressReleaseDataQuery_item_AwardsBannerFolder | PressReleaseDataQuery_item_AwardsBannerImage | PressReleaseDataQuery_item_AwardsBannerParametersTemplate | PressReleaseDataQuery_item_BYOCWrapperRenderingParameters | PressReleaseDataQuery_item_BackgroundColorOption | PressReleaseDataQuery_item_BackgroundColorOptionFolder | PressReleaseDataQuery_item_BannerFolder | PressReleaseDataQuery_item_BannerType | PressReleaseDataQuery_item_BannerTypeFolder | PressReleaseDataQuery_item_BaseHeading | PressReleaseDataQuery_item_BaseHeadingFolder | PressReleaseDataQuery_item_BoolFacet | PressReleaseDataQuery_item_BranchesFolder | PressReleaseDataQuery_item_Breadcrumb | PressReleaseDataQuery_item_BrowserTitleDefinition | PressReleaseDataQuery_item_CORSEntry | PressReleaseDataQuery_item_CORSGrouping | PressReleaseDataQuery_item_CTAPresentationType | PressReleaseDataQuery_item_CTAPresentationTypeFolder | PressReleaseDataQuery_item_C__AbrdnPage | PressReleaseDataQuery_item_C__ActionBase | PressReleaseDataQuery_item_C__AdvancedParameter | PressReleaseDataQuery_item_C__App | PressReleaseDataQuery_item_C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c | PressReleaseDataQuery_item_C__ArticleWildcardPage | PressReleaseDataQuery_item_C__AvailableRenderingsFolder | PressReleaseDataQuery_item_C__BYOCRenderingParameters | PressReleaseDataQuery_item_C__BackgroundParametersTemplate | PressReleaseDataQuery_item_C__BaseCTA | PressReleaseDataQuery_item_C__BasePage | PressReleaseDataQuery_item_C__BasePage_037da552a5524fe4aeee331f57ac1378 | PressReleaseDataQuery_item_C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f | PressReleaseDataQuery_item_C__BasePage_315fd21bebf04c9d9f00bae191442f1d | PressReleaseDataQuery_item_C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd | PressReleaseDataQuery_item_C__BasePage_728c97b5c56146d9807e21018a972bb5 | PressReleaseDataQuery_item_C__BasePage_6105875085f346729dfc8d133b481f26 | PressReleaseDataQuery_item_C__BasePage_b08130ebd3314a3b9c0f2b5e9b66387b | PressReleaseDataQuery_item_C__BaseRenderingParameters | PressReleaseDataQuery_item_C__BaseTheme | PressReleaseDataQuery_item_C__BaseVariantField | PressReleaseDataQuery_item_C__Class | PressReleaseDataQuery_item_C__CompositeGroup | PressReleaseDataQuery_item_C__CompositeSection | PressReleaseDataQuery_item_C__EloquaForm | PressReleaseDataQuery_item_C__ErrorPage_d40dd5cadbf1461191b8f9e1071e557d | PressReleaseDataQuery_item_C__ExtendedOptions | PressReleaseDataQuery_item_C__ExtendedOptions_2964fb4257a6440fb192218443904c90 | PressReleaseDataQuery_item_C__ExtendedOptions_f1850030f97848b4bdb5884b7e863160 | PressReleaseDataQuery_item_C__FEaaSRenderingParameters | PressReleaseDataQuery_item_C__FacetSelectorConfigBase | PressReleaseDataQuery_item_C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845 | PressReleaseDataQuery_item_C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b | PressReleaseDataQuery_item_C__FundDetailsWildcardPage_fb127f7aeeba46458c5fbe9f7c589303 | PressReleaseDataQuery_item_C__FundSearchPage_d83da2a5ce9042b6bd557aa8820c62c5 | PressReleaseDataQuery_item_C__FundShareclassDetailsWildcardPage_e3590ad764a84980a419c4f1f926f9fc | PressReleaseDataQuery_item_C__GlobalDatasourceBehavior | PressReleaseDataQuery_item_C__GridDefinition | PressReleaseDataQuery_item_C__GridItemBase | PressReleaseDataQuery_item_C__GridParameters | PressReleaseDataQuery_item_C__HeadlessSite | PressReleaseDataQuery_item_C__HeadlessTenant | PressReleaseDataQuery_item_C__HelpArticleSearchPage_d1c4d91365c8401389dcde7b5fb2f28b | PressReleaseDataQuery_item_C__HelpArticleWildcardPage_c0a939305f6e47a38739f2a8f300e65d | PressReleaseDataQuery_item_C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d | PressReleaseDataQuery_item_C__IAllowEmpty | PressReleaseDataQuery_item_C__IBaseVariantDefinition | PressReleaseDataQuery_item_C__IBoosting | PressReleaseDataQuery_item_C__ICacheable | PressReleaseDataQuery_item_C__ICompatibleRenderings | PressReleaseDataQuery_item_C__IComponentVariant | PressReleaseDataQuery_item_C__IControlType | PressReleaseDataQuery_item_C__IDynamicPlaceholder | PressReleaseDataQuery_item_C__IFEaaSComponentsDataSourceTemplates | PressReleaseDataQuery_item_C__IFEaaSComponentsEditorScriptURL | PressReleaseDataQuery_item_C__IIcon | PressReleaseDataQuery_item_C__ILocation | PressReleaseDataQuery_item_C__IPaginable | PressReleaseDataQuery_item_C__IPagination | PressReleaseDataQuery_item_C__IPoi | PressReleaseDataQuery_item_C__IRenderingId | PressReleaseDataQuery_item_C__ISplitter | PressReleaseDataQuery_item_C__IStyling | PressReleaseDataQuery_item_C__IVariantDefinition | PressReleaseDataQuery_item_C__InvestmentTrustPage | PressReleaseDataQuery_item_C__JSONField | PressReleaseDataQuery_item_C__JSONReference | PressReleaseDataQuery_item_C__JSSData | PressReleaseDataQuery_item_C__JSSSettings | PressReleaseDataQuery_item_C__JSSSiteFolder | PressReleaseDataQuery_item_C__JssRootFolder | PressReleaseDataQuery_item_C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086 | PressReleaseDataQuery_item_C__Navigation_e6d98f24d01c419e871a4617125a49ed | PressReleaseDataQuery_item_C__Page | PressReleaseDataQuery_item_C__PageData | PressReleaseDataQuery_item_C__PageDesignFolder | PressReleaseDataQuery_item_C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd | PressReleaseDataQuery_item_C__PageDesigns_daaf41fd96db4892be99f62f16d036c4 | PressReleaseDataQuery_item_C__PartialDesign | PressReleaseDataQuery_item_C__PartialDesignFolder | PressReleaseDataQuery_item_C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d | PressReleaseDataQuery_item_C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d | PressReleaseDataQuery_item_C__PlaceholderWrapper | PressReleaseDataQuery_item_C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac | PressReleaseDataQuery_item_C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b | PressReleaseDataQuery_item_C__RedirectMapGrouping | PressReleaseDataQuery_item_C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973 | PressReleaseDataQuery_item_C__Route | PressReleaseDataQuery_item_C__SimpleVideo | PressReleaseDataQuery_item_C__SiteSettingsFolder | PressReleaseDataQuery_item_C__SitemapSettings | PressReleaseDataQuery_item_C__StandardTemplate | PressReleaseDataQuery_item_C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c | PressReleaseDataQuery_item_C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65 | PressReleaseDataQuery_item_C__TrustFolder | PressReleaseDataQuery_item_C__VariantDefinition | PressReleaseDataQuery_item_C__VariantField | PressReleaseDataQuery_item_C__VariantsGrouping | PressReleaseDataQuery_item_C___AdvancedItem | PressReleaseDataQuery_item_C___Arguments | PressReleaseDataQuery_item_C___Arguments_33fab87cd52f44319a1f589ba7c1e287 | PressReleaseDataQuery_item_C___Article | PressReleaseDataQuery_item_C___ArticlePageWorkflow | PressReleaseDataQuery_item_C___ArticleSearchPage | PressReleaseDataQuery_item_C___ArticleWildcard | PressReleaseDataQuery_item_C___AssetServiceThemeMode | PressReleaseDataQuery_item_C___BaseArticle | PressReleaseDataQuery_item_C___BaseDataFolder | PressReleaseDataQuery_item_C___BaseHelpArticle | PressReleaseDataQuery_item_C___BaseInvestmentTrust | PressReleaseDataQuery_item_C___BaseJSSTenant | PressReleaseDataQuery_item_C___BasePage | PressReleaseDataQuery_item_C___BasePageDesign | PressReleaseDataQuery_item_C___BasePageDesignFolder | PressReleaseDataQuery_item_C___BasePartialDesign | PressReleaseDataQuery_item_C___BasePartialDesignFolder | PressReleaseDataQuery_item_C___BasePlaceholder | PressReleaseDataQuery_item_C___BasePlaceholderSettingsFolder | PressReleaseDataQuery_item_C___BasePresentation | PressReleaseDataQuery_item_C___BasePressRelease | PressReleaseDataQuery_item_C___BaseRenderingParameters | PressReleaseDataQuery_item_C___BaseSXAStandardValuesFolder | PressReleaseDataQuery_item_C___BaseSettings | PressReleaseDataQuery_item_C___BaseSharedSitesSettings | PressReleaseDataQuery_item_C___BaseSiteDefinition | PressReleaseDataQuery_item_C___BaseSiteFolder | PressReleaseDataQuery_item_C___BaseSiteGrouping | PressReleaseDataQuery_item_C___BaseSiteRoot | PressReleaseDataQuery_item_C___BaseTenant | PressReleaseDataQuery_item_C___BaseTenantFolder | PressReleaseDataQuery_item_C___BucketRules | PressReleaseDataQuery_item_C___CORS | PressReleaseDataQuery_item_C___Content | PressReleaseDataQuery_item_C___ContentType | PressReleaseDataQuery_item_C___DataAttributes | PressReleaseDataQuery_item_C___DatasourceWorkflow | PressReleaseDataQuery_item_C___Dependencies | PressReleaseDataQuery_item_C___Description | PressReleaseDataQuery_item_C___DesignTemplateMapping | PressReleaseDataQuery_item_C___Designable | PressReleaseDataQuery_item_C___EditType | PressReleaseDataQuery_item_C___EditType_8a9f84baaa124c5d9096935714809da4 | PressReleaseDataQuery_item_C___EditingTheme | PressReleaseDataQuery_item_C___Enabled | PressReleaseDataQuery_item_C___ErrorHandling | PressReleaseDataQuery_item_C___ExternalArticle | PressReleaseDataQuery_item_C___Fields | PressReleaseDataQuery_item_C___FilteredArticlesParent | PressReleaseDataQuery_item_C___FilteredArticlesWildcard | PressReleaseDataQuery_item_C___Footnotes | PressReleaseDataQuery_item_C___FundDetailsWildcard | PressReleaseDataQuery_item_C___FundFormAvailability | PressReleaseDataQuery_item_C___FundMetadataPage | PressReleaseDataQuery_item_C___FundSearchPage | PressReleaseDataQuery_item_C___FundsFolder | PressReleaseDataQuery_item_C___FundsFormsFolder | PressReleaseDataQuery_item_C___FundsLiteratureFolder | PressReleaseDataQuery_item_C___FundsShareclassesDetailsWildcard | PressReleaseDataQuery_item_C___GridMapping | PressReleaseDataQuery_item_C___HelpArticle | PressReleaseDataQuery_item_C___HelpArticleSearchPage | PressReleaseDataQuery_item_C___HelpArticleWildcard | PressReleaseDataQuery_item_C___HorizonDatasourceGrouping | PressReleaseDataQuery_item_C___Icon | PressReleaseDataQuery_item_C___IncludeByDefault | PressReleaseDataQuery_item_C___IncludeIfInstalled | PressReleaseDataQuery_item_C___InternalArticle | PressReleaseDataQuery_item_C___InternetExplorerCompatibilityMode | PressReleaseDataQuery_item_C___IsSystemModule | PressReleaseDataQuery_item_C___JSONVariantPaging | PressReleaseDataQuery_item_C___JSONVariantsBase | PressReleaseDataQuery_item_C___LimitedDisplay | PressReleaseDataQuery_item_C___LinkAttributes | PressReleaseDataQuery_item_C___LinkSettings | PressReleaseDataQuery_item_C___LiteratureHubSearchPage | PressReleaseDataQuery_item_C___ManualKeyInformation | PressReleaseDataQuery_item_C___MemberOf | PressReleaseDataQuery_item_C___MetadataPage | PressReleaseDataQuery_item_C___Modules | PressReleaseDataQuery_item_C___Name | PressReleaseDataQuery_item_C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d | PressReleaseDataQuery_item_C___Name_299cdb154745448a807868d401248eaa | PressReleaseDataQuery_item_C___Name_b88cf88159a54a19991e71038751cb60 | PressReleaseDataQuery_item_C___Navigable | PressReleaseDataQuery_item_C___NavigablePage | PressReleaseDataQuery_item_C___PageContent | PressReleaseDataQuery_item_C___PageWorkflow | PressReleaseDataQuery_item_C___PerSiteStandardValues | PressReleaseDataQuery_item_C___Podcast | PressReleaseDataQuery_item_C___PodcastPressRelease | PressReleaseDataQuery_item_C___PremiumContentPage | PressReleaseDataQuery_item_C___PressRelease | PressReleaseDataQuery_item_C___PressReleaseContentType | PressReleaseDataQuery_item_C___PressReleaseSearchPage | PressReleaseDataQuery_item_C___PressReleaseWildcard | PressReleaseDataQuery_item_C___ProtectedTheme | PressReleaseDataQuery_item_C___PublishingGroupingTemplate | PressReleaseDataQuery_item_C___RenderingRelatedParameters | PressReleaseDataQuery_item_C___RenderingVariantsBase | PressReleaseDataQuery_item_C___RenderingsList | PressReleaseDataQuery_item_C___RobotsContent | PressReleaseDataQuery_item_C___RoleDomain | PressReleaseDataQuery_item_C___RoleName | PressReleaseDataQuery_item_C___RoleType | PressReleaseDataQuery_item_C___SalesforceCommonValidations | PressReleaseDataQuery_item_C___SalesforceFieldId | PressReleaseDataQuery_item_C___SalesforceFieldTitle | PressReleaseDataQuery_item_C___SalesforceFieldValue | PressReleaseDataQuery_item_C___Script | PressReleaseDataQuery_item_C___SearchSignature | PressReleaseDataQuery_item_C___Searchable | PressReleaseDataQuery_item_C___SecurityItemPointer | PressReleaseDataQuery_item_C___SharedArticles | PressReleaseDataQuery_item_C___SharedContent | PressReleaseDataQuery_item_C___SharedHelpArticles | PressReleaseDataQuery_item_C___SharedPage | PressReleaseDataQuery_item_C___SharedPressReleases | PressReleaseDataQuery_item_C___SharedRoot | PressReleaseDataQuery_item_C___SharedSettings | PressReleaseDataQuery_item_C___SiteContent | PressReleaseDataQuery_item_C___SiteFolder | PressReleaseDataQuery_item_C___SiteMediaLibrary | PressReleaseDataQuery_item_C___SiteSettings | PressReleaseDataQuery_item_C___SiteTemplate | PressReleaseDataQuery_item_C___SitecoreClientSiteManaging | PressReleaseDataQuery_item_C___Sitemap | PressReleaseDataQuery_item_C___SitemapMediaItems | PressReleaseDataQuery_item_C___SlidersRangeSettings | PressReleaseDataQuery_item_C___SolutionTemplateContent | PressReleaseDataQuery_item_C___SolutionTemplateDescription | PressReleaseDataQuery_item_C___SolutionTemplateName | PressReleaseDataQuery_item_C___SortOrder | PressReleaseDataQuery_item_C___StackBreakpoint | PressReleaseDataQuery_item_C___Statistics | PressReleaseDataQuery_item_C___SupportedLanguages | PressReleaseDataQuery_item_C___Taggable | PressReleaseDataQuery_item_C___TeamMembersParentPage | PressReleaseDataQuery_item_C___TeamMembersWildcard | PressReleaseDataQuery_item_C___TechzoneArticle | PressReleaseDataQuery_item_C___Template | PressReleaseDataQuery_item_C___Title | PressReleaseDataQuery_item_C___Type | PressReleaseDataQuery_item_C___Validation | PressReleaseDataQuery_item_C___VariantPaging | PressReleaseDataQuery_item_C___VectorTile | PressReleaseDataQuery_item_C___VectorTileLink | PressReleaseDataQuery_item_C___Video | PressReleaseDataQuery_item_C___VideoPressRelease | PressReleaseDataQuery_item_C___Width | PressReleaseDataQuery_item_C___WildcardPage | PressReleaseDataQuery_item_CacheSetting | PressReleaseDataQuery_item_Caching_26fce9bf0256458d8281a713a5bf5520 | PressReleaseDataQuery_item_CalendarEvent | PressReleaseDataQuery_item_CallOutSection | PressReleaseDataQuery_item_CallOutSectionDropdownOption | PressReleaseDataQuery_item_CallOutSectionFolder | PressReleaseDataQuery_item_CallOutSectionParametersTemplate | PressReleaseDataQuery_item_CallToAction | PressReleaseDataQuery_item_CallToActionFolder | PressReleaseDataQuery_item_CapabilitiesFolder | PressReleaseDataQuery_item_Capability | PressReleaseDataQuery_item_CapabilityMap | PressReleaseDataQuery_item_CapabilityMappings | PressReleaseDataQuery_item_Carousel | PressReleaseDataQuery_item_CarouselFolder | PressReleaseDataQuery_item_CarouselSlide | PressReleaseDataQuery_item_Carousel_2b65f0d87ec54834b4aa1753c0f7036b | PressReleaseDataQuery_item_Checkbox | PressReleaseDataQuery_item_ChecklistFilter | PressReleaseDataQuery_item_ChecklistFilterFolder | PressReleaseDataQuery_item_ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee | PressReleaseDataQuery_item_ColumnSplitter | PressReleaseDataQuery_item_ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0 | PressReleaseDataQuery_item_CompatibilityMode | PressReleaseDataQuery_item_ComponentConfiguration | PressReleaseDataQuery_item_ComponentThemeConfiguration | PressReleaseDataQuery_item_ComponentThemesConfiguration | PressReleaseDataQuery_item_ComponentsConfigurations | PressReleaseDataQuery_item_ConfigurationFolder | PressReleaseDataQuery_item_Container | PressReleaseDataQuery_item_ContainerOption | PressReleaseDataQuery_item_ContainerOptionsFolder | PressReleaseDataQuery_item_ContainerParametersTemplate | PressReleaseDataQuery_item_Container_45130bdbbae34edcaea87b68b9d94c7f | PressReleaseDataQuery_item_ContentBlock | PressReleaseDataQuery_item_ContentBlockFolder | PressReleaseDataQuery_item_ContentToken | PressReleaseDataQuery_item_ContentTokenFolder | PressReleaseDataQuery_item_ContentType | PressReleaseDataQuery_item_CorporateTheme | PressReleaseDataQuery_item_CorporateThemesFolder | PressReleaseDataQuery_item_Country | PressReleaseDataQuery_item_CountryISOCode | PressReleaseDataQuery_item_CountryISOCodesFolder | PressReleaseDataQuery_item_CustomerReviewFolder | PressReleaseDataQuery_item_CustomerReviewTile | PressReleaseDataQuery_item_CustomerReviewTileParametersTemplate | PressReleaseDataQuery_item_DataBridgeDocumentCategoryMap | PressReleaseDataQuery_item_DataBridgeFund | PressReleaseDataQuery_item_DataBridgeFundRangeName | PressReleaseDataQuery_item_DataBridgeSettingsFolder | PressReleaseDataQuery_item_DataBridgeShareClass | PressReleaseDataQuery_item_DataFolder | PressReleaseDataQuery_item_DatasourceConfiguration | PressReleaseDataQuery_item_DatasourceConfigurations | PressReleaseDataQuery_item_DatasourceWorkflowAction | PressReleaseDataQuery_item_DateFacet | PressReleaseDataQuery_item_DateFilter | PressReleaseDataQuery_item_DateFilterFolder | PressReleaseDataQuery_item_DateFilter_ad89c1f1e99148ef865938ab13aa28f1 | PressReleaseDataQuery_item_DefaultColumnLayout | PressReleaseDataQuery_item_DefaultShareclassMapping | PressReleaseDataQuery_item_DefaultShareclassMappings | PressReleaseDataQuery_item_DescriptiveHighlight | PressReleaseDataQuery_item_DescriptiveHighlightFolder | PressReleaseDataQuery_item_DescriptiveHighlightItem | PressReleaseDataQuery_item_DescriptiveHighlightParametersTemplate | PressReleaseDataQuery_item_Device | PressReleaseDataQuery_item_Device_7c27ec70f42e40428a0fabaa2f8eda18 | PressReleaseDataQuery_item_Devices | PressReleaseDataQuery_item_DictionaryFolder | PressReleaseDataQuery_item_DisqusParameters | PressReleaseDataQuery_item_DistanceFacet | PressReleaseDataQuery_item_Divider | PressReleaseDataQuery_item_DocumentItem | PressReleaseDataQuery_item_DocumentListings | PressReleaseDataQuery_item_DocumentListingsFolder | PressReleaseDataQuery_item_DocumentTypeFolder | PressReleaseDataQuery_item_DominantLanguageMapping | PressReleaseDataQuery_item_Dropdown | PressReleaseDataQuery_item_DropdownFilter | PressReleaseDataQuery_item_DropdownFilterFolder | PressReleaseDataQuery_item_DropdownFilter_790c0f2c16214604a6c672b9f8ae830d | PressReleaseDataQuery_item_EditEditingTheme | PressReleaseDataQuery_item_EditFrame | PressReleaseDataQuery_item_EditModePanel | PressReleaseDataQuery_item_EditSiteItem | PressReleaseDataQuery_item_EditSiteItem_f040db0387fe4e10ae4053c63175e31b | PressReleaseDataQuery_item_EditSiteTheme | PressReleaseDataQuery_item_EditTenantTemplate | PressReleaseDataQuery_item_EditTenantTemplate_a7d9fcbcc8944274935f9b9659c000d3 | PressReleaseDataQuery_item_EditType | PressReleaseDataQuery_item_EloquaFormFolder | PressReleaseDataQuery_item_EloquaFundForm | PressReleaseDataQuery_item_Enum | PressReleaseDataQuery_item_Enums | PressReleaseDataQuery_item_ErrorPage | PressReleaseDataQuery_item_ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171 | PressReleaseDataQuery_item_ErrorPage_4dbccce416d1491f94198496e3f77c6d | PressReleaseDataQuery_item_ErrorPage_45d797cc048740ffb693214883ff35c2 | PressReleaseDataQuery_item_ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9 | PressReleaseDataQuery_item_ErrorPage_a7dfa49761224679bf9949fffacd5fa1 | PressReleaseDataQuery_item_EventCalendarParameters | PressReleaseDataQuery_item_EventList | PressReleaseDataQuery_item_EventListParameters | PressReleaseDataQuery_item_EventTypes | PressReleaseDataQuery_item_EventsFolder | PressReleaseDataQuery_item_ExecuteScript | PressReleaseDataQuery_item_ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f | PressReleaseDataQuery_item_ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a | PressReleaseDataQuery_item_ExecuteScript_b06460c28b7b47a59e2cf966f689b6ca | PressReleaseDataQuery_item_ExecuteScript_bc9bb68436df4285888bd8b4d87b10de | PressReleaseDataQuery_item_ExecuteScript_e14c08721a97459eafef0acaaaf1ffbb | PressReleaseDataQuery_item_ExtendSiteTheme | PressReleaseDataQuery_item_ExternalLiterature | PressReleaseDataQuery_item_FEaaSWrapperRenderingParameters | PressReleaseDataQuery_item_FacebookCommentsParametersTemplate | PressReleaseDataQuery_item_FacetSlider | PressReleaseDataQuery_item_FacetSliderFolder | PressReleaseDataQuery_item_FacetSlider_995ce2c7319f478b84fe22053ac85bb7 | PressReleaseDataQuery_item_FacetSummary | PressReleaseDataQuery_item_FacetSummaryFolder | PressReleaseDataQuery_item_FacetSummary_cd5c935c1f604d899a6b88ce28305cf2 | PressReleaseDataQuery_item_FacetsGrouping | PressReleaseDataQuery_item_FakeNavigationItem | PressReleaseDataQuery_item_FeatureBanner | PressReleaseDataQuery_item_FeatureBannerParametersTemplate | PressReleaseDataQuery_item_FeaturedArticles | PressReleaseDataQuery_item_FeaturedArticlesFolder | PressReleaseDataQuery_item_FeaturedTheme | PressReleaseDataQuery_item_FeaturedThemesFolder | PressReleaseDataQuery_item_Feed | PressReleaseDataQuery_item_FeedFolder | PressReleaseDataQuery_item_FeedParameters | PressReleaseDataQuery_item_FieldEditor | PressReleaseDataQuery_item_FieldRenderer | PressReleaseDataQuery_item_FileList | PressReleaseDataQuery_item_FileListFolder | PressReleaseDataQuery_item_FileListParametersTemplate | PressReleaseDataQuery_item_File_04129321770849c1801baee196e1c0a8 | PressReleaseDataQuery_item_FilterCriteria | PressReleaseDataQuery_item_FilterCriteriaFolder | PressReleaseDataQuery_item_FilterTaxonomyOption | PressReleaseDataQuery_item_FilterTaxonomyOptions | PressReleaseDataQuery_item_FilteredArticlesParentPage | PressReleaseDataQuery_item_FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d | PressReleaseDataQuery_item_FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941 | PressReleaseDataQuery_item_FilteredArticlesParentPage_a34845039cf1441f8c967a5bbbdd7616 | PressReleaseDataQuery_item_FilteredArticlesParentPage_e4f65f074322485787460a4058d378f9 | PressReleaseDataQuery_item_FilteredArticlesParentPage_f099104e87204d52a6ab75aa44d159ce | PressReleaseDataQuery_item_FilteredArticlesWildcardPage | PressReleaseDataQuery_item_FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e | PressReleaseDataQuery_item_FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835 | PressReleaseDataQuery_item_FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2 | PressReleaseDataQuery_item_FilteredArticlesWildcardPage_ceac9aa72d344797adf00f73f9a55f96 | PressReleaseDataQuery_item_FilteredArticlesWildcardPage_da761c9a4e8f4a91b99040d8f5baa260 | PressReleaseDataQuery_item_Flip | PressReleaseDataQuery_item_FlipFolder | PressReleaseDataQuery_item_Flip_5ef078504c044b839dafefd752cfaba8 | PressReleaseDataQuery_item_Flipside | PressReleaseDataQuery_item_FloatFacet | PressReleaseDataQuery_item_Footer | PressReleaseDataQuery_item_FooterFolder | PressReleaseDataQuery_item_FooterLink | PressReleaseDataQuery_item_FormRenderingParameters | PressReleaseDataQuery_item_FundAssetClass | PressReleaseDataQuery_item_FundAssetClassesFolder | PressReleaseDataQuery_item_FundDetailsWildcardPage | PressReleaseDataQuery_item_FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734 | PressReleaseDataQuery_item_FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f | PressReleaseDataQuery_item_FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b | PressReleaseDataQuery_item_FundFormsFolder | PressReleaseDataQuery_item_FundInFocus | PressReleaseDataQuery_item_FundInFocusShareClass | PressReleaseDataQuery_item_FundSearchPage | PressReleaseDataQuery_item_FundSearchPage_5505b84dba1f47c7b8054749d802d926 | PressReleaseDataQuery_item_FundSearchPage_5806f83c03bc443380678ff955f4310f | PressReleaseDataQuery_item_FundSearchPage_7432205c04214a419ca064c4cb37501c | PressReleaseDataQuery_item_FundSearchPage_edc9df02132e4c0a8435dd60057cbb0a | PressReleaseDataQuery_item_FundSettings | PressReleaseDataQuery_item_FundShareclassDetailsWildcardPage | PressReleaseDataQuery_item_FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c | PressReleaseDataQuery_item_FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3 | PressReleaseDataQuery_item_FundShareclassDetailsWildcardPage_cf3f2635270b49779bb3822ab90f1dcc | PressReleaseDataQuery_item_FundShareclassDetailsWildcardPage_d7e686d9c3bc4ef9974e201972b59eee | PressReleaseDataQuery_item_FundSubAssetClass | PressReleaseDataQuery_item_FundSubAssetClassesFolder | PressReleaseDataQuery_item_FundsExternalLiteratureFolder | PressReleaseDataQuery_item_FundsFolder | PressReleaseDataQuery_item_FundsInFocusFolder | PressReleaseDataQuery_item_FundsInFocusParametersTemplate | PressReleaseDataQuery_item_FundsLiteratureFolder | PressReleaseDataQuery_item_FundsLiteratureMappingsFolder | PressReleaseDataQuery_item_Gallery | PressReleaseDataQuery_item_GalleryFolder | PressReleaseDataQuery_item_GalleryImage | PressReleaseDataQuery_item_GalleryParametersTemplate | PressReleaseDataQuery_item_GalleryVideo | PressReleaseDataQuery_item_GatedAccordionContainer | PressReleaseDataQuery_item_GlobalLanguageSelector | PressReleaseDataQuery_item_GlobalNavigationBar | PressReleaseDataQuery_item_GoogleAnalytics | PressReleaseDataQuery_item_GoogleTagManager | PressReleaseDataQuery_item_GoogleTagManagerFolder | PressReleaseDataQuery_item_GridSetup | PressReleaseDataQuery_item_GridTheme | PressReleaseDataQuery_item_HTMLCode | PressReleaseDataQuery_item_HTMLCodeFolder | PressReleaseDataQuery_item_HTMLInclude | PressReleaseDataQuery_item_HTMLIncludesFolder | PressReleaseDataQuery_item_HTMLSnippet | PressReleaseDataQuery_item_HTMLSnippetFolder | PressReleaseDataQuery_item_HTMLTag | PressReleaseDataQuery_item_Header | PressReleaseDataQuery_item_HeaderFolder | PressReleaseDataQuery_item_Heading | PressReleaseDataQuery_item_HeadlessSiteSetupRoot | PressReleaseDataQuery_item_HeadlessSite_00d050988bad49e5b65db1e08b03ca1b | PressReleaseDataQuery_item_HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1 | PressReleaseDataQuery_item_HeadlessSite_8ca001453c4b4715959d8a05292ecbc5 | PressReleaseDataQuery_item_HeadlessSite_68ffa40c5aab45548f774742b163f318 | PressReleaseDataQuery_item_HeadlessSite_89d464c8c03e4b0287e9a878d95d7149 | PressReleaseDataQuery_item_HeadlessSite_229484893ca144958b9937167dfb5064 | PressReleaseDataQuery_item_HeadlessSite_b28055626acc45a2913a9617398c9730 | PressReleaseDataQuery_item_HeadlessSite_f1cab1661abb450d84d55d938e7699cb | PressReleaseDataQuery_item_HeadlessSite_f3884baa0e1548f59a6d7154a4559604 | PressReleaseDataQuery_item_HeadlessSolutionTemplateFolder | PressReleaseDataQuery_item_HeadlessTenantSetupRoot | PressReleaseDataQuery_item_HeadlessTenant_07248c4700af499eb2a9cb7789f72372 | PressReleaseDataQuery_item_HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8 | PressReleaseDataQuery_item_HeadlessTenant_5d72df6049c74324969205b55767ad7b | PressReleaseDataQuery_item_HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3 | PressReleaseDataQuery_item_HeadlessTenant_77a403a2094e48afafa60943d349d23d | PressReleaseDataQuery_item_HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2 | PressReleaseDataQuery_item_HeadlessTenant_94824ac390d748499e5af0275d10811f | PressReleaseDataQuery_item_HeadlessTenant_4797571864fd40929cf2412c39757ec3 | PressReleaseDataQuery_item_HeadlessTenant_c102fb48f40f49fb9c21f8e3e1b0c107 | PressReleaseDataQuery_item_HeadlessTrustSite | PressReleaseDataQuery_item_HeadlessVariants | PressReleaseDataQuery_item_HeadlessVariantsGrouping | PressReleaseDataQuery_item_HelpArticlePage | PressReleaseDataQuery_item_HelpArticlePlatform | PressReleaseDataQuery_item_HelpArticlePlatformMap | PressReleaseDataQuery_item_HelpArticlePlatformMappings | PressReleaseDataQuery_item_HelpArticlePlatformsFolder | PressReleaseDataQuery_item_HelpArticleSearchPage | PressReleaseDataQuery_item_HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77 | PressReleaseDataQuery_item_HelpArticleTag | PressReleaseDataQuery_item_HelpArticleTagsFolder | PressReleaseDataQuery_item_HelpArticleWildcardPage | PressReleaseDataQuery_item_HelpArticleWildcardPage_e4e2d58c853341deaa6b2a2a136421c4 | PressReleaseDataQuery_item_HelpArticlesGroupFolder | PressReleaseDataQuery_item_HelpTagMap | PressReleaseDataQuery_item_HelpTagMappings | PressReleaseDataQuery_item_HeroBanner | PressReleaseDataQuery_item_Highlight | PressReleaseDataQuery_item_HighlightBlock | PressReleaseDataQuery_item_HighlightBlockFolder | PressReleaseDataQuery_item_HighlightBlockParametersTemplate | PressReleaseDataQuery_item_HighlightFolder | PressReleaseDataQuery_item_HighlightItem | PressReleaseDataQuery_item_HighlightParametersTemplate | PressReleaseDataQuery_item_Home | PressReleaseDataQuery_item_HomePage | PressReleaseDataQuery_item_HomePage_0d3963a8171d4080b5f808618578b631 | PressReleaseDataQuery_item_HomePage_6d95c7d946c74a70be07304cc73a2010 | PressReleaseDataQuery_item_HomePage_b407f259b4e34c7db9a06e8907a56b17 | PressReleaseDataQuery_item_HomePage_cde13c51062d426b95569e8202edc963 | PressReleaseDataQuery_item_HomePage_de9353283a3e41c495ba386aed0540c6 | PressReleaseDataQuery_item_IFrame | PressReleaseDataQuery_item_IFrameFolder | PressReleaseDataQuery_item_IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2 | PressReleaseDataQuery_item_IFrameParametersTemplate | PressReleaseDataQuery_item_IFrame_0da12d476de24dfeb4d0f513489bfea1 | PressReleaseDataQuery_item_IFrame_88a6f65f2b78491bb3770b06e48883e1 | PressReleaseDataQuery_item_Icon | PressReleaseDataQuery_item_IconFolder | PressReleaseDataQuery_item_Image | PressReleaseDataQuery_item_ImageFolder | PressReleaseDataQuery_item_ImageFolder_edc00e86cef24d0cbfa264460becc323 | PressReleaseDataQuery_item_ImageFolder_f7a4527687f14ea5bf25e3c7cb7aa993 | PressReleaseDataQuery_item_ImageParametersTemplate | PressReleaseDataQuery_item_Image_83bc563c6320490092f8204bff81586a | PressReleaseDataQuery_item_Image_15185b0e641844499f934ff03b7ee032 | PressReleaseDataQuery_item_Image_d885df8cb2d64007b34b2bbafb527304 | PressReleaseDataQuery_item_Infographics | PressReleaseDataQuery_item_InfographicsFolder | PressReleaseDataQuery_item_InputValidationStep | PressReleaseDataQuery_item_InputValidationStep_088928cf558e40ec87f3342aa9e66757 | PressReleaseDataQuery_item_InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593 | PressReleaseDataQuery_item_InputValidationStep_d028fef2babf4ad1bbe74d62a977992f | PressReleaseDataQuery_item_IntegerFacet | PressReleaseDataQuery_item_IntroCopy | PressReleaseDataQuery_item_IntroCopyFolder | PressReleaseDataQuery_item_InvestmentTrustAssetClass | PressReleaseDataQuery_item_InvestmentTrustAssetClassFolder | PressReleaseDataQuery_item_InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73 | PressReleaseDataQuery_item_InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb | PressReleaseDataQuery_item_InvestmentTrustRegion | PressReleaseDataQuery_item_InvestmentTrustRegionFolder | PressReleaseDataQuery_item_InvestmentTrustStyle | PressReleaseDataQuery_item_InvestmentTrustStyleFolder | PressReleaseDataQuery_item_InvestorType | PressReleaseDataQuery_item_InvestorTypesFolder | PressReleaseDataQuery_item_ItemQueriesFolder | PressReleaseDataQuery_item_ItemRights | PressReleaseDataQuery_item_JSBeaconSettings | PressReleaseDataQuery_item_JSONCheckbox | PressReleaseDataQuery_item_JSONContent | PressReleaseDataQuery_item_JSONDate | PressReleaseDataQuery_item_JSONFile | PressReleaseDataQuery_item_JSONImage | PressReleaseDataQuery_item_JSONLayout | PressReleaseDataQuery_item_JSONList | PressReleaseDataQuery_item_JSONMultilistReference | PressReleaseDataQuery_item_JSONPlaceholder | PressReleaseDataQuery_item_JSONQuery | PressReleaseDataQuery_item_JSONResults | PressReleaseDataQuery_item_JSONRichText | PressReleaseDataQuery_item_JSONScriban | PressReleaseDataQuery_item_JSONSection | PressReleaseDataQuery_item_JSONTemplate | PressReleaseDataQuery_item_JSONText | PressReleaseDataQuery_item_JSONToken | PressReleaseDataQuery_item_JSONVariantDefinition | PressReleaseDataQuery_item_JSONVariants | PressReleaseDataQuery_item_JSSLayout | PressReleaseDataQuery_item_JSSSettings_1a6fb678eca242c09ae77a9e7f72a6d0 | PressReleaseDataQuery_item_JSSSettings_6b328292f8314ab79885d89a054ca10a | PressReleaseDataQuery_item_JSSSettings_457c9d0b61b84adfaf7f82561ed275ff | PressReleaseDataQuery_item_JSSSettings_5045bf85d2ea430b9f41c2e348436e5d | PressReleaseDataQuery_item_JSSSettings_a767f80d5ad44bfbb8b750a8da144cb5 | PressReleaseDataQuery_item_JSSSettings_b001fd725bb1476496825a8cb9e995cd | PressReleaseDataQuery_item_JSSSettings_c643bc8630d14d61a173c7870f5dbbad | PressReleaseDataQuery_item_JSSSettings_ce3dfd340df34b2d8715e54f85dfcce2 | PressReleaseDataQuery_item_JSSSettings_ef855d0ba8b04a8e87851d1298266d90 | PressReleaseDataQuery_item_JSSSiteGrouping | PressReleaseDataQuery_item_JSSTenantFolder | PressReleaseDataQuery_item_JavaScriptRendering | PressReleaseDataQuery_item_JsonRendering | PressReleaseDataQuery_item_JurisdictionStatus | PressReleaseDataQuery_item_JurisdictionsFolder | PressReleaseDataQuery_item_KeyHighlightItem | PressReleaseDataQuery_item_KeyHighlights | PressReleaseDataQuery_item_KeyHighlightsFolder | PressReleaseDataQuery_item_KeyHighlightsParametersTemplate | PressReleaseDataQuery_item_Language | PressReleaseDataQuery_item_LanguageSelector | PressReleaseDataQuery_item_LanguagesFolder | PressReleaseDataQuery_item_LatestPressReleasesParametersTemplate | PressReleaseDataQuery_item_LayoutServiceVariants | PressReleaseDataQuery_item_LimitedDisplayFolder | PressReleaseDataQuery_item_LimitedDisplayOption | PressReleaseDataQuery_item_Link | PressReleaseDataQuery_item_LinkList | PressReleaseDataQuery_item_LinkListFolder | PressReleaseDataQuery_item_LinkListFolder_c237d144647a4afeaa7b1570f3e3f139 | PressReleaseDataQuery_item_LinkList_33c9207e3b0446068ef54ca99a97c776 | PressReleaseDataQuery_item_LinkList_97a593ad273141dc80bfceb5ef6a33b7 | PressReleaseDataQuery_item_LinkList_f7561ffcc0d8477fb53d2703a4060be1 | PressReleaseDataQuery_item_Link_68bd1cb5a7624a969ac6cb16ab5882a3 | PressReleaseDataQuery_item_Link_930f134d56784b35bfd1b77f9d0115f1 | PressReleaseDataQuery_item_Link_e24e0789a05848bfabb6c69c0e60b6b7 | PressReleaseDataQuery_item_LinksFolder | PressReleaseDataQuery_item_List | PressReleaseDataQuery_item_ListFacet | PressReleaseDataQuery_item_ListFolder | PressReleaseDataQuery_item_ListItem | PressReleaseDataQuery_item_ListParametersTemplate | PressReleaseDataQuery_item_ListStyle | PressReleaseDataQuery_item_ListStyleItem | PressReleaseDataQuery_item_ListingHeroBanner | PressReleaseDataQuery_item_ListingHeroParametersTemplate | PressReleaseDataQuery_item_LiteratureAuthorization | PressReleaseDataQuery_item_LiteratureAuthorizationsFolder | PressReleaseDataQuery_item_LiteratureHubSearchPage | PressReleaseDataQuery_item_LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d | PressReleaseDataQuery_item_LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e | PressReleaseDataQuery_item_LiteratureHubSearchPage_d2b2958263564ba8bba5922add46a0ea | PressReleaseDataQuery_item_LoadMore | PressReleaseDataQuery_item_LoadMoreFolder | PressReleaseDataQuery_item_LoadMore_7a3a53e06a0144ff8ba52be46e201fe6 | PressReleaseDataQuery_item_LocationFilter | PressReleaseDataQuery_item_LocationFilterFolder | PressReleaseDataQuery_item_LocationFilter_aaad4aad290744dc90b69e4e83a661ec | PressReleaseDataQuery_item_Log | PressReleaseDataQuery_item_Login | PressReleaseDataQuery_item_Login_abed54dc4f7840ddac562289c9c849d8 | PressReleaseDataQuery_item_LogoTextBlockItem | PressReleaseDataQuery_item_LogoTextBlocks | PressReleaseDataQuery_item_LogoTextBlocksFolder | PressReleaseDataQuery_item_Logout | PressReleaseDataQuery_item_Logout_c2294d8235a6452a94b15eb5e543b602 | PressReleaseDataQuery_item_ManagedRangeFilter | PressReleaseDataQuery_item_ManagedRangeFilterFolder | PressReleaseDataQuery_item_ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91 | PressReleaseDataQuery_item_ManagedRangeItem | PressReleaseDataQuery_item_Map | PressReleaseDataQuery_item_MapParameters | PressReleaseDataQuery_item_MapsFolder | PressReleaseDataQuery_item_MapsProvider | PressReleaseDataQuery_item_MediaBlock | PressReleaseDataQuery_item_MediaBlockFolder | PressReleaseDataQuery_item_MediaBlockParametersTemplate | PressReleaseDataQuery_item_MediaFolder_81150e5837f5443fa3c075e14a9321e7 | PressReleaseDataQuery_item_MediaLinkParameters | PressReleaseDataQuery_item_MediaVirtualFolder | PressReleaseDataQuery_item_MegaNavigation | PressReleaseDataQuery_item_MegaNavigationFolder | PressReleaseDataQuery_item_MetaBranding | PressReleaseDataQuery_item_MetaRenderingParameters | PressReleaseDataQuery_item_MetadataPartialDesign | PressReleaseDataQuery_item_Model | PressReleaseDataQuery_item_ModelIterator | PressReleaseDataQuery_item_MyLocationPOI | PressReleaseDataQuery_item_Navigation | PressReleaseDataQuery_item_NavigationCategory | PressReleaseDataQuery_item_NavigationFilter | PressReleaseDataQuery_item_NavigationFilterFolder | PressReleaseDataQuery_item_NavigationLink | PressReleaseDataQuery_item_NavigationSubcategory | PressReleaseDataQuery_item_Navigation_9ce34bf95c934dff841d8f649c2bd6c8 | PressReleaseDataQuery_item_OneTrustSettings | PressReleaseDataQuery_item_OptimiserConfiguration | PressReleaseDataQuery_item_OptimiserConfigurationSection | PressReleaseDataQuery_item_OptimizedFile | PressReleaseDataQuery_item_OracleCDPSettings | PressReleaseDataQuery_item_OverlayContent | PressReleaseDataQuery_item_OverlayFolderTemplate | PressReleaseDataQuery_item_Ownership | PressReleaseDataQuery_item_OwnershipFolder | PressReleaseDataQuery_item_POI | PressReleaseDataQuery_item_POIFolder | PressReleaseDataQuery_item_POIType | PressReleaseDataQuery_item_POIs | PressReleaseDataQuery_item_PageBranchesFolder | PressReleaseDataQuery_item_PageContent | PressReleaseDataQuery_item_PageContentFolder | PressReleaseDataQuery_item_PageContent_ef87e73bc7ff49a2ac599b0be83755c3 | PressReleaseDataQuery_item_PageDesign | PressReleaseDataQuery_item_PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0 | PressReleaseDataQuery_item_PageDesignFolder_27d4f8be63b045769a4ef3163c935b47 | PressReleaseDataQuery_item_PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8 | PressReleaseDataQuery_item_PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b | PressReleaseDataQuery_item_PageDesignFolder_720d01f11e5046fa9c4a697f9321f662 | PressReleaseDataQuery_item_PageDesignFolder_771a0de7e83f44338c5d78727ead93bc | PressReleaseDataQuery_item_PageDesignFolder_14161ec204984aa7a2a46decadf669f5 | PressReleaseDataQuery_item_PageDesignFolder_c691c2c4e0dd4fedb84a3c29de7002cb | PressReleaseDataQuery_item_PageDesignFolder_d84605f786ea482da6ff683f6572821c | PressReleaseDataQuery_item_PageDesign_1105b8f81e00426bbf1fc840742d827b | PressReleaseDataQuery_item_PageDesigns | PressReleaseDataQuery_item_PageDesigns_3af52e70e982424b9c85e355542500c9 | PressReleaseDataQuery_item_PageDesigns_9b34083e890b467d8e76b8c3dbbb712d | PressReleaseDataQuery_item_PageDesigns_48d2d50a150c4f6283603a4fed5646e0 | PressReleaseDataQuery_item_PageDesigns_99a71bba507746729c3fb29b04abee23 | PressReleaseDataQuery_item_PageDesigns_a0f265b42d6241968b65d3ede7cb59c3 | PressReleaseDataQuery_item_PageDesigns_abe5ce6a82ff4433b4973bc50f192e11 | PressReleaseDataQuery_item_PageDesigns_b8d9b352c1694b31bd506848b47ca884 | PressReleaseDataQuery_item_PageDesigns_d3b2e1466f744df0900bec314f699ef3 | PressReleaseDataQuery_item_PageDesigns_fd4b9b54f7474f01abdeba569d4b5bbe | PressReleaseDataQuery_item_PageLevelTabs | PressReleaseDataQuery_item_PageLevelTabsFolder | PressReleaseDataQuery_item_PageList | PressReleaseDataQuery_item_PageSelector | PressReleaseDataQuery_item_PageSelectorConfiguration | PressReleaseDataQuery_item_PageSelectorFolder | PressReleaseDataQuery_item_PageSelector_59a7bb775f8c435ab810291abde80e63 | PressReleaseDataQuery_item_PageSize | PressReleaseDataQuery_item_PageSizeFolder | PressReleaseDataQuery_item_PageSize_b682562e0af64b3e9e3b45273bbe152d | PressReleaseDataQuery_item_PageTheme | PressReleaseDataQuery_item_PageThemesFolder | PressReleaseDataQuery_item_Page_4f49a81db3664f198b89cab92f377d7a | PressReleaseDataQuery_item_Page_5e66d86353544fe6a27d3b894984d50f | PressReleaseDataQuery_item_Page_84f342ad2d0646b9aa9a818201145ca2 | PressReleaseDataQuery_item_Page_718df200be51463d93edf4d77ab7a49e | PressReleaseDataQuery_item_Page_b61d5babe46f4ef39f27b57c4ccefdf7 | PressReleaseDataQuery_item_Page_cfd6e04697e24f3cb9eb41b79afc35dc | PressReleaseDataQuery_item_Page_dae7821153e14dbabb0ddf0b53a90aaf | PressReleaseDataQuery_item_Page_fa608b3e6aeb426388a059d89caabada | PressReleaseDataQuery_item_Pagging | PressReleaseDataQuery_item_Pagination | PressReleaseDataQuery_item_PaginationFolder | PressReleaseDataQuery_item_Paragraph | PressReleaseDataQuery_item_PartialDesignFolder_8cf20a4412b746ee801218122c955b2d | PressReleaseDataQuery_item_PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b | PressReleaseDataQuery_item_PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8 | PressReleaseDataQuery_item_PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b | PressReleaseDataQuery_item_PartialDesignFolder_828b5ff144cd4150bcdfe54084165112 | PressReleaseDataQuery_item_PartialDesignFolder_89098e3089aa4062a77346d608caac90 | PressReleaseDataQuery_item_PartialDesignFolder_1695576fb93647d7842ed17730278c32 | PressReleaseDataQuery_item_PartialDesignFolder_f16ae56fb78845639407c88edaffcbcc | PressReleaseDataQuery_item_PartialDesignFolder_fb58558a3ec946d18524cd30805ab21a | PressReleaseDataQuery_item_PartialDesign_fd2059fd60434dfe8c04e2437ce87634 | PressReleaseDataQuery_item_PartialDesigns | PressReleaseDataQuery_item_PartialDesigns_043d3ad0ac4445dba03afc3550d088ec | PressReleaseDataQuery_item_PartialDesigns_0310a4bf20d1441c886a0418c53e30f4 | PressReleaseDataQuery_item_PartialDesigns_36c869ded22040929ce829f6ed643c66 | PressReleaseDataQuery_item_PartialDesigns_1943dc73710a430895515a342c84b037 | PressReleaseDataQuery_item_PartialDesigns_b1e2a6790a1442d8bafa66317b8be117 | PressReleaseDataQuery_item_PartialDesigns_cc6d8635f3e2440ab8ebb93dc1030e9e | PressReleaseDataQuery_item_PartialDesigns_d52704ed3b704a53abb4292105f687ad | PressReleaseDataQuery_item_PartialDesigns_d216303f58d8425688da8cd30d00afab | PressReleaseDataQuery_item_PartialDesigns_facda26791204fa9a0363344348f2c42 | PressReleaseDataQuery_item_PerformanceChartSettings | PressReleaseDataQuery_item_PerformanceChartTimePeriod | PressReleaseDataQuery_item_PerformanceChartTimePeriodFolder | PressReleaseDataQuery_item_PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80 | PressReleaseDataQuery_item_PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d | PressReleaseDataQuery_item_PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba | PressReleaseDataQuery_item_Placeholder_1ca0304be5b64810821154426f1752c2 | PressReleaseDataQuery_item_Placeholder_d2a6884c04d54089a64ed27ca9d68d4c | PressReleaseDataQuery_item_PlainHtmlParametersTemplate | PressReleaseDataQuery_item_Playlist | PressReleaseDataQuery_item_PlaylistFolder | PressReleaseDataQuery_item_PlaylistParametersTemplate | PressReleaseDataQuery_item_Podcast | PressReleaseDataQuery_item_PodcastFolder | PressReleaseDataQuery_item_PodcastPage | PressReleaseDataQuery_item_PodcastPressReleasePage | PressReleaseDataQuery_item_PoiTypes | PressReleaseDataQuery_item_PostDeleteStep | PressReleaseDataQuery_item_PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574 | PressReleaseDataQuery_item_PostDeleteStep_78d6ec9b66e34763987003cf314ee37a | PressReleaseDataQuery_item_PostDeleteStep_b20857895385413883f096f3767cb156 | PressReleaseDataQuery_item_PostSetupStep | PressReleaseDataQuery_item_PostSetupStep_6fac654e22154a419a1d59197bebc0fe | PressReleaseDataQuery_item_PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f | PressReleaseDataQuery_item_PostSetupStep_341738aa44fe490e90ff7010a3c2463b | PressReleaseDataQuery_item_PreDeleteStep | PressReleaseDataQuery_item_PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49 | PressReleaseDataQuery_item_PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b | PressReleaseDataQuery_item_PreDeleteStep_f0daf401190f45468bda8568d08e161d | PressReleaseDataQuery_item_PreDeleteValidationStep | PressReleaseDataQuery_item_PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f | PressReleaseDataQuery_item_PreDeleteValidationStep_edf1fa4206c44703ab1af23495bc6d8f | PressReleaseDataQuery_item_PreDeleteValidationStep_f8c52120d0ea4d009de3b49fe12a3f1e | PressReleaseDataQuery_item_Presentation | PressReleaseDataQuery_item_Presentation_0a70fa7389234a6eabf34134f25f3221 | PressReleaseDataQuery_item_PressReleaseContentType | PressReleaseDataQuery_item_PressReleaseContentTypesFolder | PressReleaseDataQuery_item_PressReleaseFilter | PressReleaseDataQuery_item_PressReleasePage | PressReleaseDataQuery_item_PressReleasePlatform | PressReleaseDataQuery_item_PressReleasePlatformsFolder | PressReleaseDataQuery_item_PressReleaseSearchPage | PressReleaseDataQuery_item_PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f | PressReleaseDataQuery_item_PressReleaseSearchPage_a6c344ca7c6946009de2ca92e27d7b72 | PressReleaseDataQuery_item_PressReleaseSearchPage_b9cd16f585ea4405a1ceda10cb20f64d | PressReleaseDataQuery_item_PressReleaseSearchPage_c97027442df647cf9c36eedfc6787f58 | PressReleaseDataQuery_item_PressReleaseWildcardPage | PressReleaseDataQuery_item_PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e | PressReleaseDataQuery_item_PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79 | PressReleaseDataQuery_item_PressReleaseWildcardPage_b337d30403c642d2b9757e23d08223a1 | PressReleaseDataQuery_item_PressReleaseWildcardPage_e55e9d5bf9614e30b0a2a90327428258 | PressReleaseDataQuery_item_PressReleasesGroupFolder | PressReleaseDataQuery_item_PrivacyWarning | PressReleaseDataQuery_item_ProjectFolder | PressReleaseDataQuery_item_Promo | PressReleaseDataQuery_item_PromoFolder | PressReleaseDataQuery_item_PromoFolder_f07cbe8973ae4de692172570260cac6e | PressReleaseDataQuery_item_Promo_7f21f14d096b4f27bbccf115c6e6f6f1 | PressReleaseDataQuery_item_Promo_881869ca7f5845ea8b34ad1bfd3551a8 | PressReleaseDataQuery_item_Promo_dfed4457d760457abec1c0dccdc44381 | PressReleaseDataQuery_item_PromotedContent | PressReleaseDataQuery_item_PromotedContentFolder | PressReleaseDataQuery_item_PropertyListingCard | PressReleaseDataQuery_item_PropertyListingCards | PressReleaseDataQuery_item_PropertyListingCategory | PressReleaseDataQuery_item_PropertyListingFolder | PressReleaseDataQuery_item_Query_98b413525a4b4067b92418a4b50f0a53 | PressReleaseDataQuery_item_QuickLinks | PressReleaseDataQuery_item_QuickLinksFolder | PressReleaseDataQuery_item_QuickLinksParametersTemplate | PressReleaseDataQuery_item_QuotationBlockItem | PressReleaseDataQuery_item_QuotationBlocks | PressReleaseDataQuery_item_QuotationBlocksFolder | PressReleaseDataQuery_item_QuotationBlocksParametersTemplate | PressReleaseDataQuery_item_Quote | PressReleaseDataQuery_item_QuoteFolder | PressReleaseDataQuery_item_QuoteParametersTemplate | PressReleaseDataQuery_item_RadiusFilter | PressReleaseDataQuery_item_RadiusFilterFolder | PressReleaseDataQuery_item_RadiusFilter_de3fa58eef9d45449f77dcd1dbb05b64 | PressReleaseDataQuery_item_RadiusScheme | PressReleaseDataQuery_item_RadiusSchemeValue | PressReleaseDataQuery_item_RangeSliderFilter | PressReleaseDataQuery_item_RangeSliderFilterFolder | PressReleaseDataQuery_item_RangeSliderFilter_0a1787c296b54d40828522564a5d8e03 | PressReleaseDataQuery_item_RecentArticles | PressReleaseDataQuery_item_Redirect | PressReleaseDataQuery_item_RedirectMap | PressReleaseDataQuery_item_RedirectMaps | PressReleaseDataQuery_item_Region | PressReleaseDataQuery_item_RegionLanguages | PressReleaseDataQuery_item_RegionLanguagesFolder | PressReleaseDataQuery_item_RelatedArticles | PressReleaseDataQuery_item_RelatedArticlesParametersTemplate | PressReleaseDataQuery_item_RenderEngineType | PressReleaseDataQuery_item_RenderingFolder_840d4a46550349ecbf9dbd090946c63d | PressReleaseDataQuery_item_RenderingHost | PressReleaseDataQuery_item_ResizableIFramePage | PressReleaseDataQuery_item_ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067 | PressReleaseDataQuery_item_ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68 | PressReleaseDataQuery_item_ResizableIFramePage_b58eacfb27f5417bb536141f94b92521 | PressReleaseDataQuery_item_ResizableIFramePage_d8d76a2407084147bf3900cd5e12e401 | PressReleaseDataQuery_item_ResizableIFramePage_f460ab055585441892023750e7cef6b7 | PressReleaseDataQuery_item_ResponsiveImage | PressReleaseDataQuery_item_ResultsCount | PressReleaseDataQuery_item_ResultsCountFolder | PressReleaseDataQuery_item_ResultsCount_f3c0661ef9a9444ca26d44bf2a68a186 | PressReleaseDataQuery_item_ResultsVariantSelector | PressReleaseDataQuery_item_RichText | PressReleaseDataQuery_item_RichTextFolder | PressReleaseDataQuery_item_RichText_0f3b73366112418c8bbab0526f3887ce | PressReleaseDataQuery_item_RichText_efcfd8f6596745f48f85b5421928205d | PressReleaseDataQuery_item_RiskImageMapping | PressReleaseDataQuery_item_RiskImageMappings | PressReleaseDataQuery_item_RiskLevelOption | PressReleaseDataQuery_item_RiskLevelOptionFolder | PressReleaseDataQuery_item_RiskWarning | PressReleaseDataQuery_item_RiskWarningFolder | PressReleaseDataQuery_item_RiskWarningParametersTemplate | PressReleaseDataQuery_item_RolePlaceholder | PressReleaseDataQuery_item_RowSplitter | PressReleaseDataQuery_item_RowSplitter_340c887da1d1415b9678c763af74ea97 | PressReleaseDataQuery_item_Rule | PressReleaseDataQuery_item_SDRLogoMapping | PressReleaseDataQuery_item_SDRLogoMappings | PressReleaseDataQuery_item_SDRTypeOption | PressReleaseDataQuery_item_SDRTypeOptionFolder | PressReleaseDataQuery_item_SXAJSSLayout | PressReleaseDataQuery_item_SXARole | PressReleaseDataQuery_item_SXAStandardValuesFolder | PressReleaseDataQuery_item_SalesforceAlertMessage | PressReleaseDataQuery_item_SalesforceCheckBox | PressReleaseDataQuery_item_SalesforceCheckBoxType | PressReleaseDataQuery_item_SalesforceConditionalRadioButton | PressReleaseDataQuery_item_SalesforceConditionalRadioButtons | PressReleaseDataQuery_item_SalesforceDateInput | PressReleaseDataQuery_item_SalesforceDropdown | PressReleaseDataQuery_item_SalesforceDropdownOption | PressReleaseDataQuery_item_SalesforceHiddenField | PressReleaseDataQuery_item_SalesforceInput | PressReleaseDataQuery_item_SalesforceInputType | PressReleaseDataQuery_item_SalesforceIntegratedForm | PressReleaseDataQuery_item_SalesforceIntegratedFormTypesFolder | PressReleaseDataQuery_item_SalesforceRepeatableSubSection | PressReleaseDataQuery_item_SalesforceRichTextArea | PressReleaseDataQuery_item_SalesforceSection | PressReleaseDataQuery_item_SalesforceSortCodeInput | PressReleaseDataQuery_item_SalesforceSubmissionType | PressReleaseDataQuery_item_Scope | PressReleaseDataQuery_item_ScopesFolder | PressReleaseDataQuery_item_Scriban | PressReleaseDataQuery_item_Scripts | PressReleaseDataQuery_item_SearchBox | PressReleaseDataQuery_item_SearchBoxFolder | PressReleaseDataQuery_item_SearchBox_1c04fd611d874590acfe9cc186865ab3 | PressReleaseDataQuery_item_SearchFolder | PressReleaseDataQuery_item_SearchResults | PressReleaseDataQuery_item_SearchResultsFolder | PressReleaseDataQuery_item_SearchResults_a06f7130041d46bb8c2995a2dc00c26a | PressReleaseDataQuery_item_SecondaryHeroBannerParametersTemplate | PressReleaseDataQuery_item_SectionHeading | PressReleaseDataQuery_item_SectionHeadingFolder | PressReleaseDataQuery_item_SectionHeadingParametersTemplate | PressReleaseDataQuery_item_SectionHeadingType | PressReleaseDataQuery_item_SectionHeadingTypeFolder | PressReleaseDataQuery_item_SectionSelector | PressReleaseDataQuery_item_SectionSelectorFolder | PressReleaseDataQuery_item_SectionSelectorTab | PressReleaseDataQuery_item_Security_33077d51ebad4d1cb4a83b79f51dba13 | PressReleaseDataQuery_item_Series | PressReleaseDataQuery_item_SeriesFolder | PressReleaseDataQuery_item_Settings | PressReleaseDataQuery_item_SettingsFolder | PressReleaseDataQuery_item_Settings_6c82caca67dc464195698faad083230e | PressReleaseDataQuery_item_SharePriceSettings | PressReleaseDataQuery_item_SharedArticlesFolder | PressReleaseDataQuery_item_SharedContentFolder | PressReleaseDataQuery_item_SharedFolder | PressReleaseDataQuery_item_SharedHelpArticlesFolder | PressReleaseDataQuery_item_SharedPressReleasesFolder | PressReleaseDataQuery_item_SharedSettingsFolder | PressReleaseDataQuery_item_SharedSitesSettings | PressReleaseDataQuery_item_SharedSitesSettings_c14bf746030f4e598594395f6d299e61 | PressReleaseDataQuery_item_Showcase | PressReleaseDataQuery_item_ShowcaseFolder | PressReleaseDataQuery_item_ShowcaseItem | PressReleaseDataQuery_item_ShowcaseParametersTemplate | PressReleaseDataQuery_item_Site | PressReleaseDataQuery_item_SiteContentFolder | PressReleaseDataQuery_item_SiteDefinition | PressReleaseDataQuery_item_SiteEntryDisclaimer | PressReleaseDataQuery_item_SiteFolder | PressReleaseDataQuery_item_SiteGrouping | PressReleaseDataQuery_item_SiteManagement | PressReleaseDataQuery_item_SiteSecurityItemPointer | PressReleaseDataQuery_item_SiteSelector | PressReleaseDataQuery_item_SiteSelector_a44632f56dcd4d10b4892f4e35e193c3 | PressReleaseDataQuery_item_SiteSetupRoot | PressReleaseDataQuery_item_SiteTheme | PressReleaseDataQuery_item_Site_e46f3af239fa4866a1577017c4b2a40c | PressReleaseDataQuery_item_SitecoreFormWrapperParametersTemplate | PressReleaseDataQuery_item_SitecoreRole | PressReleaseDataQuery_item_SitemapSettings_c71d856635c849b7a84d9d176e9cbd05 | PressReleaseDataQuery_item_SkipLink | PressReleaseDataQuery_item_SkipLinkParameters | PressReleaseDataQuery_item_SkipLinksFolder | PressReleaseDataQuery_item_Snippet | PressReleaseDataQuery_item_SnippetItem | PressReleaseDataQuery_item_SnippetsFolder | PressReleaseDataQuery_item_SocialLoginWrapper | PressReleaseDataQuery_item_SocialMediaButtons | PressReleaseDataQuery_item_SocialMediaFolder | PressReleaseDataQuery_item_SocialMediaShare | PressReleaseDataQuery_item_SocialMediaTemplate | PressReleaseDataQuery_item_SocialNetwork | PressReleaseDataQuery_item_SocialNetworkFolder | PressReleaseDataQuery_item_SocialNetworkLink | PressReleaseDataQuery_item_SolutionTemplate | PressReleaseDataQuery_item_SortResults | PressReleaseDataQuery_item_SortResultsFolder | PressReleaseDataQuery_item_Sorting | PressReleaseDataQuery_item_SortingGroups | PressReleaseDataQuery_item_SpotifyPodcast | PressReleaseDataQuery_item_SpotifyPodcastFolder | PressReleaseDataQuery_item_StickyCTA | PressReleaseDataQuery_item_StickyCTAFolder | PressReleaseDataQuery_item_StickyCTAParametersTemplate | PressReleaseDataQuery_item_StrategiesInFocusFolder | PressReleaseDataQuery_item_StrategyInFocus | PressReleaseDataQuery_item_Style | PressReleaseDataQuery_item_Styles | PressReleaseDataQuery_item_Styles_9c0dac2808aa4b44bc2153363206f6a5 | PressReleaseDataQuery_item_SubscriptionBannerParametersTemplate | PressReleaseDataQuery_item_Tab | PressReleaseDataQuery_item_TabItem | PressReleaseDataQuery_item_TableOfContents | PressReleaseDataQuery_item_TableOfContentsFolder | PressReleaseDataQuery_item_TableOfContentsSection | PressReleaseDataQuery_item_TableOfContentsSubsection | PressReleaseDataQuery_item_Tabs | PressReleaseDataQuery_item_TabsFolder | PressReleaseDataQuery_item_Tabs_f26a9560ccf148c59542800e837caf7a | PressReleaseDataQuery_item_Tag | PressReleaseDataQuery_item_TagCloud | PressReleaseDataQuery_item_TagFolder | PressReleaseDataQuery_item_TagList | PressReleaseDataQuery_item_TeamBiographySettings | PressReleaseDataQuery_item_TeamListingCards | PressReleaseDataQuery_item_TeamListingCardsFolder | PressReleaseDataQuery_item_TeamMember | PressReleaseDataQuery_item_TeamMemberCard | PressReleaseDataQuery_item_TeamMembers | PressReleaseDataQuery_item_TeamMembersParentPage | PressReleaseDataQuery_item_TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e | PressReleaseDataQuery_item_TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e | PressReleaseDataQuery_item_TeamMembersParentPage_47f304d629a84648a0e2b942513133ff | PressReleaseDataQuery_item_TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089 | PressReleaseDataQuery_item_TeamMembersParentPage_b4311697c06c4d58b88dca047c0a72b0 | PressReleaseDataQuery_item_TeamMembersWildcardPage | PressReleaseDataQuery_item_TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e | PressReleaseDataQuery_item_TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450 | PressReleaseDataQuery_item_TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a | PressReleaseDataQuery_item_TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29 | PressReleaseDataQuery_item_TeamMembersWildcardPage_ea27a3d835fd49a3a4c797d2a6d52745 | PressReleaseDataQuery_item_TeamProfileCards | PressReleaseDataQuery_item_TeamProfileCardsFolder | PressReleaseDataQuery_item_TechzoneArticlePage | PressReleaseDataQuery_item_Tenant | PressReleaseDataQuery_item_TenantFolder | PressReleaseDataQuery_item_TenantSecurityItemPointer | PressReleaseDataQuery_item_TenantSetupRoot | PressReleaseDataQuery_item_TertieryHeroBanner | PressReleaseDataQuery_item_TertieryHeroBannerParametersTemplate | PressReleaseDataQuery_item_Text | PressReleaseDataQuery_item_TextBlock | PressReleaseDataQuery_item_TextBlockHeadingParametersTemplate | PressReleaseDataQuery_item_TextBlockHeadingType | PressReleaseDataQuery_item_TextBlockHeadingTypeFolder | PressReleaseDataQuery_item_TextBlockLinkType | PressReleaseDataQuery_item_TextBlockLinkTypeFolder | PressReleaseDataQuery_item_TextBlocks | PressReleaseDataQuery_item_TextBlocksFolder | PressReleaseDataQuery_item_TextBlocksParametersTemplate | PressReleaseDataQuery_item_TextFolder | PressReleaseDataQuery_item_TextFolder_b762d56787f5493cbb480c455d834457 | PressReleaseDataQuery_item_Text_b8f5894cb4934016bf784090b0a2fd16 | PressReleaseDataQuery_item_Theme | PressReleaseDataQuery_item_ThemeTag | PressReleaseDataQuery_item_ThemeTagsFolder | PressReleaseDataQuery_item_ThemingMode | PressReleaseDataQuery_item_ThemingModes | PressReleaseDataQuery_item_Tile | PressReleaseDataQuery_item_TileLink | PressReleaseDataQuery_item_TileParametersTemplate | PressReleaseDataQuery_item_TileSizeOption | PressReleaseDataQuery_item_TileSizeOptionFolder | PressReleaseDataQuery_item_TilesFolder | PressReleaseDataQuery_item_TilesParametersTemplate | PressReleaseDataQuery_item_Title | PressReleaseDataQuery_item_Title_a82e893105754175917de904ef7e6dbe | PressReleaseDataQuery_item_Toggle | PressReleaseDataQuery_item_ToggleFolder | PressReleaseDataQuery_item_Toggle_8e4c968e9fa543a89ac4c0baf273ccde | PressReleaseDataQuery_item_Transformation | PressReleaseDataQuery_item_TrustArticleHeroParametersTemplate | PressReleaseDataQuery_item_TrustFinder | PressReleaseDataQuery_item_TrustFinderFilterOption | PressReleaseDataQuery_item_TrustRegion | PressReleaseDataQuery_item_TrustType | PressReleaseDataQuery_item_TrustTypesFolder | PressReleaseDataQuery_item_Twitter | PressReleaseDataQuery_item_TwitterApp | PressReleaseDataQuery_item_TwitterApps | PressReleaseDataQuery_item_TwitterFolder | PressReleaseDataQuery_item_TwitterParametersTemplate | PressReleaseDataQuery_item_TwitterSettings | PressReleaseDataQuery_item_UnknownItem | PressReleaseDataQuery_item_UnminifiedFile | PressReleaseDataQuery_item_UpgradeScript | PressReleaseDataQuery_item_UpgradeScriptLibrary | PressReleaseDataQuery_item_VariantComponentField | PressReleaseDataQuery_item_VariantDateField | PressReleaseDataQuery_item_VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55 | PressReleaseDataQuery_item_VariantPlaceholder | PressReleaseDataQuery_item_VariantReference | PressReleaseDataQuery_item_VariantSection | PressReleaseDataQuery_item_VariantTemplate | PressReleaseDataQuery_item_VariantText | PressReleaseDataQuery_item_VariantToken | PressReleaseDataQuery_item_Variants | PressReleaseDataQuery_item_VectorFolder | PressReleaseDataQuery_item_VectorTile | PressReleaseDataQuery_item_VectorTileLink | PressReleaseDataQuery_item_VectorTilesFolder | PressReleaseDataQuery_item_VectorTilesParametersTemplate | PressReleaseDataQuery_item_Version_95ebc23204774dc38ad3465d5fe8da2f | PressReleaseDataQuery_item_Video | PressReleaseDataQuery_item_VideoCountOption | PressReleaseDataQuery_item_VideoCountOptions | PressReleaseDataQuery_item_VideoFolder | PressReleaseDataQuery_item_VideoFolder_bba49474673e468186ba8b1a20e067a9 | PressReleaseDataQuery_item_VideoPage | PressReleaseDataQuery_item_VideoParameters | PressReleaseDataQuery_item_VideoParametersTemplate | PressReleaseDataQuery_item_VideoPressReleasePage | PressReleaseDataQuery_item_Video_4bc649610a894242be2dc5026090cf49 | PressReleaseDataQuery_item__AssetsOptimization | PressReleaseDataQuery_item__BackgroundImage | PressReleaseDataQuery_item__CompatibleThemes | PressReleaseDataQuery_item__CompositeTheme | PressReleaseDataQuery_item__CustomMetadata | PressReleaseDataQuery_item__CustomRenderingViewPath | PressReleaseDataQuery_item__DatasourceBehaviour | PressReleaseDataQuery_item__Favicon | PressReleaseDataQuery_item__FormsFolderLocation | PressReleaseDataQuery_item__FundSettings | PressReleaseDataQuery_item__HasValidUrlName | PressReleaseDataQuery_item__LocalDataLink | PressReleaseDataQuery_item__Login | PressReleaseDataQuery_item__OpenGraphMetadata | PressReleaseDataQuery_item__PageDesignTheme | PressReleaseDataQuery_item__PageSearchScope | PressReleaseDataQuery_item__SearchCriteria | PressReleaseDataQuery_item__SearchableWithoutRelatedItems | PressReleaseDataQuery_item__SeoMetadata | PressReleaseDataQuery_item__SiteTheme | PressReleaseDataQuery_item__SitemapSettings | PressReleaseDataQuery_item__StickyNote | PressReleaseDataQuery_item__Styleable | PressReleaseDataQuery_item__TwitterMetadata | PressReleaseDataQuery_item__Webinar | PressReleaseDataQuery_item__WildcardSource;

export type PressReleaseDataQuery_Query = (
  { __typename?: 'Query' }
  & { item: Types.Maybe<PressReleaseDataQuery_item> }
);


export type PressReleaseDataQueryVariables = Types.Exact<{
  path: Types.Scalars['String']['input'];
  language: Types.Scalars['String']['input'];
}>;


export type PressReleaseDataQuery = PressReleaseDataQuery_Query;


export const PressReleaseDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PressReleaseData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"path"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"item"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"Variable","name":{"kind":"Name","value":"path"}}},{"kind":"Argument","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"_BasePressRelease"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pressReleaseTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pressReleaseDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pressReleasePlatform"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"targetItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PressReleasePlatform"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"name_cc07df8136b04eb8bbc9763e31c85261"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pressReleaseContentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"targetItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PressReleaseContentType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"name_4b7a47e34d9849efb2aa96279704f2c2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pressReleasePublicationDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formattedDateValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"StringValue","value":"yyyy-MM-ddTHH:mm:ssZ","block":false}}]},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"_PodcastPressRelease"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"_VideoPressRelease"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"_PressRelease"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Item"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"baseTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PressReleaseDataQuery, PressReleaseDataQueryVariables>;